import React, { useState } from "react";
import ReactTable from 'react-table-v6'
import Moment from 'moment';
import { Component, Fragment } from "react";
import { pdf, Page, Text, View, Document, StyleSheet, PDFViewer, Image, Font } from '@react-pdf/renderer';
import { Table, TableHeader, TableCell, TableBody, DataTableCell } from '@david.kucsai/react-pdf-table';
import html2canvas from "html2canvas";
import { getEmailHTML, getEmailText, getINTLEmailText, getEmailHTMLNewRepair, getEmailHTMLRepairUpdate, getEmailHTMLForTechnician, getEmailHTMLINTLRepairComplete } from "./get-email-html";
import { ToastContainer, toast } from 'react-toastify';
import VideoConverter from 'convert-video'
import 'react-toastify/dist/ReactToastify.css';
//import { fabric } from "fabric";
import * as fabric from "fabric";
import Loader from 'react-loader-spinner'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"

import {
	Card,
	CardBody,
	CardTitle,
	Col,
	Row,
	Progress,
	Input,
	ListGroup,
	ListGroupItem,
	Button,
	ButtonGroup,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
  Form,
  FormGroup,
  Label,
	Collapse,
	Fade
} from 'reactstrap';

import RepairLogModalView from './repair-log-modal-view';

import { findProductByID, findProductByName, resolveProductNameForPayload } from './repair-product-utils';

import update from 'react-addons-update';
import ReactPlayer from 'react-player';
import 'c3/c3.css';
import 'react-table-v6/react-table.css'
import { authenticationService } from '../../../jwt/_services';
import { Lightbox } from 'react-lightbox-pack'; // <--- Importing LightBox Pack
import "react-lightbox-pack/dist/index.css";
import '../../../assets/calculator/css/calculator.css';
//import { Editor } from 'react-draft-wysiwyg';
//import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
//import { Editor } from "@tinymce/tinymce-react";
import videoPlaceholder from '../../../assets/images/video.png';
import pdfPlaceholder from '../../../assets/images/pdf-icon-2.png';
import logo from '../../../assets/images/logo.png';
import signature from '../../../assets/images/signature.png';
import certImage from '../../../assets/images/cert_image.png';
import logoBW from '../../../assets/images/logoBW.png';
import ultradentLogo from '../../../assets/images/UltradentLogo.png';
import repairTravelerImg from '../../../assets/images/RepairTravelerImg.png';
import repairTravelerImg2 from '../../../assets/images/RepairTravelerImg2.png';
import repairTravelerImg3 from '../../../assets/images/RepairTravelerImg3.png';

import repairTravelerImgGemini from '../../../assets/images/g1_traveler.png';
import repairTravelerImgEvo from '../../../assets/images/g2_traveler.png';

import Autocomplete from "react-google-autocomplete";

import TextField from '@material-ui/core/TextField';
import AutoCompleteInput from '@material-ui/lab/Autocomplete';
import { createTheme, ThemeProvider, styled } from '@material-ui/core/styles';
import yellow from '@material-ui/core/colors/yellow';
import grey from '@material-ui/core/colors/grey';

import business from 'moment-business';

//Google: AIzaSyDgx8tS6g3gcG_7GVgQRmN5FziAW-EMRSM
const YOUR_GOOGLE_MAPS_API_KEY = 'AIzaSyAURs2M8E46FUeKemjvViueBAODjIY9-qU';

//Test
//var shippo = require('shippo')('shippo_test_c7fe55fbad00743bd5b12b2f8ffdf373e51764fd');

//Prod
var shippo = require('shippo')('shippo_live_0802c787a1f180d8ed104f6372042b65f5b90340');

Font.register({
  family: 'Open Sans',
  fonts: [
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
    { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 }
  ]
})

const theme = createTheme({
	palette: {
    primary: yellow,
		type: "dark",
  },
});

const autocompleteStyles = (theme) => ({
	listbox: {
		padding: 0,
	},
	option: {
		borderBottom: `1px solid ${theme.palette.system[5]}`,
		// Hover
		'&[data-focus="true"]': {
			backgroundColor: theme.palette.secondSurface.light,
			borderColor: 'transparent',
			color: '#fff',
		},
		// Selected
		'&[aria-selected="true"]': {
			backgroundColor: theme.palette.secondSurface.main,
			borderColor: 'transparent',
			color: '#fff',
		},
	},
	root: {
		'& .MuiAutocomplete-input': {
			color: '#fff',
		},
	}
});

//var countryData = ["United States", "Europe", "Australia"];

var countryData = ['Australia', 'Brazil', 'Colombia', 'France', 'Italy', 'Puerto Rico', 'Thailand', 'Taiwan', 'Afghanistan', 'Åland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Austria', 'Azerbaijan', 'Bangladesh', 'Barbados', 'Bahamas', 'Bahrain', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'British Indian Ocean Territory', 'British Virgin Islands', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burma', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Comoros', 'Congo-Brazzaville', 'Congo-Kinshasa', 'Cook Islands', 'Costa Rica', '$_[', 'Croatia', 'Curaçao', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor', 'Ecuador', 'El Salvador', 'Egypt', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Federated States of Micronesia', 'Fiji', 'Finland', 'French Guiana', 'French Polynesia', 'French Southern Lands', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard and McDonald Islands', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn Islands', 'Poland', 'Portugal', 'Qatar', 'Réunion', 'Romania', 'Russia', 'Rwanda', 'Saint Barthélemy', 'Saint Helena', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Martin', 'Saint Pierre and Miquelon', 'Saint Vincent', 'Samoa', 'San Marino', 'São Tomé and Príncipe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia', 'South Korea', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Sweden', 'Swaziland', 'Switzerland', 'Syria', 'Tajikistan', 'Tanzania', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Vatican City', 'Vietnam', 'Venezuela', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'];

var requestBodyExample = {
	ID:2062,
	market:"us",
	TechnicianLog:"",
	SerialNum:"",
	BatchNum:"",
	RMANum:"",
	AgileNum:"",
	UnitType:"",
	DateCreated:"",
	TamName:"",
	TamPhone:"",
	CustomerName:"",
	Address:"",
	City:"",
	State:"",
	Zip:"",
	email:"",
	Action:"",
	TrackingNum:"",
	TrackingDateAzena:"",
	ExpectedRepairDate:"",
	OriginalShipDate:"",
	TechnicianRepair:"",
	ReceivedDate:"",
	Status:"",
	Firmware:"",
	NewCalibration:"",
	ReplacedSD:null,
	ReplacedFiber:null,
	ReplacedModule:null,
	ReplacedMain:null,
	ReplacedHans:null,
	ReplacedDisplay:1,
	ReplacedSpeaker:null,
	ReplacedBattery:null,
	ReplacedPedal:null,
	ReplacedKeypad:1,
	ReplacedDisplayDriver:null,
	FixedBoardSolder:null,
	ReplacedFlex16:null,
	ReplacedFlex21:null,
	ReplacedBox:null,
	ReplacedFoam:1,
	ReturnedDate:"2021-07-28T00:00:00.000Z",
	TrackingCustomer:"1ZE64A871299047514",
	ReturnedStatus:"As Is",
	ShippingDestination:"Customer",
	IssueCategory1:36,
	IssueCategory2:7,
	IssueCategory3:0,
	MDRRequired:0,
	MDRJustification:0,
	IncidentInvolved:0,
	RecallRequired:0,
	SendCustomerEmail:1,
	UPIClosed:1}

	// Create styles
const styles = StyleSheet.create({
  page: { backgroundColor: '#000000' },
  section: { color: 'white', textAlign: 'center', margin: 30 },
  title: {
    fontSize: 20,
    marginVertical: 5,
    textAlign: 'center',
    color: '#f3c12b'
  },
  TableCellHeaderStyle : {
    padding: 5,
    textAlign: "center",
    fontSize: 14,
    fontWeight: 900,
    backgroundColor: '#ffffff'
  },
  TableCellBodyStyle : {
    padding: 5,
    textAlign: "center",
    fontSize: 11,
    backgroundColor: '#f3c12b'
  },
  TableStyle : {
    padding: 5,
  },
  Table: {
    marginVertical: 5,
    marginHorizontal: 5,
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 0,
  },
});

const invoiceStyle = StyleSheet.create({
  page: { backgroundColor: '#000000' },
  section: { color: 'white', textAlign: 'center', margin: 30 },
  title: {
    fontSize: 25,
    marginVertical: 2,
    textAlign: 'center',
    color: '#f3c12b',
		height: 25,
		paddingTop: 5,
		marginBottom: 10,
  },
  TableCellHeaderStyle : {
    padding: 5,
    textAlign: "center",
    fontSize: 14,
    fontWeight: 900,
    backgroundColor: '#ffffff'
  },
  TableCellBodyStyle : {
    padding: 5,
    textAlign: "center",
    fontSize: 11,
    backgroundColor: '#f3c12b'
  },
  TableStyle : {
    padding: 5,
  },
  Table: {
    marginVertical: 20,
    marginHorizontal: 5,
  },
  image: {
		textAlign: 'right',
		width: '20%',
		paddingRight: 5
  },
	logo: {
		width: 110,
		height: 100,
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: '20px',
		padding: 5
  },
	invoiceNoContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
		color: '#f3c12b',
  },
  invoiceDateContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
		color: '#f3c12b',
  },
  invoiceDate: {
		fontSize: 12,
		fontStyle: 'bold',
		color: '#f3c12b',
  },
	dateLabel: {
    width: 50,
		color: '#f3c12b',
  },
  numlabel: {
    width: 100,
		color: '#f3c12b',
  },
	labelText: {
		width: 100,
		color: '#f3c12b',
		textAlign: 'left'
  },
	dateContainer: {
		width: '80%',
    marginTop: 25,
		marginBottom: 5,
		padding: 10
  },
	billingContainer: {
    marginTop: 0,
		marginBottom: 20,
		padding: 10
  },
  billTo: {
		marginTop: 5,
		paddingBottom: 3,
		color: '#f3c12b',
  },
	addresslabel: {
		color: '#f3c12b',
  },
	row: {
		flexDirection: 'row',
		borderBottomColor: '#f3c12b',
		borderBottomWidth: 1,
		alignItems: 'center',
		height: 30,
		fontSize: 20,
		fontStyle: 'bold',
  },
  description: {
		width: '80%',
		textAlign: 'right',
		borderRightColor: '#f3c12b',
		borderRightWidth: 1,
		paddingRight: 8,
		color: '#f3c12b',
  },
  total: {
		width: '20%',
		textAlign: 'center',
		paddingRight: 8,
		color: '#f3c12b',
  },
	repairNotes: {
    margin: 12,
    fontSize: 15,
    textAlign: 'justify',
		color: '#f3c12b',
		marginTop: 20
  },
	headerContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
	},
	customerHeaderContainer: {
		textAlign: 'center',
		width: '100%',
		borderBottomWidth: 2,
    borderBottomColor: '#30363d',
    borderBottomStyle: 'solid',
		borderTopWidth: 2,
    borderTopColor: '#30363d',
    borderTopStyle: 'solid',
		padding: 8,
	},
	customerHeaderLabel: {
		color: '#fff',
  },
	customerInfoContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
		borderBottomWidth: 2,
    borderBottomColor: '#30363d',
    borderBottomStyle: 'solid',
	},
	customerInfoLeftContainer: {
		width: '100%',
    marginTop: 25,
		marginBottom: 5,
		padding: 10
  },
	customerInfoLabel: {
		color: '#f3c12b',
		fontSize: 14,
  },
	customerLetterContainer: {
    marginTop: 0,
		marginBottom: 20,
		padding: 10
  },
	customerLetterHeaderLabel: {
		marginTop: 5,
		marginBottom: 5,
		color: '#f3c12b',
		fontSize: 14,
  },
	customerNotesContainer: {
		marginTop: 5,
		marginBottom: 5,
		color: '#f3c12b',
		backgroundColor: '#fff',
		borderWidth: 2,
    borderColor: '#30363d',
    borderStyle: 'solid',
  },
	customerNotesLabel: {
    margin: 12,
    fontSize: 15,
    textAlign: 'justify',
		color: '#000',
  },
	signatureInfoContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
		borderBottomWidth: 2,
    borderBottomColor: '#30363d',
    borderBottomStyle: 'solid',
	},
	signatureInfoLeftContainer: {
		width: '80%',
    marginTop: 5,
		marginBottom: 5,
		padding: 10
  },
	signature: {
		width: 175,
		height: 45,
		marginTop: '20px',
  },
	certImage: {
		width: 110,
		height: 100,
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: '85px',
		padding: 5
  },
});

const repairOrderStyle = StyleSheet.create({
  page: { backgroundColor: '#ffffff' },
  section: { color: 'white', textAlign: 'center', margin: 30 },
  headerContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
	},
  dateContainer: {
		width: '30%',
		padding: 5,
    marginTop: 5
  },
  middleContainer: {
		width: '25%',
		padding: 5,
    marginTop: 5
  },
  addressContainer: {
		width: '35%',
		padding: 5,
    marginTop: 5
  },
  addresslabel: {
    fontSize: 10,
    padding: 1,
  },
  addresslabelBold: {
    fontSize: 10,
    fontWeight: 'bold',
    fontFamily: 'Helvetica-Bold',
    padding: 1,
  },
  logo: {
		width: 66,
		height: 60,
		marginLeft: 'auto',
		marginRight: 'auto',
		padding: 10
  },
  travelerImage: {
		width: '100%',
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: '5px'
  },
  row: {
		flexDirection: 'row',
		borderBottomColor: '#000',
		borderBottomWidth: 1,
		alignItems: 'center',
		height: 30,
		fontSize: 12,
		fontStyle: 'bold',
  },
  description: {
		width: '80%',
		textAlign: 'right',
		borderRightColor: '#000',
		borderRightWidth: 1,
		paddingRight: 8,
		color: '#000',
  },
  total: {
		width: '20%',
		textAlign: 'center',
		paddingRight: 8,
		color: '#000',
  },
	repairNotes: {
    marginLeft: 12,
    marginRight: 12,
    fontSize: 9,
    textAlign: 'justify',
		color: '#000',
  },
});

const intlQuoteStyle = StyleSheet.create({
  page: { backgroundColor: '#ffffff' },
  section: { color: 'white', textAlign: 'center', margin: 30 },
  title: {
    fontSize: 25,
    marginVertical: 2,
    textAlign: 'center',
    color: '#f3c12b',
		height: 25,
		paddingTop: 5,
		marginBottom: 10,
  },
  TableCellHeaderStyle : {
    padding: 5,
    textAlign: "center",
    fontSize: 12,
    fontWeight: 900,
    backgroundColor: '#ffffff'
  },
  TableCellBodyStyle : {
    padding: 5,
    textAlign: "center",
    fontSize: 11,
    backgroundColor: '#FFFFFF'
  },
  TableStyle : {
    padding: 5,
  },
  Table: {
    marginVertical: 10,
    marginHorizontal: 5,
		padding: 15
  },
  image: {
		textAlign: 'right',
		width: '20%',
		paddingRight: 5
  },
	logo: {
		width: 160,
		height: 137,
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: '10px',
		padding: 5
  },
	logoAzena: {
		width: 140,
		height: 128,
		marginLeft: 'auto',
		marginRight: 'auto',
		marginTop: '10px',
		padding: 5
  },
	invoiceNoContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
		color: '#f3c12b',
  },
  invoiceDateContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
		color: '#f3c12b',
  },
  invoiceDate: {
		fontSize: 12,
		fontStyle: 'bold',
		color: '#f3c12b',
  },
	dateLabel: {
    width: 50,
		color: '#f3c12b',
  },
  numlabel: {
    width: 100,
		color: '#f3c12b',
  },
	labelText: {
		width: 100,
		color: '#f3c12b',
		textAlign: 'left'
  },
	dateContainer: {
		width: '70%',
    marginTop: 15,
		padding: 15
  },
	billingContainer: {
    marginTop: 0,
		marginBottom: 20,
		padding: 15
  },
  billTo: {
		marginTop: 5,
		paddingBottom: 3,
		fontSize: 16,
		fontStyle: 'bold',
		color: '#000000',
  },
	titlelabel: {
		fontSize: 20,
		color: '#000000',
  },
	addresslabelItalic: {
		fontStyle: 'italic',
		color: '#000000',
  },
	addresslabel: {
		fontSize: 14,
		color: '#000000',
  },
	row: {
		flexDirection: 'row',
		borderBottomColor: '#000000',
		borderBottomWidth: 1,
		alignItems: 'center',
		height: 30,
		fontSize: 20,
		fontStyle: 'bold',
  },
  description: {
		width: '80%',
		textAlign: 'right',
		borderRightColor: '#000000',
		borderRightWidth: 1,
		paddingRight: 8,
		color: '#000000',
  },
  total: {
		width: '20%',
		textAlign: 'center',
		paddingRight: 8,
		color: '#000000',
  },
	repairNotesContainer: {
		height: 120,
		paddingLeft: 15,
		paddingRight: 15,
		paddingTop: 5,
		paddingBottom: 5
	},
	repairNotes: {
    fontSize: 15,
    textAlign: 'justify',
		color: '#000000',
  },
	headerContainer: {
		flexDirection: 'row',
		justifyContent: 'flex-end',
	},
	addressContainerLeft: {
		width: '50%',
		float: 'left',
		paddingLeft: 15,
		paddingRight: 15,
		paddingTop: 5,
		paddingBottom: 5
	},
	addressContainerRight: {
		width: '50%',
		float: 'right',
		paddingLeft: 15,
		paddingRight: 15,
		paddingTop: 5,
		paddingBottom: 5
	},
	tableContainer: {
		padding: 15
	},
	footerContainer: {
		textAlign: 'center',
		marginTop: 5,
		padding: 20
	},
	tablefooterContainer: {
		textAlign: 'center',
		marginTop: 0,
		padding: 5
	},
	footerLabel: {
		whiteSpace: "nowrap",
    fontSize: 14,
		marginBottom: 5,
		color: '#000000',
  },
	tableNotesLabel: {
		whiteSpace: "nowrap",
		fontFamily: "Helvetica-Bold",
		fontWeight: "bolder",
    fontSize: 14,
		marginBottom: 5,
		color: '#000000',
  },
	gstView: {
		width: '95%',
		float: 'right',
		textAlign: 'right',
		padding: 5
  },
});

class GenIntlQuote extends React.Component {

  async componentDidMount() {

    //console.log("MyDocument procedure data: " + JSON.stringify(this.props.data));

		// <Text style={intlQuoteStyle.addresslabel}>Repair Log ID: {this.props.repairLogID}</Text>
		// <Text style={intlQuoteStyle.addresslabel}>Serial Number: {this.props.serialNumber}</Text>
		// <Text style={intlQuoteStyle.addresslabel}>Quote Number: {this.props.invoiceNumber}</Text>
	}

  render() {

				 var d1 = Moment(this.props.repairLog.OriginalShipDate);
				 var d2 = Moment();
				 var underWarrantyValue = "NO";

				 console.log("d1: " + d1);
				 console.log("d2: " + d2);

				 console.log("date diff: " + d2.diff(d1, 'days'));

				 if (d2.diff(d1, 'days')<731) {
					 underWarrantyValue = "YES"
				 }

				 let equipmentArray = [{
					 equipment: this.props.repairLog.ProductName,
					 serial: this.props.repairLog.SerialNum,
					 repairedBy: this.props.repairLog.TechnicianRepair,
					 date: Moment(this.props.repairLog.ReturnedDate).utc(false).format('YYYY-MM-DD'),
					 warranty: underWarrantyValue,
					 id: this.props.repairLog.ID,
				 }]

				 const dealer = this.props.dealers.find(dealer => dealer.Name==this.props.repairLog.DealerName);

				 var customerNotes = "";

				 this.props.data.map((item, i) => {

  					customerNotes = customerNotes+" "+item.CustomerNotes+"."

  				});

         return (
					 <Document>
						 <Page size="A4" style={intlQuoteStyle.page}>
							 <View style={intlQuoteStyle.headerContainer}>
								 <View style={intlQuoteStyle.dateContainer}>
								 		<Text style={intlQuoteStyle.titlelabel}>Ultradent Products Australia Pty Ltd</Text>
										<Text style={intlQuoteStyle.addresslabelItalic}>ABN 53 166 456 640</Text>
										<Text style={intlQuoteStyle.addresslabel}>PO Box 184 Manly, NSW 1165</Text>
										<Text style={intlQuoteStyle.addresslabel}>Phone: 1800 290 029</Text>
										<Text style={intlQuoteStyle.addresslabel}>www.ultradent.com/au</Text>
										<Text style={intlQuoteStyle.addresslabel}></Text>
										<Text style={intlQuoteStyle.addresslabel}>Date: {this.props.invoiceDate}</Text>
							   </View>
								 <Image style={intlQuoteStyle.logo} src={ultradentLogo} />
						   </View>
							 <View style={intlQuoteStyle.headerContainer}>
								 <View style={intlQuoteStyle.addressContainerLeft}>
							      <Text style={intlQuoteStyle.billTo}>CUSTOMER:</Text>
							      <Text style={intlQuoteStyle.addresslabel}>{this.props.repairLog.CustomerName}</Text>
							      <Text style={intlQuoteStyle.addresslabel}>{this.props.repairLog.Address}</Text>
										<Text style={intlQuoteStyle.addresslabel}>{this.props.repairLog.City} {this.props.repairLog.State} {this.props.repairLog.Zip}</Text>
							   </View>
								 {dealer ? (
									 <View style={intlQuoteStyle.addressContainerRight}>
								      <Text style={intlQuoteStyle.billTo}>Dealer:</Text>
								      <Text style={intlQuoteStyle.addresslabel}>{dealer ? dealer.Address : "N/A"}</Text>
											<Text style={intlQuoteStyle.addresslabel}>{dealer ? dealer.Address2 : "N/A"}</Text>
											<Text style={intlQuoteStyle.addresslabel}>{dealer ? dealer.City : "N/A"}</Text>
											<Text style={intlQuoteStyle.addresslabel}>{dealer ? dealer.County : "N/A"}</Text>
											<Text style={intlQuoteStyle.addresslabel}>{dealer ? dealer.State : "N/A"}</Text>
											<Text style={intlQuoteStyle.addresslabel}>{dealer ? dealer.Province : "N/A"}</Text>
											<Text style={intlQuoteStyle.addresslabel}>{dealer ? dealer.Country : "N/A"}</Text>
											<Text style={intlQuoteStyle.addresslabel}>{dealer ? dealer.PostalCode : "N/A"}</Text>
								   </View>
								 ) : (
									 <View style={intlQuoteStyle.addressContainerRight}>
								      <Text style={intlQuoteStyle.billTo}>Dealer:</Text>
								      <Text style={intlQuoteStyle.addresslabel}>{"N/A"}</Text>
								   </View>
								 )}
							 </View>
							 <View style={intlQuoteStyle.repairNotesContainer}>
							 		<Text style={intlQuoteStyle.billTo}>COMMENTS OR SPECIAL INSTRUCTIONS:</Text>
							 		<Text style={intlQuoteStyle.repairNotes}>{this.props.detailedIssue}</Text>
							 </View>
							 <View style={intlQuoteStyle.tableContainer}>
									 <Table style={intlQuoteStyle.Table} data={equipmentArray}>
		                 <TableHeader style={intlQuoteStyle.Table} textAlign={"center"}>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         EQUIPMENT
		                     </TableCell>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         SERIAL N.
		                     </TableCell>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         REPAIRED BY
		                     </TableCell>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         DATE
		                     </TableCell>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         WARRANTY
		                     </TableCell>
												 <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         LOG ID
		                     </TableCell>
		                 </TableHeader>
		                 <TableBody textAlign={"center"} >
										 		<DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.equipment}/>
		                    <DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.serial}/>
		                    <DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.repairedBy}/>
		                    <DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.date}/>
		                    <DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.warranty}/>
												<DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.id}/>
		                 </TableBody>
		               </Table>
							 </View>
							 <View style={intlQuoteStyle.tableContainer}>
									 <Table style={intlQuoteStyle.Table} data={this.props.data}>
		                 <TableHeader style={intlQuoteStyle.Table} textAlign={"center"}>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         QTY.
		                     </TableCell>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         CODE
		                     </TableCell>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         DESCRIPTION
		                     </TableCell>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         UN. PRICE
		                     </TableCell>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         TOTAL
		                     </TableCell>
		                 </TableHeader>
		                 <TableBody textAlign={"center"} >
										 		<DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.Quantity}/>
		                    <DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.PartNumber}/>
		                    <DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.Description}/>
		                    <DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.Cost}/>
		                    <DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.Total}/>
		                 </TableBody>
		               </Table>
									 <View style={intlQuoteStyle.row}>
									 	 {this.props.market=="aus" ? (
											 <Text style={intlQuoteStyle.description}>AUD TOTAL</Text>
										 ) : (
											 <Text style={intlQuoteStyle.description}>TOTAL</Text>
										 )}
									   <Text style={intlQuoteStyle.total}>{this.props.invoiceTotal}</Text>
					         </View>
									 <View style={intlQuoteStyle.gstView}>
					           <Text style={intlQuoteStyle.addresslabel}>*gst incl.</Text>
					         </View>
									 <View style={intlQuoteStyle.footerContainer}>
					           <Text style={intlQuoteStyle.footerLabel}>If you have questions regarding this quote, please contact us at 1800 290 029 or info.anz@ultradent.com</Text>
					           <Text style={intlQuoteStyle.footerLabel}>THANK YOU FOR YOUR BUSINESS!</Text>
					         </View>
							 </View>
						 </Page>
					 </Document>
     )}
}

class GenEuropeIntlQuote extends React.Component {

  async componentDidMount() {

    //console.log("MyDocument procedure data: " + JSON.stringify(this.props.data));

		// <Text style={intlQuoteStyle.addresslabel}>Repair Log ID: {this.props.repairLogID}</Text>
		// <Text style={intlQuoteStyle.addresslabel}>Serial Number: {this.props.serialNumber}</Text>
		// <Text style={intlQuoteStyle.addresslabel}>Quote Number: {this.props.invoiceNumber}</Text>
	}

  render() {

				 var d1 = Moment(this.props.repairLog.OriginalShipDate);
				 var d2 = Moment();
				 var underWarrantyValue = "NO";

				 console.log("d1: " + d1);
				 console.log("d2: " + d2);

				 console.log("date diff: " + d2.diff(d1, 'days'));

				 if (d2.diff(d1, 'days')<731) {
					 underWarrantyValue = "YES"
				 }

				 let equipmentArray = [{
					 equipment: this.props.repairLog.ProductName,
					 serial: this.props.repairLog.SerialNum,
					 repairedBy: this.props.repairLog.TechnicianRepair,
					 date: Moment(this.props.repairLog.ReturnedDate).utc(false).format('YYYY-MM-DD'),
					 warranty: underWarrantyValue,
					 id: this.props.repairLog.ID,
				 }]

				 const dealer = this.props.dealers.find(dealer => dealer.Name==this.props.repairLog.DealerName);

				 var customerNotes = "";

				 this.props.data.map((item, i) => {

  					customerNotes = customerNotes+" "+item.CustomerNotes+"."

  				});

         return (
					 <Document>
						 <Page size="A4" style={intlQuoteStyle.page}>
							 <View style={intlQuoteStyle.headerContainer}>
								 <View style={intlQuoteStyle.dateContainer}>
								 		<Text style={intlQuoteStyle.titlelabel}>Azena Repair List</Text>
							   </View>
								 <Image style={intlQuoteStyle.logoAzena} src={logoBW} />
						   </View>
							 <View style={intlQuoteStyle.headerContainer}>
								 <View style={intlQuoteStyle.addressContainerLeft}>
							      <Text style={intlQuoteStyle.billTo}>CUSTOMER:</Text>
							      <Text style={intlQuoteStyle.addresslabel}>{this.props.repairLog.CustomerName}</Text>
							      <Text style={intlQuoteStyle.addresslabel}>{this.props.repairLog.Address}</Text>
										<Text style={intlQuoteStyle.addresslabel}>{this.props.repairLog.City} {this.props.repairLog.State} {this.props.repairLog.Zip}</Text>
							   </View>
								 {this.props.market!="brazil" ? (
									 <Fragment>
									 {dealer ? (
										 <View style={intlQuoteStyle.addressContainerRight}>
									      <Text style={intlQuoteStyle.billTo}>Dealer:</Text>
									      <Text style={intlQuoteStyle.addresslabel}>{dealer ? dealer.Address : "N/A"}</Text>
												<Text style={intlQuoteStyle.addresslabel}>{dealer ? dealer.Address2 : "N/A"}</Text>
												<Text style={intlQuoteStyle.addresslabel}>{dealer ? dealer.City : "N/A"}</Text>
												<Text style={intlQuoteStyle.addresslabel}>{dealer ? dealer.County : "N/A"}</Text>
												<Text style={intlQuoteStyle.addresslabel}>{dealer ? dealer.State : "N/A"}</Text>
												<Text style={intlQuoteStyle.addresslabel}>{dealer ? dealer.Province : "N/A"}</Text>
												<Text style={intlQuoteStyle.addresslabel}>{dealer ? dealer.Country : "N/A"}</Text>
												<Text style={intlQuoteStyle.addresslabel}>{dealer ? dealer.PostalCode : "N/A"}</Text>
									   </View>
									 ) : (
										 <View style={intlQuoteStyle.addressContainerRight}>
									      <Text style={intlQuoteStyle.billTo}>Dealer:</Text>
									      <Text style={intlQuoteStyle.addresslabel}>{"N/A"}</Text>
									   </View>
									 )}
									 </Fragment>
								 ) : (
									 <View style={intlQuoteStyle.addressContainerRight}>
									 </View>
								 )}

							 </View>
							 <View style={intlQuoteStyle.repairNotesContainer}>
							 		<Text style={intlQuoteStyle.billTo}>COMMENTS OR SPECIAL INSTRUCTIONS:</Text>
							 		<Text style={intlQuoteStyle.repairNotes}>{this.props.detailedIssue}</Text>
							 </View>
							 <View style={intlQuoteStyle.tableContainer}>
									 <Table style={intlQuoteStyle.Table} data={equipmentArray}>
		                 <TableHeader style={intlQuoteStyle.Table} textAlign={"center"}>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         EQUIPMENT
		                     </TableCell>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         SERIAL N.
		                     </TableCell>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         REPAIRED BY
		                     </TableCell>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         DATE
		                     </TableCell>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         WARRANTY
		                     </TableCell>
												 <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         LOG ID
		                     </TableCell>
		                 </TableHeader>
		                 <TableBody textAlign={"center"} >
										 		<DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.equipment}/>
		                    <DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.serial}/>
		                    <DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.repairedBy}/>
		                    <DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.date}/>
		                    <DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.warranty}/>
												<DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.id}/>
		                 </TableBody>
		               </Table>
							 </View>
							 <View style={intlQuoteStyle.tableContainer}>
									 <Table style={intlQuoteStyle.Table} data={this.props.data}>
		                 <TableHeader style={intlQuoteStyle.Table} textAlign={"center"}>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         QTY.
		                     </TableCell>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         CODE
		                     </TableCell>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         DESCRIPTION
		                     </TableCell>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         UN. PRICE
		                     </TableCell>
		                     <TableCell style={intlQuoteStyle.TableCellHeaderStyle}>
		                         TOTAL
		                     </TableCell>
		                 </TableHeader>
		                 <TableBody textAlign={"center"} >
										 		<DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.Quantity}/>
		                    <DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.PartNumber}/>
		                    <DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.Description}/>
		                    <DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.Cost}/>
		                    <DataTableCell style={intlQuoteStyle.TableCellBodyStyle} getContent={(p) => p.Total}/>
		                 </TableBody>
		               </Table>
									 {this.props.invoiceFormattedUSDTotal != "$0.00" &&
										 <View style={intlQuoteStyle.row}>
										   <Text style={intlQuoteStyle.description}>USD* TOTAL</Text>
										   <Text style={intlQuoteStyle.total}>{this.props.invoiceFormattedUSDTotal}</Text>
						         </View>
									 }
									 {this.props.invoiceFormattedEuroTotal != "€0.00" &&
										 <View style={intlQuoteStyle.row}>
						           <Text style={intlQuoteStyle.description}>EURO* TOTAL</Text>
						           <Text style={intlQuoteStyle.total}>{this.props.invoiceFormattedEuroTotal}</Text>
						         </View>
									 }
									 {this.props.invoiceFormattedUSDTotal != "$0.00" && this.props.invoiceFormattedEuroTotal != "€0.00" &&
										 <View style={intlQuoteStyle.tablefooterContainer}>
						           <Text style={intlQuoteStyle.tableNotesLabel}>*Grand totals to be combined for final quoting*</Text>
						         </View>
									 }
									 <View style={intlQuoteStyle.footerContainer}>
					           <Text style={intlQuoteStyle.footerLabel}>If you have questions or problems, please reach out to </Text>
										 <Text style={intlQuoteStyle.footerLabel}>Azena Repair at repairs@azenamedical.com</Text>
					           <Text style={intlQuoteStyle.footerLabel}>THANK YOU FOR YOUR BUSINESS!</Text>
					         </View>
							 </View>
						 </Page>
					 </Document>
     )}
}

class GenRepairOrder extends React.Component {

  async componentDidMount() {

    console.log("GenRepairOrder repairOrderData data: " + JSON.stringify(this.props.repairOrderData));
		// var repairOrderData = {
		// 	repairID: this.props.repairID,
		// 	underWarranty: underWarrantyValue,
		// 	warrantyDate: shipDate,
		// 	serialNumber: serialNum,
		// 	numberOfRepairs: totalRepairs,
		// 	arrivalDate: recievedDate,
		// 	state: state,
		// };
	}

  render() {
         return (
					 <Document>
						 <Page size="A4" style={repairOrderStyle.page}>
							 <View style={repairOrderStyle.headerContainer}>
                 <Image style={repairOrderStyle.logo} src={logoBW} />
								 <View style={repairOrderStyle.dateContainer}>
								 		<Text style={repairOrderStyle.addresslabel}>Repair Order / Log ID: {this.props.repairOrderData.repairID}</Text>
                    <Text style={repairOrderStyle.addresslabel}>Under Warranty: {this.props.repairOrderData.underWarranty}</Text>
                    <Text style={repairOrderStyle.addresslabel}>Warranty Date: {this.props.repairOrderData.warrantyDate}</Text>
							   </View>
                 <View style={repairOrderStyle.middleContainer}>
										<Text style={repairOrderStyle.addresslabelBold}>Unit Number: {this.props.repairOrderData.serialNumber}</Text>
                    <Text style={repairOrderStyle.addresslabel}>Number of Repairs: {this.props.repairOrderData.numberOfRepairs}</Text>
							   </View>
                 <View style={repairOrderStyle.addressContainer}>
                    <Text style={repairOrderStyle.addresslabelBold}>Arrival Date: {this.props.repairOrderData.arrivalDate}</Text>
										<Text style={repairOrderStyle.addresslabel}>Return To: ( UPI / Customer )</Text>
                    <Text style={repairOrderStyle.addresslabel}>State: {this.props.repairOrderData.state}</Text>
							   </View>
						   </View>
							 <Text style={repairOrderStyle.repairNotes}><b>Detailed Issue:</b> {this.props.repairOrderData.detailedIssue}</Text>
							 {this.props.repairOrderData.productID==1 ? (
								 <Image style={repairOrderStyle.travelerImage} src={repairTravelerImgGemini} />
							 ) : (
								 <Image style={repairOrderStyle.travelerImage} src={repairTravelerImgEvo} />
							 )}
						 </Page>
					 </Document>
     )}
}

class GenCustomerReport extends React.Component {

  async componentDidMount() {

    //console.log("MyDocument procedure data: " + JSON.stringify(this.props.data));
	}

  render() {
         return (
					 <Document>
						 <Page size="A4" style={invoiceStyle.page}>
							 <View style={invoiceStyle.customerHeaderContainer}>
								 <Text style={invoiceStyle.customerHeaderLabel}>YOUR GEMINI LASER REPAIR IS COMPLETED</Text>
							 </View>
							 <View style={invoiceStyle.customerInfoContainer}>
								 <View style={invoiceStyle.customerInfoLeftContainer}>
								 		<Text style={invoiceStyle.customerInfoLabel}>Customer Name: {this.props.customerName}</Text>
										<Text style={invoiceStyle.customerInfoLabel}>Serial Number: {this.props.serialNumber}</Text>
										<Text style={invoiceStyle.customerInfoLabel}>RMA Number: {this.props.rmaNumber}</Text>
										<Text style={invoiceStyle.customerInfoLabel}>Days In Service: {this.props.daysInService}</Text>
										<Text style={invoiceStyle.customerInfoLabel}>Tracking Number: {this.props.trackingNumber}</Text>
							   </View>
								 {
									 //<Image style={invoiceStyle.logo} src={logo} />
								 }
						   </View>
							 <View style={invoiceStyle.customerLetterContainer}>
						      <Text style={invoiceStyle.customerLetterHeaderLabel}>Dear {this.props.customerName},</Text>
						      <Text style={invoiceStyle.customerLetterHeaderLabel}>Your Gemini Laser is on its way back to you after being serviced. We truly apologize for the inconvenience.</Text>
						      <Text style={invoiceStyle.customerLetterHeaderLabel}>The UPS tracking number is shown above for your convenience.</Text>
						      <Text style={invoiceStyle.customerLetterHeaderLabel}>Below you can find additional comments by the laser technician that worked on your unit. Should you have any further questions, please contact your Ultradent representative.</Text>
						   </View>
							 <Text style={invoiceStyle.customerLetterHeaderLabel}>Technician Notes:</Text>
							 <View style={invoiceStyle.customerNotesContainer}>
						      <Text style={invoiceStyle.customerNotesLabel}>{this.props.customerNotes}</Text>
						   </View>
							 <View style={invoiceStyle.signatureInfoContainer}>
								 <View style={invoiceStyle.signatureInfoLeftContainer}>
										<Text style={invoiceStyle.customerLetterHeaderLabel}>Regards,</Text>
										<Text style={invoiceStyle.customerLetterHeaderLabel}>Gemini Service team</Text>
										<Text style={invoiceStyle.customerLetterHeaderLabel}>1-800-552-5512 ext 4574</Text>
										<Text style={invoiceStyle.customerLetterHeaderLabel}>equipment.repair@ultradent.com</Text>
										<Image style={invoiceStyle.signature} src={signature} />
								 </View>
								 <Image style={invoiceStyle.certImage} src={certImage} />
						   </View>
						 </Page>
					 </Document>
     )}
}

class GenInvoice extends React.Component {

  async componentDidMount() {

    //console.log("MyDocument procedure data: " + JSON.stringify(this.props.data));
	}

  render() {

				var customerNotes = "";

				this.props.data.map((item, i) => {

					customerNotes = customerNotes+" "+item.CustomerNotes+"."

				});

         return (
					 <Document>
						 <Page size="A4" style={invoiceStyle.page}>
							 <View style={invoiceStyle.headerContainer}>
								 <View style={invoiceStyle.dateContainer}>
								 		<Text style={invoiceStyle.addresslabel}>Date: {this.props.invoiceDate}</Text>
										<Text style={invoiceStyle.addresslabel}>Repair Log ID: {this.props.repairLogID}</Text>
										<Text style={invoiceStyle.addresslabel}>Serial Number: {this.props.serialNumber}</Text>
										<Text style={invoiceStyle.addresslabel}>Quote Number: {this.props.invoiceNumber}</Text>
							   </View>
								 <Image style={invoiceStyle.logo} src={logo} />
						   </View>
							 <View style={invoiceStyle.billingContainer}>
						      <Text style={invoiceStyle.billTo}>To:</Text>
						      <Text style={invoiceStyle.addresslabel}>Ultradent Products</Text>
						      <Text style={invoiceStyle.addresslabel}>505 W. 10200 S</Text>
						      <Text style={invoiceStyle.addresslabel}>South Jordan, UT 84095-3942</Text>
						      <Text style={invoiceStyle.addresslabel}>United States</Text>
						   </View>
							 <Table style={invoiceStyle.Table} data={this.props.data}>
                 <TableHeader style={invoiceStyle.Table} textAlign={"center"}>
                     <TableCell style={invoiceStyle.TableCellHeaderStyle}>
                         Part Number
                     </TableCell>
                     <TableCell style={invoiceStyle.TableCellHeaderStyle}>
                         Description
                     </TableCell>
                     <TableCell style={invoiceStyle.TableCellHeaderStyle}>
                         Item Cost
                     </TableCell>
                     <TableCell style={invoiceStyle.TableCellHeaderStyle}>
                         Quantity
                     </TableCell>
                     <TableCell style={invoiceStyle.TableCellHeaderStyle}>
                         Total
                     </TableCell>
                 </TableHeader>
                 <TableBody textAlign={"center"} >
								 		<DataTableCell style={invoiceStyle.TableCellBodyStyle} getContent={(p) => p.PartNumber}/>
                    <DataTableCell style={invoiceStyle.TableCellBodyStyle} getContent={(p) => p.Description}/>
                    <DataTableCell style={invoiceStyle.TableCellBodyStyle} getContent={(p) => p.Cost}/>
                    <DataTableCell style={invoiceStyle.TableCellBodyStyle} getContent={(p) => p.Quantity}/>
                    <DataTableCell style={invoiceStyle.TableCellBodyStyle} getContent={(p) => p.Total}/>
                 </TableBody>
               </Table>
							 <View style={invoiceStyle.row}>
			           <Text style={invoiceStyle.description}>TOTAL</Text>
			           <Text style={invoiceStyle.total}>{this.props.invoiceTotal}</Text>
			         </View>
							 <Text style={invoiceStyle.repairNotes}><b>Customer Notes:</b> {this.props.detailedRepair}</Text>
						 </Page>
					 </Document>
     )}
}

class RepairLogView extends React.Component {

	constructor(props) {
    super(props);

		const currentUser = authenticationService.currentUserValue;
		console.log('currentUser info: ' + JSON.stringify(currentUser));
		console.log('currentUser info: ' + JSON.stringify(currentUser.token));
		console.log('props info: ' + JSON.stringify(this.props.repairID));
		//this.props.match.params.id

    this.state = {
			repairLog: {},
			isOneOpen: true,
			sectionOneTitle: "Close",
			isTwoOpen: true,
			sectionTwoTitle: "Close",
			isThreeOpen: true,
			sectionThreeTitle: "Close",
			currentUser: JSON.parse(localStorage.getItem('currentUser')),
			detailedIssue: "",
			detailedRepair: "",
			customerNotes: "",
			warrantyPurchaseDate: "",
			warrantyLength: "",
			repairCategories: [],
			repairOptions: [],
			serialNumbers: [],
			g1SerialNumbers: [],
			evoSerialNumbers: [],
			novaSerialNumbers: [],
			deviceRepairs: [],
			serialNumbersAll: [],
			evoSerialNumbersAll: [],
			novaSerialNumbersAll: [],
			bomData: [],
			productsData: [],
			quoteData: [],
			quoteItemsForRepair: [],
			tamData: [],
			dealerData: [],
			repairCustomerNotes: [],
			componentItemsForRepair: [],
			categoryItemsForRepair: [],
			componentData: [],
			isNewRepairLog: true,
			selectedFileOne: null,
			loadedOne: false,
			filePreviewOne: null,
			selectedFileTwo: null,
			loadedTwo: false,
			filePreviewTwo: null,
			selectedFileThree: null,
			loadedThree: false,
			filePreviewThree: null,
			selectedFilePurchaseOrder: null,
			loadedPurchaseOrder: false,
			filePreviewPurchaseOrder: null,
			selectedFileLoanerReturnLabel: null,
			loadedLoanerReturnLabel: false,
			filePreviewLoanerReturnLabel: null,
			sectionOneFiles: [],
			sectionTwoFiles: [],
			sectionThreeFiles: [],
			purchaseOrderFiles: [],
			loanerReturnLabelFiles: [],
			imageEditorOpen: false,
			editingSlot: null, // 1 | 2 | 3
		  originalImageSrc: null,
		  croppedImageSrc: null,
		  editedImageBlob: null,
			annotationColor: "#ff0000",
			selectedAnnotationIsText: false,
			annotationFontSize: 24,
			annotationFontWeight: "normal",
			annotationFontStyle: "normal",
			annotationUnderline: false,
			annotationTextAlign: "left",
			cropSelection: null,
			crop: { x: 0, y: 0 },
			zoom: 1,
			croppedAreaPixels: null,
			repairHistoryLogs: [],
			lightBoxIndex: 0,
			lightBoxDataIndex: 1,
			modal: false,
			modal2: false,
			modal3: false,
			modal4: false,
			modal5: false,
			modal6: false,
			modal7: false,
			modal8: false,
			modal9: false,
			modal10: false,
			modal11: false,
			modal12: false,
			modal13: false,
			mediaHash: '',
			file: {},
			invoiceArray: [],
			invoiceTotal: "",
			invoiceFormattedUSDTotal: "",
			invoiceFormattedEuroTotal: "",
			invoiceNumber: "",
			invoiceDate: Moment().format('MM-DD-YYYY'),
			invoicePDFName: "",
			customerReportPDFName: "",
			invoiceSerialNumber: "",
			invoiceRepairID: "",
			statusSubject: "Failed",
			statusMessage: "Failed to send email.",
			testImageFile: null,
			isUPI: false,
			isUPI2: false,
			customerTracking: "",
			customerEmail: "",
			rmaNumber: "",
			customerDaysInService: 0,
			customerReportPreviewUrl: "",
			customerReportPreviewLoading: false,
			repairTravelerPreviewUrl: "",
			repairTravelerPreviewLoading: false,
			isMobileOrTabletPdfAction: false,
			selectedModalRepair: "",
			serialsByProduct: [],
			openedRepairSaved: false,
			loadingRepair: true,
			openedRepairStatus: "",
			manualTAMChecked: false,
			presignedURLTest: "",
			isUploadingFile: false,
			selectedCustomerNoteID: 0,
			shippingLabelErrorStatus: "",
			shippoTestKey: "shippo_test_c7fe55fbad00743bd5b12b2f8ffdf373e51764fd",
			shippoProdKey: "shippo_live_0802c787a1f180d8ed104f6372042b65f5b90340",
			currencies: [{ Currency: "USD", Symbol: "$" }, { Currency: "EURO", Symbol: "€" }, { Currency: "AUD", Symbol: "$" }, { Currency: "TWD", Symbol: "$" }, { Currency: "COP", Symbol: "$" }],
			shippingLabelURL: "",
			shippingRetreivingRates: false,
			shippingReceivedRates: false,
			shippingLabelGenerating: false,
			shippingLabelGenerated: false,
			shippoAvailableRates: [],
			repairOrderData: {},
			selectedProductName: 0,
			market: "us",
			isInternationalRepair: false,
			footpedalFlag: false,
			isReturnLabel: false,
			udiCode: "",
			udiDate: "",
			udiSerialCode: "",
			shipDateFormattedDate: "",
			isBeingSaved: false,
			initialSaveLabel: "",
			latestUpdateLabel: "",
			isSavingComponents: false,
			isSavingReasons: false,
			isSavingQuotes: false,
			kitType: "",
			userName: "",
			techEmail: "",
			techRepair: "",
			batchNum: "",
			activeRepairs: []
	  };

		this.toggleOne = this.toggleOne.bind(this);
		this.toggleTwo = this.toggleTwo.bind(this);
		this.toggleThree = this.toggleThree.bind(this);
		this.onChangeHandlerOne = this.onChangeHandlerOne.bind(this);
		this.onChangeHandlerTwo = this.onChangeHandlerTwo.bind(this);
		this.onChangeHandlerThree = this.onChangeHandlerThree.bind(this);
		this.onClickHandlerOne = this.onClickHandlerOne.bind(this);
		this.onClickHandlerTwo = this.onClickHandlerTwo.bind(this);
		this.onClickHandlerThree = this.onClickHandlerThree.bind(this);
		this.getFileFromUrl = this.getFileFromUrl.bind(this);

		this.onChange = this.onChange.bind(this);
		this.onChangeSerialNumber = this.onChangeSerialNumber.bind(this);
		this.onChangeRepairSelection = this.onChangeRepairSelection.bind(this);
		this.onChangeManualTAMChecked = this.onChangeManualTAMChecked.bind(this);
		this.toggle = this.toggle.bind(this);
		this.toggle2 = this.toggle2.bind(this);
		this.toggle3 = this.toggle3.bind(this);
		this.toggle4 = this.toggle4.bind(this);
		this.toggle5 = this.toggle5.bind(this);
		this.toggle6 = this.toggle6.bind(this);
		this.toggle7 = this.toggle7.bind(this);
		this.toggle8 = this.toggle8.bind(this);
		this.toggle9 = this.toggle9.bind(this);
		this.toggle9Return = this.toggle9Return.bind(this);
		this.toggle10 = this.toggle10.bind(this);
		this.toggle11 = this.toggle11.bind(this);
		this.toggle12 = this.toggle12.bind(this);
		this.toggle13 = this.toggle13.bind(this);

			this.createSnapShot = this.createSnapShot.bind(this);

			this.editorCanvasRef = React.createRef();
			this.editorImageRef = React.createRef();
			this.cropSourceImageRef = React.createRef();
			this.previewPdfModalFrameRef = React.createRef();
			this.customerReportFrameRef = React.createRef();
			this.shippingLabelFrameRef = React.createRef();
			this.repairTravelerFrameRef = React.createRef();
			this.fabricInitVersion = 0;
			this.fabricCanvas = null;
			this.cropDragStart = null;
			this.cropDragBounds = null;

	  }

	async componentDidMount() {
		this.updatePdfActionViewportState();
		window.addEventListener("resize", this.updatePdfActionViewportState);

		if (this.state.currentUser.payload['custom:market'] || (this.state.currentUser && this.state.currentUser.payload['custom:role']!=1 && this.state.currentUser.payload['custom:role']!=2)) {
			//this.setState({ isUPI: true });
			//this.setState({ isUPI2: true });
		}

		if (this.state.currentUser.payload['custom:market'] && (this.state.currentUser && this.state.currentUser.payload['custom:market']=="aus" || this.state.currentUser.payload['custom:market']=="europe" || this.state.currentUser.payload['custom:market']=="brazil" || this.state.currentUser.payload['custom:market']=="taiwan" || this.state.currentUser.payload['custom:market']=="colombia" || this.state.currentUser.payload['custom:market']=="mexico" || this.state.currentUser.payload['custom:market']=="czech")) {
			this.setState({ market: this.state.currentUser.payload['custom:market'], isInternationalRepair: true });
			//document.getElementById("UnitType").value = "INTL";
			this.state.repairLog.UnitType = "INTL";
		}

		var hash = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
		console.log('random mediaHash: ' + hash);
		//console.log('email html: ' + getEmailHTML("Ryan Stickel Ryan Stickel Ryan Stickel Ryan Stickel"));
		//this.sendEmailToAzena("00001");

		await this.getTAMData();
		await this.getSerialNumbersData();
		await this.getEvoSerialNumbersData();
		await this.getNovaSerialNumbersData();

		if (!this.props.repairID) {
			this.setState({loadingRepair: false});
		}

		// await this.getCustomerNotesData();
		// await this.getCategoryData();
		// await this.getOptionsData();
		// await this.getBOMData();

		await this.getActiveRepairsData();
		await this.getProductsData();
		await this.getDealerData();

		this.setState({ mediaHash: hash });

		if (this.props.repairID) {
			await this.getQuoteItemsForRepairData();
			await this.getComponentItemsForRepairData();
			await this.getCategoryItemsForRepairData();
			await this.getData();
			await this.getRepairHistoryLogs();
			this.setState({isNewRepairLog: false});
			//this.getRepairsForSerial();
		} else {
			this.setState({isTwoOpen: false, isThreeOpen: false, loadingRepair: false});
		}

		await this.getCustomerNotesData();
		await this.getCategoryData();
		await this.getOptionsData();
		await this.getBOMData();
		await this.getQuoteData();

		if (this.props.repairID) {
			//await this.updateRepairLog();
			await this.logRepairViewCount(this.props.repairID);

			//Test session error handling
			// var currentUserHack = JSON.parse(JSON.stringify(this.state.currentUser));
			// currentUserHack.jwtToken = "blahblah";
			// this.setState({ currentUser: currentUserHack });
		}

		// // a string
		// const str = "Hey. this is a string!";
		//
		// // convert string to Buffer
		// const buff = Buffer.from(str, "utf8");
		//
		// console.log(buff);
		//
		// var string = Buffer.from(buff, 'utf8');
		//
		// console.log("string: "+string);

		// var hash = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
		// console.log('random hash: ' + hash);

		//Modal Testing
		//setTimeout(this.toggle7, 2000);

		//this.sendEmailToINTLOrders();

		//this.saveRepairTest();

	}

	saveRepairTest = async () => {

		var url = "https://ys1kl6v775.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"create-repair-log";

		//"AuthKey": "80df5092485bbfc74591317dd897ec0124ef531c"
		var requestBody = {
			"AuthKey": "80df5092485bbfc74591317dd897ec0124ef531c",
			"TechnicianName": "Ryan Stickel",
			"TechnicianEmail": "rstickel@azenamedical.com",
			"ProductName": "Gemini",
		  "UnitSerialNumber": "EL-5-001/00013",
		  "RMANumber": "3364",
		  "AgileNumber": "VR-1533",
		  "CustomerType": "DOM",
		  "TAMName": "AARON JOSEPH",
			"TAMPhone": "909-263-5256",
		  "OfficeName": "DR ERIC CHEN (406866)",
		  "ContactName": "Sarah Jane",
		  "Address": "9188 E SAN SALVADOR DR, STE 105",
		  "City": "SCOTTSDALE",
		  "State": "AZ",
		  "ZipCode": "85258",
		  "Email": "doctorchen@email.com",
		  "Action": "Return To Customer",
		  "TrackingNumber": "1Z30Y45W2522392518",
			"TrackingLabelDate": "2024-05-04",
		  "ExpectedRepairBy": "2024-05-04",
		  "ProductPurchaseDate": "2016-06-03",
		  "IncidentInvoved": "NO",
		  "MDRRequired": "NO",
		  "DetailedIssueInfo": "the foot pedal disconnects from the laser regularly, the display seems loose, the plug on the back of the Gemini where the power supply connects seems loose",
		};

		try {

			const response = await fetch(url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(requestBody)
			});

			const body = await response.json();
			console.log("saveRepairTest response: " + JSON.stringify(body));

			if (body.status == 'Success') {

			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	checkLoadingRepair () {
		this.updateRepairLog();
	}

	lightBoxHandler(dataIndex, imageIndex) {
		this.setState({
			modal: true,
			lightBoxDataIndex: dataIndex,
			lightBoxIndex: imageIndex
		});
	}

	toggle() {
	  this.setState((prevState) => ({
	    modal: !prevState.modal
	  }));
	}

	toggle2() {
	  this.setState({
	    modal2: !this.state.modal2
	  });
	}

	toggle3() {
	  this.setState({
	    modal3: !this.state.modal3
	  });
	}

	toggle4() {
	  this.setState({
	    modal4: !this.state.modal4
	  });
	}

	toggle5() {
	  this.setState({
	    modal5: !this.state.modal5
	  });
	}

	toggle6() {
		if (this.state.modal6) {
			this.clearPreviewUrl("customerReportPreviewUrl");
			this.setState({
				modal6: false,
				customerReportPreviewLoading: false
			});
			return;
		}

	  this.setState({
	    modal6: true
	  });
	}

	toggle7() {
	  this.setState({
	    modal7: !this.state.modal7
	  });
	}

	toggle8() {
	  this.setState({
	    modal8: !this.state.modal8
	  });
	}

	toggle9() {

		this.setState({
			shippingRetreivingRates: false,
			shippingReceivedRates: false,
			shippingLabelGenerating: false,
			shippingLabelGenerated: false,
		});

	  this.setState({
	    modal9: !this.state.modal9
	  });
	}

	toggle9Return() {

		this.setState({
			isReturnLabel: true,
			shippingRetreivingRates: false,
			shippingReceivedRates: false,
			shippingLabelGenerating: false,
			shippingLabelGenerated: false,
		});

	  this.setState({
	    modal9: !this.state.modal9
	  });
	}

	toggle10() {
		if (this.state.modal10) {
			this.clearPreviewUrl("repairTravelerPreviewUrl");
			this.setState({
				modal10: false,
				repairTravelerPreviewLoading: false
			});
			return;
		}

		var d1 = Moment(this.state.repairLog.OriginalShipDate);
		var d2 = Moment();

		if (this.state.repairLog.DateCreated) {
			d2 = Moment(this.state.repairLog.DateCreated).utc(false);
		}

		var underWarrantyValue = "NO";

		console.log("date diff: " + d2.diff(d1, 'days'));

		if (d2.diff(d1, 'days')<731) {
			underWarrantyValue = "YES"
		}

		if (this.state.warrantyLength==2 || this.state.warrantyLength==3) {
			//var wd1 = Moment(this.state.warrantyPurchaseDate).utc(false);
			var wd2 = Moment().utc(false);

			if (this.state.repairLog.DateCreated) {
				wd2 = Moment(this.state.repairLog.DateCreated).utc(false);
			}

			//console.log("wd1: " + wd1);
			console.log("wd2: " + wd2);

			console.log("date diff: " + wd2.diff(d1, 'years', true));

			if (wd2.diff(d1, 'years', true)<(2+parseInt(this.state.warrantyLength))) {
				underWarrantyValue = "YES"
			}
		}


		// var d1 = Moment(this.state.repairLog.OriginalShipDate);
		// var d2 = Moment();
		// var underWarrantyValue = "NO";
		//
		// console.log("d1: " + d1);
		// console.log("d2: " + d2);
		//
		// console.log("date diff: " + d2.diff(d1, 'days'));
		//
		// if (d2.diff(d1, 'days')<731) {
		// 	underWarrantyValue = "YES"
		// }

		var shipDate = Moment(this.state.repairLog.OriginalShipDate).utc(false).format('MM-DD-YYYY');
		var recievedDate = Moment(this.state.repairLog.ReceivedDate).utc(false).format('MM-DD-YYYY');
		var serialNum = this.state.repairLog.SerialNum;
		var state = this.state.repairLog.State;
		var productID = this.state.selectedProductName;
		var totalRepairs = this.state.deviceRepairs ? this.state.deviceRepairs.length : 0;
		var detailedIssue = document.getElementById("detailedIssue").value;

		var repairOrderData = {
			repairID: this.props.repairID,
			productID: productID,
			underWarranty: underWarrantyValue,
			warrantyDate: shipDate,
			serialNumber: serialNum,
			numberOfRepairs: totalRepairs,
			arrivalDate: recievedDate,
			state: state,
			detailedIssue
		};

		this.setState({
			repairOrderData,
			modal10: true,
			repairTravelerPreviewLoading: true
		}, this.prepareRepairTravelerPreview);
	}

	toggle11() {
	  this.setState({
	    modal11: !this.state.modal11
	  });
	}

	toggle12() {
	  this.setState({
	    modal12: !this.state.modal12
	  });
	}

	toggle13() {
	  this.setState({
	    modal13: !this.state.modal13
	  });
	}

	previewRepairLog(repairID) {
		this.setState({
	    selectedModalRepair: repairID
	  });
		this.toggle7();
	}

	componentDidUpdate(prevProps, prevState) {
		if (
	    this.state.imageEditorOpen &&
	    this.state.croppedImageSrc &&
	    (
	      this.state.croppedImageSrc !== prevState.croppedImageSrc ||
	      !this.fabricCanvas
	    )
	  ) {
	    window.requestAnimationFrame(() => {
	      const canvasEl = this.editorCanvasRef.current;
	      if (canvasEl) {
	        this.initFabric(this.state.croppedImageSrc);
	      }
	    });
	  }
	}

	componentWillUnmount() {
		this.fabricInitVersion += 1;
		window.removeEventListener("resize", this.updatePdfActionViewportState);

	  if (this.fabricCanvas) {
	    this.fabricCanvas.dispose();
	    this.fabricCanvas = null;
	  }

		this.clearPreviewUrl("customerReportPreviewUrl");
		this.clearPreviewUrl("repairTravelerPreviewUrl");
	}

	updatePdfActionViewportState = () => {
		const isMobileOrTabletPdfAction = window.innerWidth <= 1024;

		if (this.state.isMobileOrTabletPdfAction !== isMobileOrTabletPdfAction) {
			this.setState({ isMobileOrTabletPdfAction });
		}
	};

	clearPreviewUrl = (stateKey) => {
		const previewUrl = this.state[stateKey];

		if (previewUrl) {
			URL.revokeObjectURL(previewUrl);
		}
	};

	createPreviewUrl = async (documentNode) => {
		const blob = await pdf(documentNode).toBlob();
		return URL.createObjectURL(blob);
	};

	prepareCustomerReportPreview = async () => {
		try {
			const previewUrl = await this.createPreviewUrl(
				<GenCustomerReport daysInService={this.state.customerDaysInService} trackingNumber={this.state.customerTracking} rmaNumber={this.state.rmaNumber} customerName={this.state.repairLog.CustomerName} invoiceDate={this.state.invoiceDate} customerNotes={this.state.customerNotes} repairLogID={this.props.repairID} serialNumber={this.state.invoiceSerialNumber} />
			);

			this.clearPreviewUrl("customerReportPreviewUrl");

			this.setState({
				customerReportPreviewUrl: previewUrl,
				customerReportPreviewLoading: false
			});
		} catch (error) {
			this.setState({
				customerReportPreviewLoading: false
			});
			toast.error("Unable to prepare the customer repair report preview.");
		}
	};

	prepareRepairTravelerPreview = async () => {
		try {
			const previewUrl = await this.createPreviewUrl(
				<GenRepairOrder repairOrderData={this.state.repairOrderData}/>
			);

			this.clearPreviewUrl("repairTravelerPreviewUrl");

			this.setState({
				repairTravelerPreviewUrl: previewUrl,
				repairTravelerPreviewLoading: false
			});
		} catch (error) {
			this.setState({
				repairTravelerPreviewLoading: false
			});
			toast.error("Unable to prepare the repair traveler preview.");
		}
	};

	shippoLabelGenerationStep1 = async () => {

	}

	shippoLabelGenerationStep2 = async () => {

	}

	shippoLabelGenerationStep3 = async () => {

	}

	reteiveShippingLabel = (event) => {
		event.preventDefault();

		this.setState({ shippingLabelErrorStatus: "" });

		console.log("reteiveShippingLabel");
		let shippingDestination = event.target.ShippingDestination.value;
    console.log(`shippingDestination is:`, shippingDestination);
		let boxSize = event.target.BoxSize.value;
    console.log(`boxSize is:`, boxSize);
		let boxWeight = event.target.BoxWeight.value;
    console.log(`boxWeight is:`, boxWeight);

		var validation = true;

		if (boxSize==0) {
			validation = false;
			this.setState({ shippingLabelErrorStatus: "Box Size is Required." });
		} else if (boxWeight==0) {
			validation = false;
			this.setState({ shippingLabelErrorStatus: "Box Weight is Required." });
		}

		if (validation) {
			//this.toggle9();
			this.setState({ shippingRetreivingRates: true });

			if (this.state.isReturnLabel) {
				this.setState({ isReturnLabel:false });
				this.retrieveShippingReturnLabelRates(shippingDestination, boxSize, boxWeight);
			} else {
				this.retrieveShippingLabelRates(shippingDestination, boxSize, boxWeight);
			}

		}

	}

	retrieveShippingLabelRates = async (shippingDestination, boxSize, boxWeight) => {

		//OLD ADDRESS
		// var addressFrom  = {
		//     "name": "Azena Medical",
		//     "street1": "3021 Citrus Circle Suite 180",
		//     "city": "WALNUT CREEK",
		//     "state": "CA",
		//     "zip": "94598",
		//     "country": "US"
		// };

		var addressFrom  = {
		    "name": "Azena Medical, LLC",
		    "street1": "1777 Botelho Drive, Ste 100",
		    "city": "Walnut Creek",
		    "state": "CA",
		    "zip": "94596",
		    "country": "US"
		};

		var addressTo = {
		    "name": document.getElementById("CustomerName").value,
		    "street1": document.getElementById("Address").value,
		    "city": document.getElementById("City").value,
		    "state": document.getElementById("State").value,
		    "zip": document.getElementById("Zip").value,
		    "country": "US"
		};

		if (shippingDestination=="UPI") {
			//document.getElementById("ShippingDestination").value = shippingDestination;
			addressTo = {
			    "name": "Ultradent Products, Inc.",
			    "street1": "505 West Ultradent Drive",
			    "city": "South Jordan",
			    "state": "UT",
			    "zip": "84095",
			    "country": "US"
			};
		}

		var length = "12";
		var width = "12";
		var height = "9";
		var weight = "7";

		if (boxSize==2) {
			length = "13";
			width = "13";
			height = "10";
		} else if (boxSize==3) {
			length = "14";
			width = "14";
			height = "10";
		} else if (boxSize==4) {
			length = "8";
			width = "6";
			height = "6";
		}

		if (boxWeight==2) {
			weight = "13";
		} else if (boxWeight==3) {
			weight = "1";
		}

		var parcel = {
		    "length": length,
		    "width": width,
		    "height": height,
		    "distance_unit": "in",
		    "weight": weight,
		    "mass_unit": "lb"
		};

		var shipment = {
		    "address_from": addressFrom,
		    "address_to": addressTo,
		    "parcels": [parcel],
				"async": false
		};

		var transactionOptions = {
			"shipment": shipment,
			"carrier_account": "bb852771151f44f4b6113dc9364743d7",
			"label_file_type": "PDF"
		};

		//console.log("retrieveShippingLabelRates addressTo: ", JSON.stringify(addressTo));
		//console.log("retrieveShippingLabelRates shipment: ", JSON.stringify(shipment));
		//console.log("retrieveShippingLabelRates parcel: ", JSON.stringify(parcel));

		// shippo.transaction.create(transactionOptions).then(
		// 	transaction => {
		// 		console.log("shippo.transaction.create: ", transaction);
		// 		console.log("shippo.transaction.create: ", JSON.stringify(transaction));
		// 		console.log("Label URL: %s", transaction.label_url);
		// 		console.log("Tracking Number: %s", transaction.tracking_number);
		//
		// 	},
		// 	error => {
		// 		console.log("failed to generate shipping label with exception:", { error });
		//
		// 	}
		// );

		shippo.shipment.create(shipment).then(
			shipmentData => {
				console.log("shippo.shipment.create: ", shipmentData);
				console.log("shippo.shipment.create: ", JSON.stringify(shipmentData));
				console.log("shippo rates: ", JSON.stringify(shipmentData.rates));

				const availableRates = shipmentData.rates.filter(rate => rate.servicelevel.token!="ups_next_day_air_early_am");

				this.setState({
					shippingRetreivingRates: false,
					shippingReceivedRates: true,
					shippoAvailableRates: availableRates,
				});
			},
			error => {
				console.log("failed to generate shipping label with exception:", { error });
			}
		);

	}

	retrieveShippingReturnLabelRates = async (shippingDestination, boxSize, boxWeight) => {

		//OLD ADDRESS
		// var addressTo  = {
		//     "name": "Azena Medical",
		//     "street1": "3021 Citrus Circle Suite 180",
		//     "city": "WALNUT CREEK",
		//     "state": "CA",
		//     "zip": "94598",
		//     "country": "US"
		// };

		var addressTo  = {
		    "name": "Azena Medical, LLC",
		    "street1": "1777 Botelho Drive, Ste 100",
		    "city": "Walnut Creek",
		    "state": "CA",
		    "zip": "94596",
		    "country": "US"
		};

		var addressFrom = {
		    "name": document.getElementById("CustomerName").value,
		    "street1": document.getElementById("Address").value,
		    "city": document.getElementById("City").value,
		    "state": document.getElementById("State").value,
		    "zip": document.getElementById("Zip").value,
		    "country": "US"
		};

		if (shippingDestination=="UPI") {
			//document.getElementById("ShippingDestination").value = shippingDestination;
			addressTo = {
			    "name": "Ultradent Products, Inc.",
			    "street1": "505 West Ultradent Drive",
			    "city": "South Jordan",
			    "state": "UT",
			    "zip": "84095",
			    "country": "US"
			};
		}

		var length = "12";
		var width = "12";
		var height = "9";
		var weight = "7";

		if (boxSize==2) {
			length = "13";
			width = "13";
			height = "10";
		} else if (boxSize==3) {
			length = "14";
			width = "14";
			height = "10";
		} else if (boxSize==4) {
			length = "8";
			width = "6";
			height = "6";
		}

		if (boxWeight==2) {
			weight = "13";
		} else if (boxWeight==3) {
			weight = "1";
		}

		var parcel = {
		    "length": length,
		    "width": width,
		    "height": height,
		    "distance_unit": "in",
		    "weight": weight,
		    "mass_unit": "lb"
		};

		var shipment = {
		    "address_from": addressFrom,
		    "address_to": addressTo,
		    "parcels": [parcel],
				"async": false
		};

		var transactionOptions = {
			"shipment": shipment,
			"carrier_account": "bb852771151f44f4b6113dc9364743d7",
			"label_file_type": "PDF"
		};

		console.log("retrieveShippingReturnLabelRates shipment: ", JSON.stringify(shipment));
		console.log("retrieveShippingReturnLabelRates parcel: ", JSON.stringify(parcel));

		// shippo.transaction.create(transactionOptions).then(
		// 	transaction => {
		// 		console.log("shippo.transaction.create: ", transaction);
		// 		console.log("shippo.transaction.create: ", JSON.stringify(transaction));
		// 		console.log("Label URL: %s", transaction.label_url);
		// 		console.log("Tracking Number: %s", transaction.tracking_number);
		//
		// 	},
		// 	error => {
		// 		console.log("failed to generate shipping label with exception:", { error });
		//
		// 	}
		// );

		shippo.shipment.create(shipment).then(
			shipmentData => {
				console.log("shippo.shipment.create: ", shipmentData);
				console.log("shippo.shipment.create: ", JSON.stringify(shipmentData));
				console.log("shippo rates: ", JSON.stringify(shipmentData.rates));

				const availableRates = shipmentData.rates.filter(rate => rate.servicelevel.token!="ups_next_day_air_early_am");

				this.setState({
					shippingRetreivingRates: false,
					shippingReceivedRates: true,
					shippoAvailableRates: availableRates,
				});
			},
			error => {
				console.log("failed to generate shipping label with exception:", { error });
			}
		);

	}

	selectShippingRate = async (rate) => {
		console.log(`selectShippingRate object_id is:`, rate);

		this.setState({
			shippingRetreivingRates: false,
			shippingReceivedRates: false,
			shippingLabelGenerating: true,
		});
		this.generateShippingLabel(rate);
	}

	generateShippingLabel = async (rate) => {

		var transactionOptions = {
			"rate": rate,
			"label_file_type": "PDF",
			"async": false
		};

		shippo.transaction.create(transactionOptions).then(
			transaction => {
				console.log("shippo.transaction.create: ", JSON.stringify(transaction));
				console.log("Label URL: %s", transaction.label_url);
				console.log("Tracking Number: %s", transaction.tracking_number);

				if (document.getElementById("TrackingCustomer")) {
					console.log("Setting TrackingCustomer");
					document.getElementById("TrackingCustomer").value = transaction.tracking_number;
					document.getElementById("ReturnedDate").value = Moment().utc(false).format('YYYY-MM-DD');
				}

				this.setState({
					shippingLabelURL: transaction.label_url,
					shippingLabelGenerating: false,
					shippingLabelGenerated: true,
				});

				//this.getFileFromUrl(transaction.label_url);
				this.addShippingLabelToRepair(transaction.label_url, 2);
			},
			error => {
				console.log("failed to generate shipping label with exception:", { error });
				//this.loginChat();
				this.setState({
					shippingLabelGenerating: false,
				});

				let msg = "Sorry, failed to generate shipping label. "+error;

				toast.error(msg, {
					position: "top-center",
					autoClose: 3000,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "dark",
					closeButton: false
				});
			}
		);

	}

	getData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-repair-log?RepairLogID="+this.props.repairID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("repair Log: " + JSON.stringify(body));

			this.setState({loading: false});

			if (body.status == 'Success' && body.response.length>0) {
				this.setState({ repairLog: body.response[0] });

				var buf1;
				var buf2;
				var buf3;

				if (body.response[0].Status) {
					console.log("repair Log openedRepairStatus: " + JSON.stringify(body.response[0].Status));
					this.setState({ openedRepairStatus: body.response[0].Status });
				}

				if (body.response[0].DetailedIssue) {
					buf1 = Buffer.from(body.response[0].DetailedIssue, 'utf8');
				}

				if (body.response[0].DetailedRepair) {
					buf2 = Buffer.from(body.response[0].DetailedRepair, 'utf8');
				}

				if (body.response[0].CustomerNotes) {
					buf3 = Buffer.from(body.response[0].CustomerNotes, 'utf8');
				}

				if (buf1) {
					this.setState({ detailedIssue: buf1.toString() });
				}

				if (buf2) {
					this.setState({ detailedRepair: buf2.toString() });
				}

				if (buf3) {
					this.setState({ customerNotes: buf3.toString() });
				}

				if (body.response[0].MediaHash) {
					this.setState({ mediaHash: body.response[0].MediaHash });
				}

				this.getFilesForRepair(0);
				this.getFilesForRepair(1);
				this.getFilesForRepair(2);
				this.getFilesForRepair(3);
				this.getFilesForRepair(4);

				if (body.response[0].ProductName) {
					this.setSerialNumbersForProductName(body.response[0].ProductName);
				}

				if (body.response[0].market!="us" && body.response[0].market!="us-azena") {
					this.setState({ isInternationalRepair: true, market: body.response[0].market });
				}

				this.setState({ loadingRepair: false });

				if (body.response[0].SerialNum) {
					this.getRepairsForSerial(body.response[0].SerialNum);

					if (body.response[0].ProductName) {
						if (body.response[0].ProductName=='EVO') {

							const udiSerial = this.state.evoSerialNumbersAll.filter(serial => serial.SerialNumber.includes(body.response[0].SerialNum));

							//console.log("udiSerial: " + JSON.stringify(udiSerial));

							if (udiSerial.length>0) {

								//console.log("current repairLog: " + JSON.stringify(repairLog));

								if (!body.response[0].BatchNum) {
									var repairLog = JSON.parse(JSON.stringify(body.response[0]));

									//console.log("new repairLog: " + JSON.stringify(repairLog));

									repairLog['BatchNum'] = udiSerial[0].BatchNumber;
									//console.log("new repairLog batch number change: " + JSON.stringify(repairLog));

									this.setState({repairLog});
								}

								let udiCreationDate = udiSerial[0].creation_date;
								let udiKit = udiSerial[0].Kit;
								this.setState({ kitType: udiSerial[0].Kit });
								var udiCode = "00850010501086";
								var udiSerialCode = "G2-5-001";

								if (udiKit.toLowerCase() == "us") {
									udiCode = "00850010501062";
									udiSerialCode = "G2-5-001";
								} else if (udiKit.toLowerCase() == "intl") {
									udiCode = "00850010501079";
									udiSerialCode = "G2-5-002";
								} else if (udiKit.toLowerCase() == "demo") {
									udiCode = "00850010501086";
									udiSerialCode = "G2-5-003";
								} else if (udiKit.toLowerCase() == "brazil") {
									//TODO Add proper values
									udiCode = "00850010501161";
									udiSerialCode = "G2-005-1002";
								}

								let udiFormattedDate = Moment(udiCreationDate).utc(false).format('YYMMDD');
								//console.log("udiSerial EVO formattedDate: " + JSON.stringify(udiFormattedDate));
								//console.log("udiSerial EVO udiCode: " + JSON.stringify(udiCode));

								this.setState({ udiCode: udiCode , udiDate: udiFormattedDate, udiSerialCode: udiSerialCode, warrantyPurchaseDate: udiSerial[0].WarrantyPurchaseDate, warrantyLength: udiSerial[0].WarrantyLength });
							}

						} else {

							const udiSerial = this.getSerialRecordForProduct(body.response[0].ProductName, body.response[0].SerialNum);

							console.log("udiSerial: " + JSON.stringify(udiSerial));

							if (udiSerial) {

								//console.log("current repairLog: " + JSON.stringify(repairLog));

								if (!body.response[0].BatchNum) {
									var repairLog = JSON.parse(JSON.stringify(body.response[0]));

									//console.log("new repairLog: " + JSON.stringify(repairLog));

									repairLog['BatchNum'] = udiSerial.BatchNumber;
									//console.log("new repairLog batch number change: " + JSON.stringify(repairLog));

									this.setState({repairLog});
								}

								if (this.isNovaProductName(body.response[0].ProductName)) {
									const novaUDI = this.getNovaUDIValues(udiSerial, body.response[0].SerialNum);
									this.setState({
										kitType: udiSerial.Kit,
										udiCode: novaUDI.udiCode,
										udiDate: novaUDI.udiDate,
										udiSerialCode: novaUDI.udiSerialCode,
										warrantyPurchaseDate: udiSerial.WarrantyPurchaseDate,
										warrantyLength: udiSerial.WarrantyLength
									});
								} else {
									let udiDate = udiSerial.MFGDate;
									let udiKit = udiSerial.BatchNumber;
									this.setState({ kitType: udiSerial.BatchNumber });
									var udiCode = udiSerial.udiCode;
									var udiSerialCode = udiSerial.SerialCode;

									this.setState({ udiCode: udiCode , udiDate: udiDate, udiSerialCode: udiSerialCode });
								}
							}

						}

					}

				}

			} else {
	      //ADD ERROR MESSAGE
				this.setState({ repairLog: requestBodyExample });
				let msg = "Repair "+this.props.repairID+" Doesn't Exist";

				toast.error(msg, {
					position: "top-center",
					autoClose: 2000,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "dark",
					closeButton: false
				});

				setTimeout(this.goToActiveRepairs, 2000);
				//window.location.href="/active-repairs";

	    }

			console.log("serialNumbers: "+this.state.serialNumbers);

		}
		catch (err) {
			console.log(err);
		}

	};

	getActiveRepairsData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-in-progress-repair-logs";

		// if (this.state.currentUser.payload['custom:market'] && this.state.currentUser.payload['custom:market']!="us" && this.state.currentUser.payload['custom:market']!="us-azena") {
		// 	url = url+"?Market="+this.state.currentUser.payload['custom:market'];
		// } else {
		// 	if (this.state.marketSelect!="all") {
		// 		url = url+"&Market="+this.state.marketSelect;
		// 	}
		// }

		console.log("url: " + url);

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("getActiveRepairsData all activeRepairs: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ activeRepairs: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
			authenticationService.refresh();
		}

	};

	goToActiveRepairs() {
		window.location.href="/active-repairs";
	}

	getPresignedBucketURL = async (section) => {

		this.setState({ isUploadingFile: true });

		var hash = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
		console.log('random hash: ' + hash);

		var contentType = null;
		var fileData = null;
		var fileSize = null;

		if (section==0) {
			console.log("file type: "+this.state.selectedFileOne.type);
			console.log("file size: "+this.state.selectedFileOne.size);
			fileSize = this.state.selectedFileOne.size;
			contentType = this.state.selectedFileOne.type;
			fileData = this.state.selectedFileOne;
		} else if (section==1) {
			console.log("file type: "+this.state.selectedFileTwo.type);
			console.log("file size: "+this.state.selectedFileTwo.size);
			fileSize = this.state.selectedFileTwo.size;
			contentType = this.state.selectedFileTwo.type;
			fileData = this.state.selectedFileTwo;
		} else if (section==2) {
			console.log("file type: "+this.state.selectedFileThree.type);
			console.log("file size: "+this.state.selectedFileThree.size);
			fileSize = this.state.selectedFileThree.size;
			contentType = this.state.selectedFileThree.type;
			fileData = this.state.selectedFileThree;
		} else if (section==3) {
			console.log("file type: "+this.state.selectedFilePurchaseOrder.type);
			console.log("file size: "+this.state.selectedFilePurchaseOrder.size);
			fileSize = this.state.selectedFilePurchaseOrder.size;
			contentType = this.state.selectedFilePurchaseOrder.type;
			fileData = this.state.selectedFilePurchaseOrder;
		} else if (section==4) {
			console.log("file type: "+this.state.selectedFileLoanerReturnLabel.type);
			console.log("file size: "+this.state.selectedFileLoanerReturnLabel.size);
			fileSize = this.state.selectedFileLoanerReturnLabel.size;
			contentType = this.state.selectedFileLoanerReturnLabel.type;
			fileData = this.state.selectedFileLoanerReturnLabel;
		}

		/*if (contentType=="video/quicktime") {
			let sourceVideoFile = fileData;
	    let targetVideoFormat = 'mp4';
	    let convertedVideoDataObjFile = await VideoConverter.convert(sourceVideoFile, targetVideoFormat);

			contentType = "video/mp4";
			console.log("converted file type: "+contentType);

			const data = await fetch(convertedVideoDataObjFile.data);
    	const blob = await data.blob();

			fileData = blob;

		}*/

		const contentTypeArray = contentType.split("/");

		//OLD WAY
		var fileName = this.state.mediaHash+"-"+hash+"."+contentTypeArray[1];

		if (contentTypeArray[1]=="quicktime") {
			fileName = this.state.mediaHash+"-"+hash+".mov";
		}
		console.log('fileName: ' + fileName);

		if (section==3) {
			fileName = this.state.mediaHash+"-"+hash+"-PurchaseOrder.pdf";
		}

		if (section==4) {
			fileName = this.state.mediaHash+"-"+hash+"-LoanerReturnLabel.pdf";
		}

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-presigned-bucket-url?FileName="+fileName+"&ContentType="+contentType;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all getPresignedBucketURL: " + JSON.stringify(body));

			if (body.status == 'Success') {
				let url = body.response;

				this.uploadToS3PresignedURL(section, url, fileName, fileData, contentType);

			} else {
	      //ADD ERROR MESSAGE
				this.setState({ isUploadingFile: false });

				let msg = "Problem Uploading Selected File, Please Try Again.";

				toast.error(msg, {
					position: "top-center",
					autoClose: 4000,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "dark",
					closeButton: false
				});
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	uploadToS3PresignedURL = async (section, url, fileName, fileData, contentType) => {

		console.log("uploadToS3PresignedURL section: " + section);
		console.log("uploadToS3PresignedURL url: " + url);
		console.log("uploadToS3PresignedURL fileName: " + fileName);

		/*var fileData = null;
		var contentType = null;
		var fileSize = null;

		if (section==0) {
			fileSize = this.state.selectedFileOne.size;
			contentType = this.state.selectedFileOne.type;
			fileData = this.state.selectedFileOne;
		} else if (section==1) {
			fileSize = this.state.selectedFileTwo.size;
			contentType = this.state.selectedFileTwo.type;
			fileData = this.state.selectedFileTwo;
		} else if (section==2) {
			fileSize = this.state.selectedFileThree.size;
			contentType = this.state.selectedFileThree.type;
			fileData = this.state.selectedFileThree;
		} else if (section==3) {
			fileSize = this.state.selectedFilePurchaseOrder.size;
			contentType = this.state.selectedFilePurchaseOrder.type;
			fileData = this.state.selectedFilePurchaseOrder;
		}*/

		/*const maxAllowedSize = 10 * 1024 * 1024;
		console.log("max file size: "+maxAllowedSize);

		if (fileSize>maxAllowedSize) {

			let msg = "File is too large. Maximum file size is 10MB.";

			toast.error(msg, {
				position: "top-center",
				autoClose: 4000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "dark",
				closeButton: false
			});
		}*/

		try {
			const options = {
				method: 'PUT',
				body: fileData,
				headers: {
		      'Content-Type': contentType
		    },
			};

			const response = await fetch(url, options);

			//const body = await response.json();
			console.log("uploadToS3PresignedURL upload response: " + JSON.stringify(response));

			if (response.status == '200') {
				console.log("uploadToS3PresignedURL Upload Success!");

				this.setState({ isUploadingFile: false });

				let msg = "Upload Successful!";

				toast.success(msg, {
					position: "top-center",
					autoClose: 3000,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "dark",
					closeButton: false
				});

				if (section==3) {
					this.addFileToRepair(fileName, section);
					// if (this.state.purchaseOrderFiles.length==0) {
					// 	//this.addFileToRepair(fileName, section);
					// } else {
					// 	document.getElementById("filePurchaseOrder").value = null;
					// 	this.setState({ filePreviewPurchaseOrder: null, loadedPurchaseOrder: false });
					// }
				} else {
					this.addFileToRepair(fileName, section);
				}
			} else {
				//ADD ERROR MESSAGE
				this.setState({ isUploadingFile: false });

				let msg = "Problem Uploading Selected File, Please Try Again.";

				toast.error(msg, {
					position: "top-center",
					autoClose: 4000,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "dark",
					closeButton: false
				});
			}
		}
		catch (err) {
			console.log("uploadToS3 error: "+err);
			this.setState({ isUploadingFile: false });

			let msg = "Problem Uploading Selected File, Please Try Again.";

			toast.error(msg, {
				position: "top-center",
				autoClose: 4000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "dark",
				closeButton: false
			});
		}
	}

	// getCustomerNotesData = async () => {
	//
	// 	var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-customer-notes?ProductID="+this.state.selectedProductName;
	//
	// 	const response = await fetch(url, {
	// 		method: 'GET',
	// 		headers: {
	// 			Authorization: this.state.currentUser.jwtToken
	// 		},
	// 	});
	//
	// 	const body = await response.json();
	// 	console.log("all repairCustomerNotes: " + JSON.stringify(body));
	//
	// 	if (body.status == 'Success') {
	// 		this.setState({ repairCustomerNotes: body.response });
	// 	} else {
  //     //ADD ERROR MESSAGE
  //   }
	//
	// };

	getCustomerNotesData = async () => {

		var marketID = 100;

		if (this.state.market=="europe") {
			marketID = 1;
		} else if (this.state.market=="aus") {
			marketID = 2;
		} else if (this.state.market=="brazil") {
			marketID = 3;
		} else if (this.state.market=="taiwan") {
			marketID = 4;
		} else if (this.state.market=="colombia") {
			marketID = 5;
		} else if (this.state.market=="mexico") {
			marketID = 6;
		} else if (this.state.market=="czech") {
			marketID = 7;
		}

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-customer-notes?ProductID="+this.state.selectedProductName;

		if (marketID != 100) {
			url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-customer-notes?ProductID="+this.state.selectedProductName+"&MarketID="+marketID;
		}

		console.log("getCustomerNotesData url: " + url);

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all repairCustomerNotes: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ repairCustomerNotes: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	createRepairHistoryLog = async (logData) => {

		// let logData = {
		// 	FullName: dealerID,
		// 	Market: name,
		// 	LogType: logType,
		// 	ButtonSection: phone,
		// 	RepairID: repairID,
		// }

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"create-repair-history-log";

		console.log("createRepairHistoryLog url: " + url);

		try {

			const response = await fetch(url, {
				method: 'POST',
				headers: {
					Authorization: this.state.currentUser.jwtToken,
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(logData)
			});

			const body = await response.json();
			console.log("createRepairHistoryLog response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				//this.setState({ dealerData: body.response });
			} else {
				//ADD ERROR MESSAGE
			}

		}
		catch (err) {
			console.log(err);
		}

	};

	getAndShowRepairHistoryLogs = async () => {
		await this.getRepairHistoryLogs();
		this.setState({ modal13: true });
	}

	getRepairHistoryLogs = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-repair-history-logs?RepairID="+this.props.repairID;

		console.log("getRepairHistoryLogs url: " + url);

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all getRepairHistoryLogs: " + JSON.stringify(body));

			if (body.status == 'Success') {

				var repairHistoryLogs = body.response;

				this.setState({ repairHistoryLogs });

				var initialSaveLabel = "";
				var latestUpdateLabel = "";

				if (body.response.length > 0) {
					latestUpdateLabel = repairHistoryLogs[0].TechFullName + " | " + Moment(repairHistoryLogs[0].Timestamp).utc(false).format('MM-DD-YYYY');
					initialSaveLabel = repairHistoryLogs[repairHistoryLogs.length-1].TechFullName + " | " + Moment(repairHistoryLogs[repairHistoryLogs.length-1].Timestamp).utc(false).format('MM-DD-YYYY');

					this.setState({ initialSaveLabel, latestUpdateLabel });
				}

			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	logRepairViewCount = async (repairLogID) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"log-repair-view-count?RepairLogID="+repairLogID;

		console.log("getDealerData url: " + url);

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all logRepairViewCount: " + JSON.stringify(body));

			if (body.status == 'Success') {
				//this.setState({ dealerData: body.response });
			} else {
				//ADD ERROR MESSAGE
			}

		}
		catch (err) {
			console.log(err);
		}

	};

	getDealerData = async () => {

		var marketID = 100;

		if (this.state.market=="europe") {
			marketID = 1;
		} else if (this.state.market=="aus") {
			marketID = 2;
		} else if (this.state.market=="brazil") {
			marketID = 3;
		} else if (this.state.market=="taiwan") {
			marketID = 4;
		} else if (this.state.market=="colombia") {
			marketID = 5;
		} else if (this.state.market=="mexico") {
			marketID = 6;
		} else if (this.state.market=="czech") {
			marketID = 7;
		}

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-dealers?MarketID="+marketID;

		console.log("getDealerData url: " + url);

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all getDealerData: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ dealerData: body.response });
			} else {
				//ADD ERROR MESSAGE
			}

		}
		catch (err) {
			console.log(err);
		}

	};

	getTAMData = async () => {

		var marketID = 100;

		if (this.state.market=="europe") {
			marketID = 1;
		} else if (this.state.market=="aus") {
			marketID = 2;
		} else if (this.state.market=="brazil") {
			marketID = 3;
		} else if (this.state.market=="taiwan") {
			marketID = 4;
		} else if (this.state.market=="colombia") {
			marketID = 5;
		} else if (this.state.market=="mexico") {
			marketID = 6;
		} else if (this.state.market=="czech") {
			marketID = 7;
		}

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-tam-names?MarketID="+marketID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all TAM data: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ tamData: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	getBOMData = async () => {

		var marketID = 100;

		if (this.state.market=="us") {
			marketID = 0;
		} else if (this.state.market=="europe") {
			marketID = 1;
		} else if (this.state.market=="aus") {
			marketID = 2;
		} else if (this.state.market=="brazil") {
			marketID = 3;
		} else if (this.state.market=="taiwan") {
			marketID = 4;
		} else if (this.state.market=="colombia") {
			marketID = 5;
		} else if (this.state.market=="mexico") {
			marketID = 6;
		} else if (this.state.market=="czech") {
			marketID = 7;
		}

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-bill-of-materials?ProductID="+this.state.selectedProductName;

		if (marketID != 100) {
			url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-bill-of-materials?ProductID="+this.state.selectedProductName+"&MarketID="+marketID;
			//url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-quote-items?ProductID="+this.state.selectedProductName+"&MarketID="+marketID;
		}

		console.log("getBOMData url: " + url);

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all BOM data: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ bomData: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	getProductsData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-products";

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all Products data: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ productsData: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	getCategoryItemsForRepairData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-category-items-for-repair?RepairID="+this.props.repairID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all categoryItemsForRepair data: " + JSON.stringify(body));

			if (body.status == 'Success') {

				if (body.response.length>0) {

					var categoryItems = body.response;

					if (categoryItems.length<this.state.categoryItemsForRepair.length) {
						let startPoint = categoryItems.length;

						for (var i=startPoint; i<this.state.categoryItemsForRepair.length; i++) {
							let categoryItem = this.state.categoryItemsForRepair[i];
							categoryItems.push(categoryItem);
						}
					}

					this.setState({ categoryItemsForRepair: categoryItems });
				} else {

					let cIFR = [{
						id: null,
						RepairID: 0,
						CategoryItemID: 0,
						CustomerCaused: 100
					}];
					console.log("all category cIFR data: " + JSON.stringify(cIFR));
					this.setState({ categoryItemsForRepair: cIFR });
				}

			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	addCategoryItemForRepair = async () => {

		var categoryItemsForRepair = JSON.parse(JSON.stringify(this.state.categoryItemsForRepair));

		let cIFR = {
			id: null,
			RepairID: 0,
			CategoryItemID: 0,
			CustomerCaused: 100
		};

		categoryItemsForRepair.push(cIFR);
		this.setState({ categoryItemsForRepair });

	}

	saveAllCategoryItems = async () => {

		this.setState({ isSavingReasons: true });

		for (var i=0; i<this.state.categoryItemsForRepair.length; i++) {
			var categoryItem = this.state.categoryItemsForRepair[i];

			if (categoryItem.id==null && categoryItem.Quantity!=0) {
				await this.createCategoryItemForRepair(i);
			}
		}

		this.setState({ isSavingReasons: false });

	}

	createCategoryItemForRepair = async (i) => {

		var categoryItem = this.state.categoryItemsForRepair[i];

		if (categoryItem.id==null && categoryItem.CustomerCaused!=100) {
			var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"add-category-item-for-repair?RepairID="+categoryItem.RepairID+"&CategoryItemID="+categoryItem.CategoryItemID+"&CustomerCaused="+categoryItem.CustomerCaused;

			try {

				const response = await fetch(url, {
					method: 'GET',
					headers: {
						Authorization: this.state.currentUser.jwtToken
					},
				});

				const body = await response.json();
				console.log("new component data response: " + JSON.stringify(body));

				if (body.status == 'Success') {
					//this.setState({ quoteData: body.response });
					var categoryItemsForRepair = JSON.parse(JSON.stringify(this.state.categoryItemsForRepair));
					categoryItemsForRepair[i].id = body.response.insertId;
					this.setState({categoryItemsForRepair});
					//this.getQuoteItemsForRepairData();

					console.log("id value: " + categoryItem.CategoryItemID);

					// const result = this.state.bomData.filter(bom => bom.id==componentItem.ComponentItemID);
					//
					// console.log("Quantity: " + result[0].Quantity);
					//
					// var startValue = result[0].Quantity;
					//
					// console.log("Start Value: " + startValue);
					//
					// console.log("Used Quantity: " + componentItem.Quantity);
					//
					// var revisedQuantity = startValue;
					//
					// revisedQuantity = parseInt(startValue) - parseInt(componentItem.Quantity);
					//
					// console.log("revised Quantity: " + revisedQuantity);
					//
					// this.updateBOM(result[0], revisedQuantity);
				} else {
		      //ADD ERROR MESSAGE
		    }

			}
			catch (err) {
				console.log(err);
			}

		} else {
			toast.error('Please select a User Caused option.', {
				position: "top-center",
				autoClose: 3000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "dark",
				closeButton: false
			});
		}

	};

	deleteCategoryItemForRepair = async (i) => {

		var categoryItem = this.state.categoryItemsForRepair[i];

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-category-item-for-repair?CifrID="+categoryItem.id;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("delete category data response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				var categoryItemsForRepair = JSON.parse(JSON.stringify(this.state.categoryItemsForRepair));
				//quoteItemsForRepair[i].id = body.response.insertId;
				categoryItemsForRepair.splice(i,1);
				this.setState({categoryItemsForRepair});
				//this.getQuoteItemsForRepairData();

				console.log("id value: " + categoryItem.CategoryItemID);

				// const result = this.state.bomData.filter(bom => bom.id==componentItem.ComponentItemID);
				//
				// console.log("Quantity: " + result[0].Quantity);
				//
				// var startValue = result[0].Quantity;
				//
				// console.log("Start Value: " + startValue);
				//
				// console.log("Used Quantity: " + componentItem.Quantity);
				//
				// var revisedQuantity = startValue;
				//
				// revisedQuantity = parseInt(startValue) + parseInt(componentItem.Quantity);
				//
				// console.log("revised Quantity: " + revisedQuantity);
				//
				// this.updateBOM(result[0], revisedQuantity);
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	getComponentItemsForRepairData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-component-items-for-repair?RepairID="+this.props.repairID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all componentItemsForRepair data: " + JSON.stringify(body));

			if (body.status == 'Success') {

				if (body.response.length>0) {

					var componentItems = body.response;

					if (componentItems.length<this.state.componentItemsForRepair.length) {
						let startPoint = componentItems.length;

						for (var i=startPoint; i<this.state.componentItemsForRepair.length; i++) {
							let componentItem = this.state.componentItemsForRepair[i];
							componentItems.push(componentItem);
						}
					}

					this.setState({ componentItemsForRepair: componentItems });
				} else {

					let cIFR = [{
						id: null,
						RepairID: 0,
						ComponentItemID: 0,
						Quantity: 0
					}];
					console.log("all cIFR data: " + JSON.stringify(cIFR));
					this.setState({ componentItemsForRepair: cIFR });
				}

			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	addComponentItemForRepair = async () => {

		var componentItemsForRepair = JSON.parse(JSON.stringify(this.state.componentItemsForRepair));

		let cIFR = {
			id: null,
			RepairID: 0,
			ComponentItemID: 0,
			Quantity: 0
		};

		componentItemsForRepair.push(cIFR);
		this.setState({ componentItemsForRepair });

	}

	saveAllComponentItems = async () => {

		this.setState({ isSavingComponents: true });

		for (var i=0; i<this.state.componentItemsForRepair.length; i++) {
			var componentItem = this.state.componentItemsForRepair[i];

			if (componentItem.id==null && componentItem.Quantity!=0) {
				await this.createComponentItemForRepair(i);
			}
		}

		this.setState({ isSavingComponents: false });

	}

	createComponentItemForRepair = async (i) => {

		var componentItem = this.state.componentItemsForRepair[i];

		if (componentItem.id==null && componentItem.Quantity!=0) {
			var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"add-component-item-for-repair?RepairID="+componentItem.RepairID+"&ComponentItemID="+componentItem.ComponentItemID+"&Quantity="+componentItem.Quantity;

			try {

				const response = await fetch(url, {
					method: 'GET',
					headers: {
						Authorization: this.state.currentUser.jwtToken
					},
				});

				const body = await response.json();
				console.log("new component data response: " + JSON.stringify(body));

				if (body.status == 'Success') {
					//this.setState({ quoteData: body.response });
					var componentItemsForRepair = JSON.parse(JSON.stringify(this.state.componentItemsForRepair));
					componentItemsForRepair[i].id = body.response.insertId;
					this.setState({componentItemsForRepair});
					//this.getQuoteItemsForRepairData();

					console.log("id value: " + componentItem.ComponentItemID);

					const result = this.state.bomData.filter(bom => bom.id==componentItem.ComponentItemID);

					console.log("Quantity: " + result[0].Quantity);

					var startValue = result[0].Quantity;

					console.log("Start Value: " + startValue);

					console.log("Used Quantity: " + componentItem.Quantity);

					var revisedQuantity = startValue;

					revisedQuantity = parseInt(startValue) - parseInt(componentItem.Quantity);

					console.log("revised Quantity: " + revisedQuantity);

					this.updateBOM(result[0], revisedQuantity);

					// if (!this.state.isInternationalRepair) {
					// 	this.updateBOM(result[0], revisedQuantity);
					// }
				} else {
		      //ADD ERROR MESSAGE
		    }

			}
			catch (err) {
				console.log(err);
			}

		}

	};

	deleteComponentItemForRepair = async (i) => {

		var componentItem = this.state.componentItemsForRepair[i];

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-component-item-for-repair?CifrID="+componentItem.id;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("delete component data response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				var componentItemsForRepair = JSON.parse(JSON.stringify(this.state.componentItemsForRepair));
				//quoteItemsForRepair[i].id = body.response.insertId;
				componentItemsForRepair.splice(i,1);
				this.setState({componentItemsForRepair});
				//this.getQuoteItemsForRepairData();

				console.log("id value: " + componentItem.ComponentItemID);

				const result = this.state.bomData.filter(bom => bom.id==componentItem.ComponentItemID);

				console.log("Quantity: " + result[0].Quantity);

				var startValue = result[0].Quantity;

				console.log("Start Value: " + startValue);

				console.log("Used Quantity: " + componentItem.Quantity);

				var revisedQuantity = startValue;

				revisedQuantity = parseInt(startValue) + parseInt(componentItem.Quantity);

				console.log("revised Quantity: " + revisedQuantity);

				this.updateBOM(result[0], revisedQuantity);

			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	// getQuoteData = async () => {
	//
	// 	var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-quote-items?ProductID="+this.state.selectedProductName;
	//
	// 	const response = await fetch(url, {
	// 		method: 'GET',
	// 		headers: {
	// 			Authorization: this.state.currentUser.jwtToken
	// 		},
	// 	});
	//
	// 	const body = await response.json();
	// 	console.log("all Quote data: " + JSON.stringify(body));
	//
	// 	if (body.status == 'Success') {
	// 		this.setState({ quoteData: body.response });
	// 	} else {
  //     //ADD ERROR MESSAGE
  //   }
	//
	// };

	getQuoteData = async () => {

		var marketID = 100;

		if (this.state.market=="us") {
			marketID = 0;
		} else if (this.state.market=="europe") {
			marketID = 1;
		} else if (this.state.market=="aus") {
			marketID = 2;
		} else if (this.state.market=="brazil") {
			marketID = 3;
		} else if (this.state.market=="taiwan") {
			marketID = 4;
		} else if (this.state.market=="colombia") {
			marketID = 5;
		} else if (this.state.market=="mexico") {
			marketID = 6;
		} else if (this.state.market=="czech") {
			marketID = 7;
		}

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-quote-items?ProductID="+this.state.selectedProductName;

		if (marketID != 100) {
			url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-quote-items?ProductID="+this.state.selectedProductName+"&MarketID="+marketID;
		}

		console.log("getQuoteData url: " + url);

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all Quote data: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ quoteData: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	getQuoteItemsForRepairData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-quote-items-for-repair?RepairID="+this.props.repairID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all QuoteItemsForRepair data: " + JSON.stringify(body));

			if (body.status == 'Success') {

				if (body.response.length>0) {

					var quoteItems = body.response;

					if (quoteItems.length<this.state.quoteItemsForRepair.length) {
						let startPoint = quoteItems.length;

						for (var i=startPoint; i<this.state.quoteItemsForRepair.length; i++) {
							let quoteItem = this.state.quoteItemsForRepair[i];
							quoteItems.push(quoteItem);
						}
					}

					this.setState({ quoteItemsForRepair: quoteItems });
				} else {

					let qIFR = [{
						id: null,
						RepairID: 0,
						QuoteItemID: 0,
						Quantity: 0,
						Optional: 0
					}];
					console.log("all qIFR data: " + JSON.stringify(qIFR));
					this.setState({ quoteItemsForRepair: qIFR });
				}

			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	addQuoteItemForRepair = async () => {

		var quoteItemsForRepair = JSON.parse(JSON.stringify(this.state.quoteItemsForRepair));

		let qIFR = {
			id: null,
			RepairID: 0,
			QuoteItemID: 0,
			Quantity: 0,
			Optional: 0
		};

		quoteItemsForRepair.push(qIFR);
		this.setState({ quoteItemsForRepair });

	}

	saveAllQuoteItems = async () => {

		this.setState({ isSavingQuotes: true });

		for (var i=0; i<this.state.quoteItemsForRepair.length; i++) {
			var quoteItem = this.state.quoteItemsForRepair[i];

			if (quoteItem.id==null && quoteItem.Quantity!=0) {
				await this.createQuoteItemForRepair(i);
			}
		}

		this.setState({ isSavingQuotes: false });

	}

	createQuoteItemForRepair = async (i) => {

		var quoteItem = this.state.quoteItemsForRepair[i];
		console.log("new Quote item: " + JSON.stringify(quoteItem));

		if (quoteItem.id==null && quoteItem.Quantity!=0) {
			var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"add-quote-item-for-repair?RepairID="+quoteItem.RepairID+"&QuoteItemID="+quoteItem.QuoteItemID+"&Quantity="+quoteItem.Quantity+"&Optional="+quoteItem.Optional;

			try {

				const response = await fetch(url, {
					method: 'GET',
					headers: {
						Authorization: this.state.currentUser.jwtToken
					},
				});

				const body = await response.json();
				console.log("new Quote data response: " + JSON.stringify(body));

				if (body.status == 'Success') {
					//this.setState({ quoteData: body.response });
					var quoteItemsForRepair = JSON.parse(JSON.stringify(this.state.quoteItemsForRepair));
					quoteItemsForRepair[i].id = body.response.insertId;
					this.setState({quoteItemsForRepair});
					//this.getQuoteItemsForRepairData();
				} else {
		      //ADD ERROR MESSAGE
		    }

			}
			catch (err) {
				console.log(err);
			}

		}

	};

	deleteQuoteItemForRepair = async (i) => {

		var quoteItem = this.state.quoteItemsForRepair[i];

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-quote-item-for-repair?QifrID="+quoteItem.id;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("delete Quote data response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				var quoteItemsForRepair = JSON.parse(JSON.stringify(this.state.quoteItemsForRepair));
				//quoteItemsForRepair[i].id = body.response.insertId;
				quoteItemsForRepair.splice(i,1);
				this.setState({quoteItemsForRepair});
				//this.getQuoteItemsForRepairData();
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	getCategoryData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-repair-categories?ProductID="+this.state.selectedProductName;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all repairCategories: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ repairCategories: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	getOptionsData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-repair-options";

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all repairOptions: " + JSON.stringify(body));

			if (body.status == 'Success') {
				this.setState({ repairOptions: body.response });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	getRepairsForSerial = async (serial) => {

		const selectedProduct = this.state.productsData.find(product => product.id==this.state.selectedProductName);

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-repairs-for-device?SerialNumber="+serial;

		if (selectedProduct) {
			url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-repairs-for-device?SerialNumber="+serial+"&ProductName="+selectedProduct.Name;
		}

		console.log("getRepairsForSerial url: " + url);

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all repairs for device: " + JSON.stringify(body));

			if (body.status == 'Success') {

				this.setState({ deviceRepairs: body.response });

			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	formatSerialNumbers = (serials) => {
		const revisedSerials = [];
		serials.map((serial, i) => {
			if (serial.SerialNumber.includes('EL-')) {
				var revisedSerial = serial.SerialNumber.substring(serial.SerialNumber.length - 5)
				revisedSerials.push(String(revisedSerial));
			} else {
				revisedSerials.push(String(serial.SerialNumber));
			}
		});
		return revisedSerials;
	};

	getSerialProductID = (serial) => {
		const productID = serial.Product || serial.product || serial.ProductID || serial.productID || serial.productid || serial.ProductId || serial.productId || serial.product_id || serial.Product_ID || serial.productID_fk || serial.ProductID_fk || serial.SerialProductID || serial.serialProductID;
		return productID === undefined || productID === null ? "" : String(productID).trim();
	};

	getSerialProductName = (serial) => {
		return String(serial.ProductName || serial.productName || serial.productname || serial.Name || serial.name || "").trim().toLowerCase();
	};

	getAllSerialRows = (body) => {
		if (Array.isArray(body)) {
			return body;
		}
		return body.results || body.response || body.serials || [];
	};

	hasAllSerialRows = (body) => {
		return this.getAllSerialRows(body).length>0;
	};

	isNonEvoAllSerialProduct = (serial) => {
		const serialProductID = this.getSerialProductID(serial);
		const serialProductName = this.getSerialProductName(serial);
		return serialProductID==2 || serialProductID==3 || serialProductID==99 || serialProductName=="nova" || serialProductName=="vision" || serialProductName=="recovery";
	};

	isNovaAllSerialProduct = (serial) => {
		return this.getSerialProductID(serial)==2 || this.getSerialProductName(serial)=="nova";
	};

	isNovaProductName = (productName) => {
		return String(productName).trim().toLowerCase()=="nova";
	};

	getNovaUDIValues = (serialRecord, serialNumber) => {
		const kit = String(serialRecord && serialRecord.Kit ? serialRecord.Kit : "").trim().toLowerCase();
		let gtin = "00000000000000";
		let pn = "N/A";

		if (kit=="us") {
			gtin = "00850010501345";
			pn = "6351";
		} else if (kit=="intl") {
			gtin = "00850010501369";
			pn = "6352";
		} else if (kit=="demo") {
			gtin = "00850010501352";
			pn = "6353";
		} else if (kit=="brazil") {
			gtin = "00850010501161";
			pn = "9121-P2";
		}

		return {
			udiCode: gtin,
			udiSerialCode: pn,
			udiDate: serialRecord && serialRecord.creation_date ? Moment(serialRecord.creation_date).utc(false).format('YYMMDD') : "",
			upi: serialNumber
		};
	};

	setSerialNumbersForProductID = (productID, productName = "") => {
		const normalizedProductName = String(productName).trim().toLowerCase();
		if (productID==1) {
			this.setState({serialNumbers: this.state.g1SerialNumbers, selectedProductName: productID});
		} else if (productID==2 && normalizedProductName!="nova") {
			this.setState({serialNumbers: this.state.evoSerialNumbers, selectedProductName: productID});
		} else if (productID==3 || normalizedProductName=="nova") {
			this.setState({serialNumbers: this.state.novaSerialNumbers, selectedProductName: productID});
			if (this.state.novaSerialNumbers.length==0) {
				this.getNovaSerialNumbersData(true);
			}
		} else {
			this.setState({serialNumbers: [], selectedProductName: productID});
		}
	};

	setSerialNumbersForProductName = (productName) => {
		const selectedProduct = findProductByName(this.state.productsData, productName);
		if (selectedProduct) {
			this.setSerialNumbersForProductID(selectedProduct.id, selectedProduct.Name);
		}
	};

	getSerialRecordForProduct = (productName, serialNumber) => {
		const selectedProduct = findProductByName(this.state.productsData, productName);
		const productID = selectedProduct ? selectedProduct.id : this.state.selectedProductName;
		const normalizedProductName = String(productName).trim().toLowerCase();
		let serials = this.state.serialNumbersAll;

		if (productID==2 && normalizedProductName!="nova") {
			serials = this.state.evoSerialNumbersAll;
		} else if (productID==3 || normalizedProductName=="nova") {
			serials = this.state.novaSerialNumbersAll;
		}

		if (productID==2 && normalizedProductName!="nova") {
			const results = serials.filter(serial => serial.SerialNumber.includes(serialNumber));
			return results.length>0 ? results[0] : null;
		}

		return serials.find(serial => serial.SerialNumber.includes(serialNumber));
	};

	getSelectedSerialNumber = () => {
		var selectedSerialNumber = this.state.repairLog.SerialNum || "";
		const serialInput = document.getElementById("SerialNum");

		if (!selectedSerialNumber && serialInput && serialInput.value) {
			selectedSerialNumber = serialInput.value;
		}

		if (selectedSerialNumber) {
			selectedSerialNumber = selectedSerialNumber.replace(' EVO', '');
		}

		return selectedSerialNumber;
	};

	getElementValue = (id, fallback = "N/A") => {
		const element = document.getElementById(id);
		return element ? element.value : fallback;
	};

	getEvoSerialNumbersData = async () => {

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com/v1/all-serials?ProductID=1";

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all evo serials: " + JSON.stringify(body));

			if (body.status == 'Success' || this.hasAllSerialRows(body)) {

				var serials = this.getAllSerialRows(body).filter(serial => !this.isNonEvoAllSerialProduct(serial));

				const revisedSerials = [];
				serials.map((serial, i) => {

					revisedSerials.push(String(serial.SerialNumber+" EVO"));

				});

				console.log("revised serial Numbers evo: " + JSON.stringify(revisedSerials));

				this.setState({ evoSerialNumbers: revisedSerials, evoSerialNumbersAll: serials });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	getNovaSerialNumbersData = async (activateList = false) => {

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com/v1/all-serials?ProductID=2";

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all Nova serial Numbers: " + JSON.stringify(body));

			if (body.status == 'Success' || this.hasAllSerialRows(body)) {

				var serials = this.getAllSerialRows(body).filter(serial => this.isNovaAllSerialProduct(serial));
				console.log("filtered Nova serial count: " + serials.length);
				const revisedSerials = [];
				serials.map((serial, i) => {
					revisedSerials.push(String(serial.SerialNumber));
				});

				console.log("revised Nova serial Numbers: " + JSON.stringify(revisedSerials));

				this.setState({ novaSerialNumbersAll: serials, novaSerialNumbers: revisedSerials });
				if (activateList) {
					this.setState({ serialNumbers: revisedSerials });
				}
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	getSerialNumbersData = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-serial-numbers?ProductID=1";

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("all serial Numbers: " + JSON.stringify(body));

			if (body.status == 'Success') {

				var serials = body.response;

				const revisedSerials = this.formatSerialNumbers(serials);

				console.log("revised serial Numbers: " + JSON.stringify(revisedSerials));

				this.setState({ serialNumbersAll: serials, g1SerialNumbers: revisedSerials });
			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	generateInvoice = async () => {

		var issueBOM1 = document.getElementById("IssueBOM1").value;
		console.log("issueBOM1: " + issueBOM1);
		var issueBOM2 = document.getElementById("IssueBOM2").value;
		console.log("issueBOM2: " + issueBOM2);
		var issueBOM3 = document.getElementById("IssueBOM3").value;
		console.log("issueBOM3: " + issueBOM3);
		var issueBOM4 = document.getElementById("IssueBOM4").value;
		console.log("issueBOM4: " + issueBOM4);
		var issueBOM5 = document.getElementById("IssueBOM5").value;
		console.log("issueBOM5: " + issueBOM5);
		var issueBOM6 = document.getElementById("IssueBOM6").value;
		console.log("issueBOM6: " + issueBOM6);
		var issueBOM1Quantity = document.getElementById("IssueBOM1Quantity").value;
		console.log("issueBOM1Quantity: " + issueBOM1Quantity);
		var issueBOM2Quantity = document.getElementById("IssueBOM2Quantity").value;
		console.log("issueBOM2Quantity: " + issueBOM2Quantity);
		var issueBOM3Quantity = document.getElementById("IssueBOM3Quantity").value;
		console.log("issueBOM3Quantity: " + issueBOM3Quantity);
		var issueBOM4Quantity = document.getElementById("IssueBOM4Quantity").value;
		console.log("issueBOM4Quantity: " + issueBOM4Quantity);
		var issueBOM5Quantity = document.getElementById("IssueBOM5Quantity").value;
		console.log("issueBOM5Quantity: " + issueBOM5Quantity);
		var issueBOM6Quantity = document.getElementById("IssueBOM6Quantity").value;
		console.log("issueBOM6Quantity: " + issueBOM6Quantity);

		var invoiceArray = [];
		var invoiceTotal = 0;

		if (issueBOM1Quantity>0) {

			const result = this.state.bomData.filter(bom => bom.id==issueBOM1);

			var total = parseInt(result[0].Cost)*parseInt(issueBOM1Quantity);

			var invoiceRow = {
				PartNumber: result[0].PartNumber,
				Description: result[0].Description,
				Cost: "$"+result[0].Cost,
				Quantity: issueBOM1Quantity,
				Total: "$"+total
			}

			if (issueBOM1Quantity=="100") {

				total = 0;

				invoiceRow = {
					PartNumber: result[0].PartNumber,
					Description: result[0].Description,
					Cost: "Complimentary",
					Quantity: 1,
					Total: "$0"
				}
			}

			invoiceTotal = invoiceTotal+total;

			console.log("invoiceRow: " + JSON.stringify(invoiceRow));
			invoiceArray.push(invoiceRow);
		}

		if (issueBOM2Quantity>0) {
			const result = this.state.bomData.filter(bom => bom.id==issueBOM2);

			var total = parseInt(result[0].Cost)*parseInt(issueBOM2Quantity);

			var invoiceRow = {
				PartNumber: result[0].PartNumber,
				Description: result[0].Description,
				Cost: "$"+result[0].Cost,
				Quantity: issueBOM2Quantity,
				Total: "$"+total
			}

			if (issueBOM2Quantity=="100") {

				total = 0;

				invoiceRow = {
					PartNumber: result[0].PartNumber,
					Description: result[0].Description,
					Cost: "Complimentary",
					Quantity: 1,
					Total: "$0"
				}
			}

			invoiceTotal = invoiceTotal+total;

			console.log("invoiceRow: " + JSON.stringify(invoiceRow));
			invoiceArray.push(invoiceRow);
		}

		if (issueBOM3Quantity>0) {
			const result = this.state.bomData.filter(bom => bom.id==issueBOM3);

			var total = parseInt(result[0].Cost)*parseInt(issueBOM3Quantity);

			var invoiceRow = {
				PartNumber: result[0].PartNumber,
				Description: result[0].Description,
				Cost: "$"+result[0].Cost,
				Quantity: issueBOM3Quantity,
				Total: "$"+total
			}

			if (issueBOM3Quantity=="100") {

				total = 0;

				invoiceRow = {
					PartNumber: result[0].PartNumber,
					Description: result[0].Description,
					Cost: "Complimentary",
					Quantity: 1,
					Total: "$0"
				}
			}

			invoiceTotal = invoiceTotal+total;

			console.log("invoiceRow: " + JSON.stringify(invoiceRow));
			invoiceArray.push(invoiceRow);
		}

		if (issueBOM4Quantity>0) {
			const result = this.state.bomData.filter(bom => bom.id==issueBOM4);

			var total = parseInt(result[0].Cost)*parseInt(issueBOM4Quantity);

			var invoiceRow = {
				PartNumber: result[0].PartNumber,
				Description: result[0].Description,
				Cost: "$"+result[0].Cost,
				Quantity: issueBOM4Quantity,
				Total: "$"+total
			}

			if (issueBOM4Quantity=="100") {

				total = 0;

				invoiceRow = {
					PartNumber: result[0].PartNumber,
					Description: result[0].Description,
					Cost: "Complimentary",
					Quantity: 1,
					Total: "$0"
				}
			}

			invoiceTotal = invoiceTotal+total;

			console.log("invoiceRow: " + JSON.stringify(invoiceRow));
			invoiceArray.push(invoiceRow);
		}

		if (issueBOM5Quantity>0) {
			const result = this.state.bomData.filter(bom => bom.id==issueBOM5);

			var total = parseInt(result[0].Cost)*parseInt(issueBOM5Quantity);

			var invoiceRow = {
				PartNumber: result[0].PartNumber,
				Description: result[0].Description,
				Cost: "$"+result[0].Cost,
				Quantity: issueBOM5Quantity,
				Total: "$"+total
			}

			if (issueBOM5Quantity=="100") {

				total = 0;

				invoiceRow = {
					PartNumber: result[0].PartNumber,
					Description: result[0].Description,
					Cost: "Complimentary",
					Quantity: 1,
					Total: "$0"
				}
			}

			invoiceTotal = invoiceTotal+total;

			console.log("invoiceRow: " + JSON.stringify(invoiceRow));
			invoiceArray.push(invoiceRow);
		}

		if (issueBOM6Quantity>0) {
			const result = this.state.bomData.filter(bom => bom.id==issueBOM6);

			var total = parseInt(result[0].Cost)*parseInt(issueBOM6Quantity);

			var invoiceRow = {
				PartNumber: result[0].PartNumber,
				Description: result[0].Description,
				Cost: "$"+result[0].Cost,
				Quantity: issueBOM6Quantity,
				Total: "$"+total
			}

			if (issueBOM6Quantity=="100") {

				total = 0;

				invoiceRow = {
					PartNumber: result[0].PartNumber,
					Description: result[0].Description,
					Cost: "Complimentary",
					Quantity: 1,
					Total: "$0"
				}
			}

			invoiceTotal = invoiceTotal+total;

			console.log("invoiceRow: " + JSON.stringify(invoiceRow));
			invoiceArray.push(invoiceRow);
		}

		console.log("invoiceArray: " + JSON.stringify(invoiceArray));

		//var code = Math.floor(100000 + Math.random() * 900000);
		var code = this.props.repairID+"_Quote";
		console.log("random code: "+code);

		console.log("invoiceTotal: "+invoiceTotal);

		var invoiceFormattedTotal = "$"+invoiceTotal;

		//var customerNotes = document.getElementById("customerNotes").value;
		var serialNumber = document.getElementById("SerialNum").value;
		//var customerNotes = document.getElementById("customerNotes").value;

		this.setState({ invoiceArray: invoiceArray, invoiceNumber: code, invoiceTotal: invoiceFormattedTotal, invoiceSerialNumber: serialNumber });

		this.toggle3();

		setTimeout(this.uploadInvoiceToS3, 1000);

	}

	generateQuotingInvoice = async () => {

		var quoteItemsForRepair = JSON.parse(JSON.stringify(this.state.quoteItemsForRepair));

		var invoiceArray = [];
		var invoiceTotal = 0;

		for (var i=0; i<quoteItemsForRepair.length; i++) {

			if (quoteItemsForRepair[i].id!=null) {
				const result = this.state.quoteData.filter(item => item.id==quoteItemsForRepair[i].QuoteItemID);

				var cost = result[0].Cost;

				cost = cost.replace('$', '');

				var total = parseInt(cost)*parseInt(quoteItemsForRepair[i].Quantity);

				invoiceTotal = invoiceTotal+total;

				if (quoteItemsForRepair[i].Optional) {
					total = total+" (Optional)";
				}

				var invoiceRow = {
					PartNumber: result[0].SKU,
					Description: result[0].Description,
					CustomerNotes: result[0].CustomerNotes,
					Cost: "$"+cost,
					Quantity: quoteItemsForRepair[i].Quantity,
					Total: "$"+total
				}

				console.log("invoiceRow: " + JSON.stringify(invoiceRow));
				invoiceArray.push(invoiceRow);

			}

		}

		console.log("invoiceArray: " + JSON.stringify(invoiceArray));

		//var code = Math.floor(100000 + Math.random() * 900000);
		var code = this.props.repairID+"_Quote";
		console.log("random code: "+code);

		console.log("invoiceTotal: "+invoiceTotal);

		var invoiceFormattedTotal = "$"+invoiceTotal;

		//var customerNotes = document.getElementById("customerNotes").value;
		var serialNumber = document.getElementById("SerialNum").value;
		//var customerNotes = document.getElementById("customerNotes").value;

		this.setState({ invoiceArray: invoiceArray, invoiceNumber: code, invoiceTotal: invoiceFormattedTotal, invoiceSerialNumber: serialNumber });

		this.toggle3();

		//setTimeout(this.uploadInvoiceToS3, 1000);

	}

	generateIntlQuotingInvoice = async () => {

		var quoteItemsForRepair = JSON.parse(JSON.stringify(this.state.quoteItemsForRepair));

		var invoiceArray = [];
		var invoiceTotal = 0;
		var invoiceUSDTotal = 0;
		var invoiceEuroTotal = 0;

		for (var i=0; i<quoteItemsForRepair.length; i++) {

			if (quoteItemsForRepair[i].id!=null) {
				const result = this.state.quoteData.filter(item => item.id==quoteItemsForRepair[i].QuoteItemID);

				var cost = result[0].Cost;
				var currency = result[0].Currency;

				cost = cost.replace('$', '');
				cost = cost.replace(',', '');

				var currencyObj = this.state.currencies[currency-1];

				console.log("currencyObj: " + JSON.stringify(currencyObj));

				var total = parseFloat(cost)*parseInt(quoteItemsForRepair[i].Quantity);

				//console.log("total: " + JSON.stringify(total));

				if (currencyObj.Currency=="USD") {
					invoiceUSDTotal = invoiceUSDTotal+total;
				}

				if (currencyObj.Currency=="EURO") {
					invoiceEuroTotal = invoiceEuroTotal+total;
				}

				invoiceTotal = invoiceTotal+total;

				if (quoteItemsForRepair[i].Optional) {
					total = total+" (Optional)";
				}

				var invoiceRow = {
					PartNumber: result[0].SKU,
					Description: result[0].Description,
					CustomerNotes: result[0].CustomerNotes,
					Cost: currencyObj.Symbol+parseFloat(cost).toFixed(2),
					Quantity: quoteItemsForRepair[i].Quantity,
					Total: currencyObj.Symbol+parseFloat(total).toFixed(2)
				}

				//console.log("invoiceRow: " + JSON.stringify(invoiceRow));
				invoiceArray.push(invoiceRow);

			}

		}

		//console.log("invoiceArray: " + JSON.stringify(invoiceArray));

		//var code = Math.floor(100000 + Math.random() * 900000);
		var code = this.props.repairID+"_Quote";
		//console.log("random code: "+code);

		//console.log("invoiceTotal: "+invoiceTotal);

		var invoiceFormattedTotal = "$"+invoiceTotal.toFixed(2);;

		var invoiceFormattedUSDTotal = "$"+invoiceUSDTotal.toFixed(2);;
		var invoiceFormattedEuroTotal = "€"+invoiceEuroTotal.toFixed(2);;

		//var customerNotes = document.getElementById("customerNotes").value;
		var serialNumber = document.getElementById("SerialNum").value;
		//var customerNotes = document.getElementById("customerNotes").value;

		var detailedIssue = document.getElementById("detailedIssue").value;
		//console.log("quote detailedIssue: " + JSON.stringify(detailedIssue));

		this.setState({ invoiceArray: invoiceArray, invoiceNumber: code, invoiceFormattedUSDTotal: invoiceFormattedUSDTotal, invoiceFormattedEuroTotal: invoiceFormattedEuroTotal, invoiceTotal: invoiceFormattedTotal, invoiceSerialNumber: serialNumber, detailedIssue });
		//this.setState({ invoiceArray: invoiceArray, invoiceNumber: code, invoiceTotal: invoiceFormattedTotal, invoiceSerialNumber: serialNumber });

		//this.toggle12();

		//setTimeout(this.uploadInvoiceToS3, 1000);
		setTimeout(this.toggle12, 300);

	}

	generateCustomerReport = async () => {

		//var customerNotes = document.getElementById("customerNotes").value;
		var serialNumber = document.getElementById("SerialNum").value;
		//var customerNotes = document.getElementById("customerNotes").value;

		var customerTracking = document.getElementById("TrackingCustomer").value;
		var rmaNumber = "N/A";

		if (document.getElementById("RMANum")) {
			rmaNumber = document.getElementById("RMANum").value;
		}

		var receivedDate = Moment(this.state.repairLog.ReceivedDate);
		var backToCustomerDate = Moment(this.state.repairLog.ReturnedDate);
		//var customerDaysInService = Moment.duration(backToCustomerDate.diff(receivedDate)).asDays();
		var customerDaysInService = business.weekDays( receivedDate, backToCustomerDate );
		customerDaysInService = customerDaysInService.toFixed(0);

		var customerEmail = document.getElementById("email").value;

		this.setState({
			rmaNumber: rmaNumber,
			invoiceSerialNumber: serialNumber,
			customerTracking: customerTracking,
			customerDaysInService: customerDaysInService,
			customerEmail: customerEmail,
			modal6: true,
			customerReportPreviewLoading: true
		}, () => {
			this.prepareCustomerReportPreview();
			setTimeout(this.uploadCustomerReportToS3, 1000);
		});

	}

	sendEmailToINTLOrders = async () => {

		//console.log("this.state.quoteItemsForRepair: "+JSON.stringify(this.state.quoteItemsForRepair));

		var quoteItemsForRepair = JSON.parse(JSON.stringify(this.state.quoteItemsForRepair));

		var invoiceArray = [];
		var invoiceTotal = 0;

		for (var i=0; i<quoteItemsForRepair.length; i++) {

			if (quoteItemsForRepair[i].id!=null) {

				const result = this.state.quoteData.filter(item => item.id==quoteItemsForRepair[i].QuoteItemID);

				var invoiceRow = {
					SKU: result[0].SKU,
					Description: result[0].Description,
					Cost: result[0].Cost,
					Quantity: quoteItemsForRepair[i].Quantity,
				}

				console.log("invoiceRow: " + JSON.stringify(invoiceRow));
				invoiceArray.push(invoiceRow);

			}

		}

		console.log("invoiceArray: "+JSON.stringify(invoiceArray));

		let repairInfo = {
			repairID: this.props.repairID,
			SerialNumber:document.getElementById("SerialNum") ? document.getElementById("SerialNum").value : "N/A",
			Market:this.state.market,
			DetailedRepair: document.getElementById("detailedRepair").value,
			quoteItems: invoiceArray
		}

		var textBody = getINTLEmailText(repairInfo);
		var htmlBody = getEmailHTMLINTLRepairComplete(repairInfo);

		var requestBody = {
			emailRecipient:['Orders@AzenaMedical.com'],
			emailSubject:"INTL - Out of Warranty Repair",
			emailHTMLMessage:htmlBody,
			emailTextMessage:textBody
		}

		if (process.env.REACT_APP_ENV=="/development/") {
			requestBody = {
				emailRecipient:['ryan.a.stickel@gmail.com', 'jabe@azenamedical.com'],
				emailSubject:"INTL - Out of Warranty Repair",
				emailHTMLMessage:htmlBody,
				emailTextMessage:textBody
			}
		}

		var htmlBodyStr = htmlBody.replace('\n', '');
		console.log("htmlBodyStr: "+JSON.stringify(htmlBodyStr));

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"send-email-to-user";

		try {

			const response = await fetch(url, {
				method: 'POST',
				headers: {
					Authorization: this.state.currentUser.jwtToken,
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(requestBody)
			});

			const body = await response.json();
			console.log("send-email-to-user response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				//this.setState({ repairCategories: body.response });
				//console.log("insertId: " + repairID);
				//this.goToRepairLog(repairID);
			} else {
				//ADD ERROR MESSAGE
				//this.goToRepairLog(repairID);
			}

		}
		catch (err) {
			console.log(err);
		}

	}

	sendEmailToAzena = async (repairID, type) => {

		var upiValue = "N/A"

		if (document.getElementById("UPIClosed")) {
			upiValue = document.getElementById("UPIClosed").value;
		}

		if (upiValue==1) {
			upiValue = "Yes";
		} else {
			upiValue = "No";
		}

		var mdrValue = this.getElementValue("MDRRequired", 0);

		if (upiValue==1) {
			mdrValue = "Yes";
		} else {
			mdrValue = "No";
		}

		var incidentValue = this.getElementValue("IncidentInvolved", 0);

		if (incidentValue==0) {
			incidentValue = "No injury";
		} else if (incidentValue==1) {
			incidentValue = "Minor injury";
		} else if (incidentValue==2) {
			incidentValue = "Major injury";
		} else if (incidentValue==3) {
			incidentValue = "Serious malfunction";
		}

		var mdrJustValue = this.getElementValue("IncidentInvolved", 0);

		if (mdrJustValue==0) {
			mdrJustValue = "No device related death, serious injury or malfunction that could result in death or serious injury";
		} else if (mdrJustValue==1) {
			mdrJustValue = "Death or serious injury to operator";
		} else if (mdrJustValue==2) {
			mdrJustValue = "Death or serious injury to patient";
		} else if (mdrJustValue==3) {
			mdrJustValue = "Malfunction that could result in death or serious injury";
		}

		var trackDate = this.getElementValue("TrackingDateAzena", "");
		trackDate = Moment(trackDate).format('MM-DD-YYYY');

		var expectDate = this.getElementValue("ExpectedRepairDate", "00-00-0000");
		expectDate = Moment(expectDate).format('MM-DD-YYYY');

		var originDate = this.getElementValue("OriginalShipDate", "");
		originDate = Moment(originDate).format('MM-DD-YYYY');

		let currentProductValue = this.getElementValue("ProductName", this.state.selectedProductName);
		const resolvedProductName = resolveProductNameForPayload(this.state.productsData, currentProductValue, this.state.repairLog.ProductName);

		var emailDate = Moment().format('MM-DD-YYYY');

		if (type==2) {
			emailDate = Moment(this.state.repairLog.DateCreated).format('MM-DD-YYYY');
		}

		let repairInfo = {
			TechnicianLog:this.state.userName,
			ProductName:resolvedProductName,
			SerialNum:this.getSelectedSerialNumber() || "N/A",
			BatchNum:this.state.repairLog.BatchNum,
			RMANum:this.getElementValue("RMANum"),
			AgileNum:this.getElementValue("AgileNum"),
			UnitType:this.getElementValue("UnitType", "INTL"),
			DateCreated: emailDate,
			TamName:this.getElementValue("TamName", this.state.repairLog.TamName || "N/A"),
			TamPhone:this.getElementValue("TamPhone", this.state.repairLog.TamPhone || "N/A"),
			UPIClosed:upiValue,
			Status:this.getElementValue("Status"),
			CustomerName:this.getElementValue("CustomerName"),
			Address:this.getElementValue("Address"),
			City:this.getElementValue("City"),
			State:this.getElementValue("State"),
			Zip:this.getElementValue("Zip"),
			email:this.getElementValue("email"),
			Action:this.getElementValue("Action"),
			TrackingNum:this.getElementValue("TrackingNum"),
			TrackingDateAzena:trackDate,
			ExpectedRepairDate:expectDate,
			OriginalShipDate:originDate,
			MDRRequired:mdrValue,
			IncidentInvolved:incidentValue,
			MDRJustification:mdrJustValue,
			DetailedIssue: this.getElementValue("detailedIssue")
		}

		//var htmlBody = getEmailHTML(repairInfo);
		var textBody = getEmailText(repairInfo);
		var htmlBody2 = getEmailHTMLNewRepair(repairInfo);

		if (type==2) {
			repairInfo.DetailedRepair = document.getElementById("detailedRepair") ? document.getElementById("detailedRepair").value : "N/A";
			htmlBody2 = getEmailHTMLRepairUpdate(repairInfo);
		}

		console.log('email html: ' + htmlBody2);
		console.log('email text: ' + textBody);

		var requestBody = {
			emailRecipient:['Equipment.Repair@ultradent.com','repairs@azenamedical.com'],
			emailSubject:"New Repair Created: "+repairID,
			emailHTMLMessage:htmlBody2,
			emailTextMessage:textBody
		}

		if (type==2) {
			requestBody = {
				emailRecipient:['Equipment.Repair@ultradent.com','repairs@azenamedical.com'],
				emailSubject:"Repair Number "+repairID+" changed repair status to '"+repairInfo.Status+"'",
				emailHTMLMessage:htmlBody2,
				emailTextMessage:textBody
			}
		}

		if (this.state.market=="europe") {

			requestBody = {
				emailRecipient:['Equipment.repair@ultradent.com', 'info@wanzek-dental.de', 'Bfabio@Ultradent.com', 'repairs@azenamedical.com'],
				emailSubject:"New Repair Created: "+repairID,
				emailHTMLMessage:htmlBody2,
				emailTextMessage:textBody
			}

			if (type==2) {
				requestBody = {
					emailRecipient:['Equipment.repair@ultradent.com', 'info@wanzek-dental.de', 'Bfabio@Ultradent.com', 'infoDE@ultradent.com'],
					emailSubject:"Repair Number "+repairID+" changed repair status to '"+repairInfo.Status+"'",
					emailHTMLMessage:htmlBody2,
					emailTextMessage:textBody
				}
			}

		} else if (this.state.market=="aus") {

			requestBody = {
				emailRecipient:['info.anz@ultradent.com','reception@u-techmedical.com.au', 'repairs@azenamedical.com'],
				emailSubject:"New Repair Created: "+repairID,
				emailHTMLMessage:htmlBody2,
				emailTextMessage:textBody
			}

			if (type==2) {
				requestBody = {
					emailRecipient:['info.anz@ultradent.com','reception@u-techmedical.com.au'],
					emailSubject:"Repair Number "+repairID+" changed repair status to '"+repairInfo.Status+"'",
					emailHTMLMessage:htmlBody2,
					emailTextMessage:textBody
				}
			}

		} else if (this.state.market=="colombia") {

			requestBody = {
				emailRecipient:['claudia.mendez@ultradent.com','gerencia@dentalmechanic.co', 'mariano.colantoni@ultradent.com', 'repairs@azenamedical.com'],
				emailSubject:"New Repair Created: "+repairID,
				emailHTMLMessage:htmlBody2,
				emailTextMessage:textBody
			}

			if (type==2) {
				requestBody = {
					emailRecipient:['claudia.mendez@ultradent.com','gerencia@dentalmechanic.co', 'mariano.colantoni@ultradent.com'],
					emailSubject:"Repair Number "+repairID+" changed repair status to '"+repairInfo.Status+"'",
					emailHTMLMessage:htmlBody2,
					emailTextMessage:textBody
				}
			}

		} else if (this.state.market=="brazil") {

			requestBody = {
				emailRecipient:['henrique.guimaraes@ultradent.com.br', 'claudia.cavani@ultradent.com.br', 'repairs@azenamedical.com'],
				emailSubject:"New Repair Created: "+repairID,
				emailHTMLMessage:htmlBody2,
				emailTextMessage:textBody
			}

			if (type==2) {
				requestBody = {
					emailRecipient:['henrique.guimaraes@ultradent.com.br', 'claudia.cavani@ultradent.com.br'],
					emailSubject:"Repair Number "+repairID+" changed repair status to '"+repairInfo.Status+"'",
					emailHTMLMessage:htmlBody2,
					emailTextMessage:textBody
				}
			}

		} else if (this.state.market=="mexico") {

			// requestBody = {
			// 	emailRecipient:['henrique.guimaraes@ultradent.com.br', 'claudia.cavani@ultradent.com.br', 'repairs@azenamedical.com'],
			// 	emailSubject:"New Repair Created: "+repairID,
			// 	emailHTMLMessage:htmlBody2,
			// 	emailTextMessage:textBody
			// }
			//
			// if (type==2) {
			// 	requestBody = {
			// 		emailRecipient:['henrique.guimaraes@ultradent.com.br', 'claudia.cavani@ultradent.com.br'],
			// 		emailSubject:"Repair Number "+repairID+" changed repair status to '"+repairInfo.Status+"'",
			// 		emailHTMLMessage:htmlBody2,
			// 		emailTextMessage:textBody
			// 	}
			// }

		} else if (this.state.market=="czech") {

			// requestBody = {
			// 	emailRecipient:['henrique.guimaraes@ultradent.com.br', 'claudia.cavani@ultradent.com.br', 'repairs@azenamedical.com'],
			// 	emailSubject:"New Repair Created: "+repairID,
			// 	emailHTMLMessage:htmlBody2,
			// 	emailTextMessage:textBody
			// }
			//
			// if (type==2) {
			// 	requestBody = {
			// 		emailRecipient:['henrique.guimaraes@ultradent.com.br', 'claudia.cavani@ultradent.com.br'],
			// 		emailSubject:"Repair Number "+repairID+" changed repair status to '"+repairInfo.Status+"'",
			// 		emailHTMLMessage:htmlBody2,
			// 		emailTextMessage:textBody
			// 	}
			// }

		}

		if (process.env.REACT_APP_ENV=="/development/") {
			 requestBody = {
				emailRecipient:['ryan.a.stickel@gmail.com','rstickel@azenamedical.com', 'jabe@azenamedical.com'],
				emailSubject:"New Repair Created: "+repairID,
				emailHTMLMessage:htmlBody2,
				emailTextMessage:textBody
			}
			if (type==2) {
				requestBody = {
					emailRecipient:['ryan.a.stickel@gmail.com','rstickel@azenamedical.com', 'jabe@azenamedical.com'],
					emailSubject:"Repair Number "+repairID+" changed repair status to '"+repairInfo.Status+"'",
					emailHTMLMessage:htmlBody2,
					emailTextMessage:textBody
				}
			}
		}

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"send-email-to-user";

		try {

			const response = await fetch(url, {
				method: 'POST',
				headers: {
					Authorization: this.state.currentUser.jwtToken,
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(requestBody)
			});

			const body = await response.json();
			console.log("send-email-to-user response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				//this.setState({ repairCategories: body.response });
				console.log("insertId: " + repairID);
				//this.goToRepairLog(repairID);
			} else {
				//ADD ERROR MESSAGE
				//this.goToRepairLog(repairID);
			}

			if (type==1) {
				this.setState({ isBeingSaved: false });
				this.goToRepairLog(repairID);
			}

		}
		catch (err) {
			console.log(err);
		}

	}

	sendEmailToTechnician = async () => {
		//var techEmail = document.getElementById("TechnicianEmail").innerHTML;

		//var techEmail = "Equipment.Repair@ultradent.com";

		var htmlBody = getEmailHTMLForTechnician(this.props.repairID, this.state.repairLog.TechnicianLog);
		var textBody = "A PDF Quote has been generated for Repair: "+this.props.repairID;

		console.log('email html: ' + htmlBody);

		let requestBody = {
			emailRecipient:['Equipment.Repair@ultradent.com', 'team@geminievo.com'],
			emailSubject:"New Quote PDF for Repair: "+this.props.repairID,
			emailHTMLMessage:htmlBody,
			emailTextMessage:textBody
		}

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"send-email-to-user";

		try {

			const response = await fetch(url, {
				method: 'POST',
				headers: {
					Authorization: this.state.currentUser.jwtToken,
					'Content-Type': 'application/json'
				},
				body: JSON.stringify(requestBody)
			});

			const body = await response.json();
			console.log("sendEmailToTechnician response: " + JSON.stringify(body));

			if (body.status == 'Success') {


			} else {
				//ADD ERROR MESSAGE

			}

		}
		catch (err) {
			console.log(err);
		}

	}

	updateRepairLogCheck = () => {

		//componentItemsForRepair
		//quoteItemsForRepair

		var hasUnsavedItems = false;

		for (var i=0; i<this.state.categoryItemsForRepair.length; i++) {
			var categoryItem = this.state.categoryItemsForRepair[i];

			if (categoryItem.id==null && categoryItem.CategoryItemID!=0) {
				hasUnsavedItems = true;
				return hasUnsavedItems;
			}
		}

		for (var i=0; i<this.state.componentItemsForRepair.length; i++) {
			var componentItem = this.state.componentItemsForRepair[i];

			if (componentItem.id==null && componentItem.ComponentItemID!=0) {
				hasUnsavedItems = true;
				return hasUnsavedItems;
			}
		}

		if (!hasUnsavedItems) {
			for (var i=0; i<this.state.quoteItemsForRepair.length; i++) {
				var quoteItem = this.state.quoteItemsForRepair[i];

				if (quoteItem.id==null && quoteItem.QuoteItemID!=0) {
					hasUnsavedItems = true;
					return hasUnsavedItems;
				}
			}
		}

		return hasUnsavedItems;

	}

	addMarketItemForTamItem = async (tamID, marketID) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"add-market-item-for-manage-option?ManageOptionType=0&OptionID="+tamID+"&MarketID="+marketID;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("add MarketItemForTamItem response: " + JSON.stringify(body));

			if (body.status == 'Success') {

			} else {
	      //ADD ERROR MESSAGE
	    }

		}
		catch (err) {
			console.log(err);
		}

	};

	updateRepairLog = async () => {

		if (!this.state.isBeingSaved) {

			var fullName = "";

			if (this.state.currentUser) {
				fullName = this.state.currentUser.payload.given_name + " " + this.state.currentUser.payload.family_name;
			}

			this.setState({ isBeingSaved: true });

			var old = Moment(this.state.repairLog.DateCreated).isBefore('2021-07-31');;

			console.log("is old: " + old);

			console.log('updateRepairLog mediaHash: ' + this.state.mediaHash);

			var selectedSerialNumber = this.getSelectedSerialNumber();

			var tamName = document.getElementById("TamName") ? document.getElementById("TamName").value : null;
			var tamPhone = document.getElementById("TamPhone") ? document.getElementById("TamPhone").value : null;

			if (this.state.manualTAMChecked) {
				tamName = document.getElementById("ManualTamName") ? document.getElementById("ManualTamName").value : null;
				tamPhone = document.getElementById("ManualTamPhone") ? document.getElementById("ManualTamPhone").value : null;

				if (tamName && tamPhone) {
					var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"create-tam-names?Name="+tamName+"&Phone="+tamPhone;

					try {

						const response = await fetch(url, {
							method: 'GET',
							headers: {
								Authorization: this.state.currentUser.jwtToken
							},
						});

						const body = await response.json();
						console.log("create TAM response: " + JSON.stringify(body));

						if (body.status == 'Success') {

							var market = "us"

							if (this.state.isUPI) {
								market = this.state.currentUser.payload['custom:market'];
							}

							if (this.state.market!="us" && this.state.market!="us-azena") {
								market = this.state.market;
							}

							var marketID = 0;

							if (market=="us") {
								marketID = 0;
							} else if (market=="europe") {
								marketID = 1;
							} else if (market=="aus") {
								marketID = 2;
							} else if (market=="brazil") {
								marketID = 3;
							} else if (market=="taiwan") {
								marketID = 4;
							} else if (market=="colombia") {
								marketID = 5;
							} else if (market=="mexico") {
								marketID = 6;
							} else if (market=="czech") {
								marketID = 7;
							}

							var tamID = body.response.insertId;

							await this.addMarketItemForTamItem(tamID, marketID);

							this.getTAMData();
							var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));

							repairLog['TamName'] = tamName;
							repairLog['TamPhone'] = tamPhone;
							console.log("manualTAMChecked repairLog: " + JSON.stringify(repairLog));

							this.setState({repairLog});
						} else {

						}

					}
					catch (err) {
						console.log(err);
					}

				}

			}

			if (this.props.repairID) {

				console.log("detailedIssue: " + document.getElementById("detailedIssue").value);
				//document.getElementById("market").value

				//let detailedIssue = document.getElementById("detailedIssue").value;
				//const detailedIssueBuff = Buffer.from(detailedIssue, "utf8");

				let currentProductValue = document.getElementById("ProductName").value;
				const selectedProduct = findProductByID(this.state.productsData, currentProductValue);
				const existingProduct = findProductByName(this.state.productsData, this.state.repairLog.ProductName);
				const resolvedProductName = resolveProductNameForPayload(this.state.productsData, currentProductValue, this.state.repairLog.ProductName);

				if (!selectedProduct && !existingProduct) {
					toast.error("The stored product could not be matched. Select a valid product before saving.", {
						position: "top-center",
						autoClose: 4000,
						hideProgressBar: true
					});
					this.setState({ isBeingSaved: false });
					return;
				}

				var unitType = document.getElementById("UnitType") ? document.getElementById("UnitType").value : "INTL";

				if (this.state.isInternationalRepair) {
					unitType = "INTL";
				}

				var market = this.state.repairLog.market;

				// if (this.state.currentUser.payload['custom:role'] && this.state.currentUser.payload['custom:role']>1) {
				// 	if (document.getElementById("Market")) {
				// 		market = document.getElementById("Market").value;
				// 	}
				// }

				let requestBody = {
					ID:this.props.repairID,
					market:market,
					TechnicianLog:this.state.userName,
					TechnicianEmail:this.state.techEmail,
					ProductName:resolvedProductName,
					SerialNum:selectedSerialNumber,
					BatchNum:this.state.repairLog.BatchNum,
					RMANum:document.getElementById("RMANum") ? document.getElementById("RMANum").value : null,
					AgileNum:document.getElementById("AgileNum") ? document.getElementById("AgileNum").value : null,
					UnitType:unitType,
					DateCreated:this.state.repairLog.DateCreated,
					TamName:tamName,
					TamPhone:tamPhone,
					DealerName: document.getElementById("DealerName") ? document.getElementById("DealerName").value : null,
					CustomerName:document.getElementById("CustomerName").value,
					ContactName:document.getElementById("ContactName").value,
					Address:document.getElementById("Address").value,
					Address2:document.getElementById("Address2") ? document.getElementById("Address2").value : null,
					City:document.getElementById("City").value,
					County:document.getElementById("County") ? document.getElementById("County").value : null,
					State:document.getElementById("State").value,
					Province:document.getElementById("Province") ? document.getElementById("Province").value : null,
					Country:document.getElementById("Country") ? document.getElementById("Country").value : null,
					Zip:document.getElementById("Zip").value,
					email:document.getElementById("email").value,
					Action:document.getElementById("Action").value,
					TrackingNum:document.getElementById("TrackingNum").value,
					TrackingDateAzena:document.getElementById("TrackingDateAzena").value,
					ExpectedRepairDate:document.getElementById("ExpectedRepairDate") ? document.getElementById("ExpectedRepairDate").value : "00-00-0000",
					OriginalShipDate:document.getElementById("OriginalShipDate").value,
					DetailedIssue: document.getElementById("detailedIssue").value,
					TechnicianRepair:this.state.techRepair ? this.state.techRepair : this.state.repairLog.TechnicianRepair,
					ReceivedDate:document.getElementById("ReceivedDate") ? document.getElementById("ReceivedDate").value : this.state.repairLog.ReceivedDate,
					Status:document.getElementById("Status") ? document.getElementById("Status").value : this.state.repairLog.Status,
					DetailedRepair: document.getElementById("detailedRepair") ? document.getElementById("detailedRepair").value : this.state.detailedRepair,
					Firmware:document.getElementById("Firmware") ? document.getElementById("Firmware").value : this.state.repairLog.Firmware,
					NewCalibration:document.getElementById("NewCalibration") ? document.getElementById("NewCalibration").value : this.state.repairLog.NewCalibration,
					ReplacedSD:document.getElementById("ReplacedSD") && document.getElementById("ReplacedSD").checked ? 1 : this.state.repairLog.ReplacedSD,
					ReplacedFiber:document.getElementById("ReplacedFiber") && document.getElementById("ReplacedFiber").checked ? 1 : this.state.repairLog.ReplacedFiber,
					ReplacedModule:document.getElementById("ReplacedModule") && document.getElementById("ReplacedModule").checked ? 1 : this.state.repairLog.ReplacedModule,
					ReplacedMain:document.getElementById("ReplacedMain") && document.getElementById("ReplacedMain").checked ? 1 : this.state.repairLog.ReplacedMain,
					ReplacedHans:document.getElementById("ReplacedHans") && document.getElementById("ReplacedHans").checked ? 1 : this.state.repairLog.ReplacedHans,
					ReplacedDisplay:document.getElementById("ReplacedDisplay") && document.getElementById("ReplacedDisplay").checked ? 1 : this.state.repairLog.ReplacedDisplay,
					ReplacedSpeaker:document.getElementById("ReplacedSpeaker") && document.getElementById("ReplacedSpeaker").checked ? 1 : this.state.repairLog.ReplacedSpeaker,
					ReplacedBattery:document.getElementById("ReplacedBattery") && document.getElementById("ReplacedBattery").checked ? 1 : this.state.repairLog.ReplacedBattery,
					ReplacedPedal:document.getElementById("ReplacedPedal") && document.getElementById("ReplacedPedal").checked ? 1 : this.state.repairLog.ReplacedPedal,
					ReplacedKeypad:document.getElementById("ReplacedKeypad") && document.getElementById("ReplacedKeypad").checked ? 1 : this.state.repairLog.ReplacedKeypad,
					ReplacedDisplayDriver:document.getElementById("ReplacedDisplayDriver") && document.getElementById("ReplacedDisplayDriver").checked ? 1 : this.state.repairLog.ReplacedDisplayDriver,
					FixedBoardSolder:document.getElementById("FixedBoardSolder") && document.getElementById("FixedBoardSolder").checked ? 1 : this.state.repairLog.FixedBoardSolder,
					ReplacedFlex16:document.getElementById("ReplacedFlex16") && document.getElementById("ReplacedFlex16").checked ? 1 : this.state.repairLog.ReplacedFlex16,
					ReplacedFlex21:document.getElementById("ReplacedFlex21") && document.getElementById("ReplacedFlex21").checked ? 1 : this.state.repairLog.ReplacedFlex21,
					ReplacedBox:document.getElementById("ReplacedBox") && document.getElementById("ReplacedBox").checked ? 1 : this.state.repairLog.ReplacedBox,
					ReplacedFoam:document.getElementById("ReplacedFoam") && document.getElementById("ReplacedFoam").checked ? 1 : this.state.repairLog.ReplacedFoam,
					ReturnedDate:document.getElementById("ReturnedDate") ? document.getElementById("ReturnedDate").value : this.state.repairLog.ReturnedDate,
					TrackingCustomer:document.getElementById("TrackingCustomer") ? document.getElementById("TrackingCustomer").value : this.state.repairLog.TrackingCustomer,
					ReturnedStatus:document.getElementById("ReturnedStatus") ? document.getElementById("ReturnedStatus").value : this.state.repairLog.ReturnedStatus,
					ShippingDestination:document.getElementById("ShippingDestination") ? document.getElementById("ShippingDestination").value : this.state.repairLog.ShippingDestination,
					CustomerNotes: document.getElementById("customerNotes") ? document.getElementById("customerNotes").value : this.state.customerNotes,
					IssueCategory1:document.getElementById("IssueCategory1") ? document.getElementById("IssueCategory1").value : this.state.repairLog.IssueCategory1,
					IssueCategory2:document.getElementById("IssueCategory2") ? document.getElementById("IssueCategory2").value : this.state.repairLog.IssueCategory2,
					IssueCategory3:document.getElementById("IssueCategory3") ? document.getElementById("IssueCategory3").value : this.state.repairLog.IssueCategory3,
					IssueCategory4:document.getElementById("IssueCategory4") ? document.getElementById("IssueCategory4").value : this.state.repairLog.IssueCategory4,
					IssueBOM1: document.getElementById("IssueBOM1") ? document.getElementById("IssueBOM1").value : this.state.repairLog.IssueBOM1,
					IssueBOM2: document.getElementById("IssueBOM2") ? document.getElementById("IssueBOM2").value : this.state.repairLog.IssueBOM2,
					IssueBOM3: document.getElementById("IssueBOM3") ? document.getElementById("IssueBOM3").value : this.state.repairLog.IssueBOM3,
					IssueBOM4: document.getElementById("IssueBOM4") ? document.getElementById("IssueBOM4").value : this.state.repairLog.IssueBOM4,
					IssueBOM5: document.getElementById("IssueBOM5") ? document.getElementById("IssueBOM5").value : this.state.repairLog.IssueBOM5,
					IssueBOM6: document.getElementById("IssueBOM6") ? document.getElementById("IssueBOM6").value : this.state.repairLog.IssueBOM6,
					IssueBOM1Quantity: document.getElementById("IssueBOM1Quantity") ? document.getElementById("IssueBOM1Quantity").value : this.state.repairLog.IssueBOM1Quantity,
					IssueBOM2Quantity: document.getElementById("IssueBOM2Quantity") ? document.getElementById("IssueBOM2Quantity").value : this.state.repairLog.IssueBOM2Quantity,
					IssueBOM3Quantity: document.getElementById("IssueBOM3Quantity") ? document.getElementById("IssueBOM3Quantity").value : this.state.repairLog.IssueBOM3Quantity,
					IssueBOM4Quantity: document.getElementById("IssueBOM4Quantity") ? document.getElementById("IssueBOM4Quantity").value : this.state.repairLog.IssueBOM4Quantity,
					IssueBOM5Quantity: document.getElementById("IssueBOM5Quantity") ? document.getElementById("IssueBOM5Quantity").value : this.state.repairLog.IssueBOM5Quantity,
					IssueBOM6Quantity: document.getElementById("IssueBOM6Quantity") ? document.getElementById("IssueBOM6Quantity").value : this.state.repairLog.IssueBOM6Quantity,
					MDRRequired:document.getElementById("MDRRequired") ? document.getElementById("MDRRequired").value : this.state.repairLog.MDRRequired,
					MDRJustification:document.getElementById("MDRJustification") ? document.getElementById("MDRJustification").value : this.state.repairLog.MDRJustification,
					IncidentInvolved:document.getElementById("IncidentInvolved") ? document.getElementById("IncidentInvolved").value : this.state.repairLog.IncidentInvolved,
					RecallRequired:document.getElementById("RecallRequired") ? document.getElementById("RecallRequired").value : this.state.repairLog.RecallRequired,
					SendCustomerEmail:document.getElementById("SendCustomerEmail") && document.getElementById("SendCustomerEmail").checked ? 1 : this.state.repairLog.SendCustomerEmail,
					Flagged:document.getElementById("Flagged") && document.getElementById("Flagged").checked ? 1 : this.state.repairLog.Flagged,
					UPIClosed:document.getElementById("UPIClosed") ? document.getElementById("UPIClosed").value : this.state.repairLog.UPIClosed,
					MediaHash:this.state.mediaHash,
					IssueOption1:document.getElementById("IssueOption1") ? document.getElementById("IssueOption1").value : this.state.repairLog.IssueOption1,
					IssueOption2:document.getElementById("IssueOption2") ? document.getElementById("IssueOption2").value : this.state.repairLog.IssueOption2,
					IssueOption3:document.getElementById("IssueOption3") ? document.getElementById("IssueOption3").value : this.state.repairLog.IssueOption3,
					IssueOption4:document.getElementById("IssueOption4") ? document.getElementById("IssueOption4").value : this.state.repairLog.IssueOption4,
					IssueOption5:document.getElementById("IssueOption5") ? document.getElementById("IssueOption5").value : this.state.repairLog.IssueOption5,
					IssueOption6:document.getElementById("IssueOption6") ? document.getElementById("IssueOption6").value : this.state.repairLog.IssueOption6,
					IssueOption7:document.getElementById("IssueOption7") ? document.getElementById("IssueOption7").value : this.state.repairLog.IssueOption7,
					IssueOption8:document.getElementById("IssueOption8") ? document.getElementById("IssueOption8").value : this.state.repairLog.IssueOption8,
					IssueOption9:document.getElementById("IssueOption9") ? document.getElementById("IssueOption9").value : this.state.repairLog.IssueOption9,
					IssueOption10:document.getElementById("IssueOption10") ? document.getElementById("IssueOption10").value : this.state.repairLog.IssueOption10,
					IssueOption11:document.getElementById("IssueOption11") ? document.getElementById("IssueOption11").value : this.state.repairLog.IssueOption11,
					IssueOption12:document.getElementById("IssueOption12") ? document.getElementById("IssueOption12").value : this.state.repairLog.IssueOption12}

					console.log("update-repair-log requestBody: " + JSON.stringify(requestBody));

					var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"update-repair-log";

					try {

						const response = await fetch(url, {
							method: 'POST',
							headers: {
								Authorization: this.state.currentUser.jwtToken,
								'Content-Type': 'application/json'
							},
							body: JSON.stringify(requestBody)
						});

						const body = await response.json();
						console.log("updateRepairLog response: " + JSON.stringify(body));

						// const hasCustomerCaused = this.state.categoryItemsForRepair.find(category => category.CustomerCaused==true);
						// const hasReplacedComponents = this.state.componentItemsForRepair.find(component => component.id!=null);
						// console.log("hasCustomerCaused: " + JSON.stringify(hasCustomerCaused));
						// console.log("hasReplacedComponents " + JSON.stringify(hasReplacedComponents));
						//
						// if (hasCustomerCaused && !hasReplacedComponents) {
						// 	console.log("send out of warranty email");
						// 	this.sendEmailToINTLOrders();
						// }

						if (body.status == 'Success') {
							//this.setState({ repairCategories: body.response });
							//this.sendEmailToAzena(this.props.repairID)
							//toast("Repair Saved!");

							var techMarket = "us"

							if (this.state.currentUser.payload['custom:market']) {
								market = this.state.currentUser.payload['custom:market'];
							}

							this.setState({ isBeingSaved: false });

							// if (this.state.openedRepairSaved) {
							//
							// } else {
							// 	this.setState({ openedRepairSaved: true });
							// }

							if (this.state.openedRepairStatus!=requestBody.Status) {
								console.log("STATUS CHANGED. SEND EMAIL!");
								this.setState({ openedRepairStatus: requestBody.Status });

								let logData = {
									FullName: fullName,
									Market: market,
									LogType: 3,
									ButtonSection: 1,
									RepairStatus: requestBody.Status,
									RepairID: this.props.repairID,
								}

								await this.createRepairHistoryLog(logData);

								this.sendEmailToAzena(this.props.repairID, 2);

							} else {

								let logData = {
									FullName: fullName,
									Market: market,
									LogType: 2,
									ButtonSection: 1,
									RepairStatus: requestBody.Status,
									RepairID: this.props.repairID,
								}

								await this.createRepairHistoryLog(logData);

							}

							if (this.state.isInternationalRepair) {
								if (requestBody.Status=="Completed") {
									var d1 = Moment(requestBody.OriginalShipDate);
									var d2 = Moment();
									var unitOutOfWarranty = true;

									if (d2.diff(d1, 'days')<731) {
										unitOutOfWarranty = false;
									}

									if (unitOutOfWarranty) {

										this.sendEmailToINTLOrders();

									} else {

										const hasCustomerCaused = this.state.categoryItemsForRepair.find(category => category.CustomerCaused==true);
										const hasReplacedComponents = this.state.componentItemsForRepair.find(component => component.id!=null);
										//console.log("hasCustomerCaused: " + JSON.stringify(hasCustomerCaused));
										//console.log("hasReplacedComponents " + JSON.stringify(hasReplacedComponents));

										if (hasCustomerCaused && !hasReplacedComponents) {
											console.log("SEND INTL - Out of Warranty Repair Email");
											this.sendEmailToINTLOrders();
										}

									}
								}
							}

							if (this.state.manualTAMChecked) {

								this.setState({ manualTAMChecked: false });
							}

							if (this.updateRepairLogCheck()) {
								toast.warn('Repair Saved, but you have unsaved Repair Reasons, Component Replacement, and/or Quote Items on this repair ticket.', {
									position: "top-center",
									autoClose: 5000,
									hideProgressBar: true,
									closeOnClick: true,
									pauseOnHover: true,
									draggable: true,
									progress: undefined,
									theme: "dark",
									closeButton: false
								});
							} else {
								toast.success('Repair Saved!', {
									position: "top-center",
									autoClose: 3000,
									hideProgressBar: true,
									closeOnClick: true,
									pauseOnHover: true,
									draggable: true,
									progress: undefined,
									theme: "dark",
									closeButton: false
								});
							}

						} else {
							//ADD ERROR MESSAGE

							this.setState({ isBeingSaved: false });

							toast.error('Repair Not Saved!', {
								position: "top-center",
								autoClose: 3000,
								hideProgressBar: true,
								closeOnClick: true,
								pauseOnHover: true,
								draggable: true,
								progress: undefined,
								theme: "dark",
								closeButton: false
							});
						}

					}
					catch (err) {
						console.log(err);

						this.setState({ isBeingSaved: false });

						toast.error('Repair Not Saved! Please Log out and log back in!', {
							position: "top-center",
							autoClose: 3000,
							hideProgressBar: true,
							closeOnClick: true,
							pauseOnHover: true,
							draggable: true,
							progress: undefined,
							theme: "dark",
							closeButton: false
						});
					}

			} else {

				//console.log("detailedIssue: " + document.getElementById("detailedIssue").value);
				//document.getElementById("market").value

				//let detailedIssue = document.getElementById("detailedIssue").value;
				//const detailedIssueBuff = Buffer.from(detailedIssue, "utf8");

				if (document.getElementById("OriginalShipDate").value) {
					//console.log("Has OriginalShipDate: ");

					if (selectedSerialNumber && selectedSerialNumber.length > 0) {
						var market = "us"

						if (this.state.isUPI) {
							market = this.state.currentUser.payload['custom:market'];
						}

						if (this.state.market!="us" && this.state.market!="us-azena") {
							market = this.state.market;
						}

						if (this.state.currentUser.payload['custom:role'] && this.state.currentUser.payload['custom:role']>1) {
							if (document.getElementById("market")) {
								market = document.getElementById("market").value;
							}
						}

						let currentProductValue = document.getElementById("ProductName").value;
						const resolvedProductName = resolveProductNameForPayload(this.state.productsData, currentProductValue, this.state.repairLog.ProductName);

						if (!resolvedProductName) {
							toast.error("Select a valid product before creating the repair.", {
								position: "top-center",
								autoClose: 4000,
								hideProgressBar: true
							});
							this.setState({ isBeingSaved: false });
							return;
						}

						var unitType = document.getElementById("UnitType") ? document.getElementById("UnitType").value : "INTL";

						if (this.state.isInternationalRepair) {
							unitType = "INTL";
						}

						let requestBody = {
							market:market,
							TechnicianLog:this.state.userName,
							TechnicianEmail:this.state.techEmail,
							ProductName:resolvedProductName,
							SerialNum:selectedSerialNumber,
							BatchNum:this.state.repairLog.BatchNum,
							RMANum:document.getElementById("RMANum") ? document.getElementById("RMANum").value : null,
							AgileNum:document.getElementById("AgileNum") ? document.getElementById("AgileNum").value : null,
							UnitType:unitType,
							TamName:tamName,
							TamPhone:tamPhone,
							DealerName: document.getElementById("DealerName") ? document.getElementById("DealerName").value : null,
							CustomerName:document.getElementById("CustomerName").value,
							ContactName:document.getElementById("ContactName").value,
							Address:document.getElementById("Address").value,
							Address2:document.getElementById("Address2") ? document.getElementById("Address2").value : null,
							City:document.getElementById("City").value,
							County:document.getElementById("County") ? document.getElementById("County").value : null,
							State:document.getElementById("State").value,
							Province:document.getElementById("Province") ? document.getElementById("Province").value : null,
							Country:document.getElementById("Country") ? document.getElementById("Country").value : null,
							Zip:document.getElementById("Zip").value,
							email:document.getElementById("email").value,
							Action:document.getElementById("Action").value,
							TrackingNum:document.getElementById("TrackingNum").value,
							TrackingDateAzena:document.getElementById("TrackingDateAzena").value,
							ExpectedRepairDate:document.getElementById("ExpectedRepairDate") ? document.getElementById("ExpectedRepairDate").value : "00-00-0000",
							OriginalShipDate:document.getElementById("OriginalShipDate").value,
							DetailedIssue: document.getElementById("detailedIssue").value,
							TechnicianRepair:this.state.techRepair ? this.state.techRepair : null,
							ReceivedDate:document.getElementById("ReceivedDate") ? document.getElementById("ReceivedDate").value : null,
							Status:document.getElementById("Status") ? document.getElementById("Status").value : null,
							DetailedRepair: document.getElementById("detailedRepair") ? document.getElementById("detailedRepair").value : null,
							Firmware:document.getElementById("Firmware") ? document.getElementById("Firmware").value : null,
							NewCalibration:document.getElementById("NewCalibration") ? document.getElementById("NewCalibration").value : null,
							ReplacedSD:document.getElementById("ReplacedSD") && document.getElementById("ReplacedSD").checked ? 1 : 0,
							ReplacedFiber:document.getElementById("ReplacedFiber") && document.getElementById("ReplacedFiber").checked ? 1 : 0,
							ReplacedModule:document.getElementById("ReplacedModule") && document.getElementById("ReplacedModule").checked ? 1 : 0,
							ReplacedMain:document.getElementById("ReplacedMain") && document.getElementById("ReplacedMain").checked ? 1 : 0,
							ReplacedHans:document.getElementById("ReplacedHans") && document.getElementById("ReplacedHans").checked ? 1 : 0,
							ReplacedDisplay:document.getElementById("ReplacedDisplay") && document.getElementById("ReplacedDisplay").checked ? 1 : 0,
							ReplacedSpeaker:document.getElementById("ReplacedSpeaker") && document.getElementById("ReplacedSpeaker").checked ? 1 : 0,
							ReplacedBattery:document.getElementById("ReplacedBattery") && document.getElementById("ReplacedBattery").checked ? 1 : 0,
							ReplacedPedal:document.getElementById("ReplacedPedal") && document.getElementById("ReplacedPedal").checked ? 1 : 0,
							ReplacedKeypad:document.getElementById("ReplacedKeypad") && document.getElementById("ReplacedKeypad").checked ? 1 : 0,
							ReplacedDisplayDriver:document.getElementById("ReplacedDisplayDriver") && document.getElementById("ReplacedDisplayDriver").checked ? 1 : 0,
							FixedBoardSolder:document.getElementById("FixedBoardSolder") && document.getElementById("FixedBoardSolder").checked ? 1 : 0,
							ReplacedFlex16:document.getElementById("ReplacedFlex16") && document.getElementById("ReplacedFlex16").checked ? 1 : 0,
							ReplacedFlex21:document.getElementById("ReplacedFlex21") && document.getElementById("ReplacedFlex21").checked ? 1 : 0,
							ReplacedBox:document.getElementById("ReplacedBox") && document.getElementById("ReplacedBox").checked ? 1 : 0,
							ReplacedFoam:document.getElementById("ReplacedFoam") && document.getElementById("ReplacedFoam").checked ? 1 : 0,
							ReturnedDate:document.getElementById("ReturnedDate") ? document.getElementById("ReturnedDate").value : null,
							TrackingCustomer:document.getElementById("TrackingCustomer") ? document.getElementById("TrackingCustomer").value : null,
							ReturnedStatus:document.getElementById("ReturnedStatus") ? document.getElementById("ReturnedStatus").value : null,
							ShippingDestination:document.getElementById("ShippingDestination") ? document.getElementById("ShippingDestination").value : null,
							CustomerNotes: document.getElementById("customerNotes") ? document.getElementById("customerNotes").value : null,
							IssueCategory1:document.getElementById("IssueCategory1") ? document.getElementById("IssueCategory1").value : null,
							IssueCategory2:document.getElementById("IssueCategory2") ? document.getElementById("IssueCategory2").value : null,
							IssueCategory3:document.getElementById("IssueCategory3") ? document.getElementById("IssueCategory3").value : null,
							IssueCategory4:document.getElementById("IssueCategory4") ? document.getElementById("IssueCategory4").value : null,
							IssueBOM1: document.getElementById("IssueBOM1") ? document.getElementById("IssueBOM1").value : null,
							IssueBOM2: document.getElementById("IssueBOM2") ? document.getElementById("IssueBOM2").value : null,
							IssueBOM3: document.getElementById("IssueBOM3") ? document.getElementById("IssueBOM3").value : null,
							IssueBOM4: document.getElementById("IssueBOM4") ? document.getElementById("IssueBOM4").value : null,
							IssueBOM5: document.getElementById("IssueBOM5") ? document.getElementById("IssueBOM5").value : null,
							IssueBOM6: document.getElementById("IssueBOM6") ? document.getElementById("IssueBOM6").value : null,
							IssueBOM1Quantity: document.getElementById("IssueBOM1Quantity") ? document.getElementById("IssueBOM1Quantity").value : null,
							IssueBOM2Quantity: document.getElementById("IssueBOM2Quantity") ? document.getElementById("IssueBOM2Quantity").value : null,
							IssueBOM3Quantity: document.getElementById("IssueBOM3Quantity") ? document.getElementById("IssueBOM3Quantity").value : null,
							IssueBOM4Quantity: document.getElementById("IssueBOM4Quantity") ? document.getElementById("IssueBOM4Quantity").value : null,
							IssueBOM5Quantity: document.getElementById("IssueBOM5Quantity") ? document.getElementById("IssueBOM5Quantity").value : null,
							IssueBOM6Quantity: document.getElementById("IssueBOM6Quantity") ? document.getElementById("IssueBOM6Quantity").value : null,
							MDRRequired:document.getElementById("MDRRequired") ? document.getElementById("MDRRequired").value : null,
							MDRJustification:document.getElementById("MDRJustification") ? document.getElementById("MDRJustification").value : null,
							IncidentInvolved:document.getElementById("IncidentInvolved") ? document.getElementById("IncidentInvolved").value : null,
							RecallRequired:document.getElementById("RecallRequired") ? document.getElementById("RecallRequired").value : null,
							SendCustomerEmail:document.getElementById("SendCustomerEmail") && document.getElementById("SendCustomerEmail").checked ? 1 : 0,
							Flagged:document.getElementById("Flagged") && document.getElementById("Flagged").checked ? 1 : 0,
							UPIClosed:document.getElementById("UPIClosed") ? document.getElementById("UPIClosed").value : null,
							MediaHash:this.state.mediaHash,
							IssueOption1:document.getElementById("IssueOption1") ? document.getElementById("IssueOption1").value : null,
							IssueOption2:document.getElementById("IssueOption2") ? document.getElementById("IssueOption2").value : null,
							IssueOption3:document.getElementById("IssueOption3") ? document.getElementById("IssueOption3").value : null,
							IssueOption4:document.getElementById("IssueOption4") ? document.getElementById("IssueOption4").value : null,
							IssueOption5:document.getElementById("IssueOption5") ? document.getElementById("IssueOption5").value : null,
							IssueOption6:document.getElementById("IssueOption6") ? document.getElementById("IssueOption6").value : null,
							IssueOption7:document.getElementById("IssueOption7") ? document.getElementById("IssueOption7").value : null,
							IssueOption8:document.getElementById("IssueOption8") ? document.getElementById("IssueOption8").value : null,
							IssueOption9:document.getElementById("IssueOption9") ? document.getElementById("IssueOption9").value : null,
							IssueOption10:document.getElementById("IssueOption10") ? document.getElementById("IssueOption10").value : null,
							IssueOption11:document.getElementById("IssueOption11") ? document.getElementById("IssueOption11").value : null,
							IssueOption12:document.getElementById("IssueOption12") ? document.getElementById("IssueOption12").value : null}

							console.log("save-repair-log requestBody: " + JSON.stringify(requestBody));

							// if (requestBody.DealerName) {
							// 	console.log("save-repair-log body has dealer name");
							// } else {
							// 	console.log("save-repair-log body does not have dealer name");
							// }

							var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"save-repair-log";

							try {

								const response = await fetch(url, {
									method: 'POST',
									headers: {
										Authorization: this.state.currentUser.jwtToken,
										'Content-Type': 'application/json'
									},
									body: JSON.stringify(requestBody)
								});

								const body = await response.json();
								console.log("save-repair-log response: " + JSON.stringify(body));

								if (body.status == 'Success') {

									//this.setState({ repairCategories: body.response });
									console.log("insertId: " + JSON.stringify(body.response.insertId));

									var techMarket = "us"

									if (this.state.currentUser.payload['custom:market']) {
										market = this.state.currentUser.payload['custom:market'];
									}

									let logData = {
										FullName: fullName,
										Market: market,
										LogType: 1,
										ButtonSection: 1,
										RepairID: body.response.insertId,
									}

									await this.createRepairHistoryLog(logData);

									if (this.state.manualTAMChecked) {
										this.setState({ manualTAMChecked: false });
									}

									this.sendEmailToAzena(body.response.insertId, 1);
									//this.sendEmailToAzena(body.response.insertId, 2);

									//this.setState({ isBeingSaved: false });

								} else {
									//ADD ERROR MESSAGE
									this.setState({ isBeingSaved: false });
								}

							}
							catch (err) {
								console.log(err);
								this.setState({ isBeingSaved: false });

								toast.error('Repair Not Saved! Please Log out and log back in!', {
									position: "top-center",
									autoClose: 3000,
									hideProgressBar: true,
									closeOnClick: true,
									pauseOnHover: true,
									draggable: true,
									progress: undefined,
									theme: "dark",
									closeButton: false
								});
							}

					} else {

						this.setState({ isBeingSaved: false });

						toast.error('Serial Number is Required to Save.', {
							position: "top-center",
							autoClose: 3000,
							hideProgressBar: true,
							closeOnClick: true,
							pauseOnHover: true,
							draggable: true,
							progress: undefined,
							theme: "dark",
							closeButton: false
						});
					}

				} else {
					console.log("NO OriginalShipDate: ");
					//console.log("insertId: " + JSON.stringify(body.response.insertId));

					this.setState({ isBeingSaved: false });

					toast.error('Product Purchase Date is Required to Save.', {
						position: "top-center",
						autoClose: 3000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						theme: "dark",
						closeButton: false
					});
				}

			}

		}

	};

	onChangePurchaseOrderHandler = (event) => {

		var contentType = event.target.files[0].type;

		const contentTypeArray = contentType.split("/");

		let extension = contentTypeArray[1];

		this.setState({
			selectedFilePurchaseOrder: event.target.files[0],
			filePreviewPurchaseOrder: pdfPlaceholder,
			loadedPurchaseOrder: true,
		})

		console.log("file type: "+event.target.files[0].type);
	}

	onChangeLoanerReturnLabelHandler = (event) => {

		var contentType = event.target.files[0].type;

		const contentTypeArray = contentType.split("/");

		let extension = contentTypeArray[1];

		this.setState({
			selectedFileLoanerReturnLabel: event.target.files[0],
			filePreviewLoanerReturnLabel: pdfPlaceholder,
			loadedLoanerReturnLabel: true,
		})

		console.log("file type: "+event.target.files[0].type);
	}

	openEditorForImage = (file, slot) => {
		const src = URL.createObjectURL(file);

	  this.setState({
	    imageEditorOpen: true,
	    editingSlot: slot,
	    originalImageSrc: src,
	    croppedImageSrc: null,
	    editedImageBlob: null,
	    cropSelection: null,
	  });
	};

	getRelativeCropPoint = (event) => {
		const imageEl = this.cropSourceImageRef.current;
	  if (!imageEl) return null;

	  const bounds = imageEl.getBoundingClientRect();

	  return {
	    bounds,
	    x: Math.max(0, Math.min(event.clientX - bounds.left, bounds.width)),
	    y: Math.max(0, Math.min(event.clientY - bounds.top, bounds.height))
	  };
	};

	startFreeformCrop = (event) => {
		if (event.button !== 0) return;

	  const point = this.getRelativeCropPoint(event);
	  if (!point) return;

	  this.cropDragStart = { x: point.x, y: point.y };
	  this.cropDragBounds = point.bounds;

	  this.setState({
	    cropSelection: {
	      x: point.x,
	      y: point.y,
	      width: 0,
	      height: 0
	    }
	  });

	  window.addEventListener("mousemove", this.updateFreeformCrop);
	  window.addEventListener("mouseup", this.endFreeformCrop);
	};

	startFreeformCropTouch = (event) => {
		if (!event.touches || event.touches.length !== 1) return;

	  event.preventDefault();

	  const point = this.getRelativeCropPoint(event.touches[0]);
	  if (!point) return;

	  this.cropDragStart = { x: point.x, y: point.y };
	  this.cropDragBounds = point.bounds;

	  this.setState({
	    cropSelection: {
	      x: point.x,
	      y: point.y,
	      width: 0,
	      height: 0
	    }
	  });

	  window.addEventListener("touchmove", this.updateFreeformCropTouch, { passive: false });
	  window.addEventListener("touchend", this.endFreeformCropTouch);
	  window.addEventListener("touchcancel", this.endFreeformCropTouch);
	};

	updateFreeformCrop = (event) => {
		if (!this.cropDragStart || !this.cropDragBounds) return;

	  const bounds = this.cropDragBounds;
	  const currentX = Math.max(0, Math.min(event.clientX - bounds.left, bounds.width));
	  const currentY = Math.max(0, Math.min(event.clientY - bounds.top, bounds.height));
	  const x = Math.min(this.cropDragStart.x, currentX);
	  const y = Math.min(this.cropDragStart.y, currentY);
	  const width = Math.abs(currentX - this.cropDragStart.x);
	  const height = Math.abs(currentY - this.cropDragStart.y);

	  this.setState({
	    cropSelection: {
	      x,
	      y,
	      width,
	      height
	    }
	  });
	};

	updateFreeformCropTouch = (event) => {
		if (!event.touches || event.touches.length !== 1) return;
	  event.preventDefault();
	  this.updateFreeformCrop(event.touches[0]);
	};

	endFreeformCrop = () => {
		window.removeEventListener("mousemove", this.updateFreeformCrop);
	  window.removeEventListener("mouseup", this.endFreeformCrop);
	  this.cropDragStart = null;
	  this.cropDragBounds = null;
	};

	endFreeformCropTouch = () => {
		window.removeEventListener("touchmove", this.updateFreeformCropTouch);
	  window.removeEventListener("touchend", this.endFreeformCropTouch);
	  window.removeEventListener("touchcancel", this.endFreeformCropTouch);
	  this.cropDragStart = null;
	  this.cropDragBounds = null;
	};

	getCroppedImg = async (imageSrc, cropPixels) => {
		const image = new window.Image();
	  image.src = imageSrc;

	  await new Promise((resolve, reject) => {
	    image.onload = resolve;
	    image.onerror = reject;
	  });

	  const canvas = document.createElement("canvas");
	  canvas.width = cropPixels.width;
	  canvas.height = cropPixels.height;

	  const ctx = canvas.getContext("2d");
	  ctx.drawImage(
	    image,
	    cropPixels.x,
	    cropPixels.y,
	    cropPixels.width,
	    cropPixels.height,
	    0,
	    0,
	    cropPixels.width,
	    cropPixels.height
	  );

	  return new Promise((resolve) => {
	    canvas.toBlob((blob) => resolve(blob), "image/png");
	  });
	};

	initFabric = () => {
		const canvasEl = this.editorCanvasRef.current;
		const imageEl = this.editorImageRef.current;
	  if (!canvasEl || !imageEl || !imageEl.complete) return;

	  const initVersion = ++this.fabricInitVersion;

	  if (this.fabricCanvas) {
	    this.fabricCanvas.dispose();
	    this.fabricCanvas = null;
	  }

	  const fabricCanvas = new fabric.Canvas(canvasEl, {
	    preserveObjectStacking: true,
	    backgroundColor: "transparent"
	  });

	  this.fabricCanvas = fabricCanvas;

	  fabricCanvas.on("selection:created", this.syncAnnotationColorFromSelection);
	  fabricCanvas.on("selection:updated", this.syncAnnotationColorFromSelection);
	  fabricCanvas.on("selection:cleared", this.handleAnnotationSelectionCleared);

	  try {
	    const imgWidth = imageEl.naturalWidth || imageEl.width || 0;
	    const imgHeight = imageEl.naturalHeight || imageEl.height || 0;

	    if (!imgWidth || !imgHeight) {
	      throw new Error("Cropped image dimensions were not available.");
	    }

	    const maxWidth = 900;
	    const maxHeight = 500;

	    const scale = Math.min(
	      maxWidth / imgWidth,
	      maxHeight / imgHeight,
	      1
	    );

	    const displayWidth = Math.round(imgWidth * scale);
	    const displayHeight = Math.round(imgHeight * scale);

	    if (
	      initVersion !== this.fabricInitVersion ||
	      !this.fabricCanvas ||
	      this.fabricCanvas !== fabricCanvas
	    ) {
	      return;
	    }

	    fabricCanvas.clear();
	    fabricCanvas.setDimensions({
	      width: displayWidth,
	      height: displayHeight
	    });
	    if (fabricCanvas.wrapperEl) {
	      fabricCanvas.wrapperEl.style.position = "absolute";
	      fabricCanvas.wrapperEl.style.left = "0";
	      fabricCanvas.wrapperEl.style.top = "0";
	      fabricCanvas.wrapperEl.style.width = `${displayWidth}px`;
	      fabricCanvas.wrapperEl.style.height = `${displayHeight}px`;
	      fabricCanvas.wrapperEl.style.zIndex = "2";
	    }
	    if (fabricCanvas.lowerCanvasEl) {
	      fabricCanvas.lowerCanvasEl.style.position = "absolute";
	      fabricCanvas.lowerCanvasEl.style.left = "0";
	      fabricCanvas.lowerCanvasEl.style.top = "0";
	      fabricCanvas.lowerCanvasEl.style.background = "transparent";
	    }
	    if (fabricCanvas.upperCanvasEl) {
	      fabricCanvas.upperCanvasEl.style.position = "absolute";
	      fabricCanvas.upperCanvasEl.style.left = "0";
	      fabricCanvas.upperCanvasEl.style.top = "0";
	      fabricCanvas.upperCanvasEl.style.background = "transparent";
	    }
	    fabricCanvas.requestRenderAll();
	  } catch (err) {
	    console.error("Fabric overlay init failed", err);
	    toast.error("Unable to display the cropped image in the editor.");
	  }
	};

	getSelectedAnnotationColor = (activeObject) => {
		if (!activeObject) return null;

	  if (activeObject.type === "group" && activeObject._objects && activeObject._objects.length > 0) {
	    const groupChild = activeObject._objects.find((obj) => obj.stroke || obj.fill);
	    return groupChild ? (groupChild.stroke || groupChild.fill || null) : null;
	  }

	  return activeObject.stroke || activeObject.fill || null;
	};

	syncAnnotationColorFromSelection = () => {
		if (!this.fabricCanvas) return;

	  const activeObject = this.fabricCanvas.getActiveObject();
	  const selectedColor = this.getSelectedAnnotationColor(activeObject);
	  const isTextObject = activeObject && (activeObject.type === "textbox" || activeObject.type === "i-text" || activeObject.type === "text");

	  this.setState({
	    annotationColor: selectedColor || "#ff0000",
	    selectedAnnotationIsText: !!isTextObject,
	    annotationFontSize: isTextObject ? (activeObject.fontSize || 24) : 24,
	    annotationFontWeight: isTextObject ? (activeObject.fontWeight || "normal") : "normal",
	    annotationFontStyle: isTextObject ? (activeObject.fontStyle || "normal") : "normal",
	    annotationUnderline: isTextObject ? !!activeObject.underline : false,
	    annotationTextAlign: isTextObject ? (activeObject.textAlign || "left") : "left"
	  });
	};

	handleAnnotationSelectionCleared = () => {
		this.setState({
	    annotationColor: "#ff0000",
	    selectedAnnotationIsText: false,
	    annotationFontSize: 24,
	    annotationFontWeight: "normal",
	    annotationFontStyle: "normal",
	    annotationUnderline: false,
	    annotationTextAlign: "left"
	  });
	};

	deleteAnnotationObject = (target) => {
		if (!this.fabricCanvas || !target) return;

	  this.fabricCanvas.remove(target);
	  this.fabricCanvas.discardActiveObject();
	  this.fabricCanvas.requestRenderAll();

	  this.setState({
	    annotationColor: "#ff0000",
	    selectedAnnotationIsText: false,
	    annotationFontSize: 24,
	    annotationFontWeight: "normal",
	    annotationFontStyle: "normal",
	    annotationUnderline: false,
	    annotationTextAlign: "left"
	  });
	};

	renderDeleteControl = (ctx, left, top, styleOverride, fabricObject) => {
		const size = 26;
	  const half = size / 2;

	  ctx.save();
	  ctx.translate(left, top);
	  ctx.beginPath();
	  ctx.arc(0, 0, half, 0, Math.PI * 2, false);
	  ctx.fillStyle = "#dc3545";
	  ctx.fill();
	  ctx.lineWidth = 1.5;
	  ctx.strokeStyle = "#ffffff";
	  ctx.stroke();

	  // Lid
	  ctx.beginPath();
	  ctx.lineWidth = 2;
	  ctx.strokeStyle = "#ffffff";
	  ctx.moveTo(-6, -4);
	  ctx.lineTo(6, -4);
	  ctx.stroke();

	  // Handle
	  ctx.beginPath();
	  ctx.moveTo(-2, -7);
	  ctx.lineTo(2, -7);
	  ctx.stroke();

	  // Bin body
	  ctx.beginPath();
	  ctx.rect(-5, -3, 10, 10);
	  ctx.stroke();

	  // Bin inner lines
	  ctx.beginPath();
	  ctx.moveTo(-2, -1);
	  ctx.lineTo(-2, 5);
	  ctx.moveTo(0, -1);
	  ctx.lineTo(0, 5);
	  ctx.moveTo(2, -1);
	  ctx.lineTo(2, 5);
	  ctx.stroke();
	  ctx.restore();
	};

	applyAnnotationControls = (object) => {
		object.controls = {
	    ...object.controls,
	    deleteControl: new fabric.Control({
	      x: 0.5,
	      y: -0.5,
	      offsetX: 16,
	      offsetY: -16,
	      cursorStyle: "pointer",
	      mouseUpHandler: (eventData, transform) => {
	        this.deleteAnnotationObject(transform.target);
	        return true;
	      },
	      render: this.renderDeleteControl,
	      cornerSize: 26
	    })
	  };

	  return object;
	};

	updateActiveAnnotationColor = (color) => {
		this.setState({
	    annotationColor: color
	  });

	  if (!this.fabricCanvas) return;

	  const activeObject = this.fabricCanvas.getActiveObject();
	  if (!activeObject) return;

	  if (activeObject.type === "group" && activeObject._objects) {
	    activeObject._objects.forEach((obj) => {
	      if (obj.stroke) {
	        obj.set("stroke", color);
	      }
	      if (obj.fill && obj.fill !== "transparent") {
	        obj.set("fill", color);
	      }
	    });
	  } else {
	    if (activeObject.stroke) {
	      activeObject.set("stroke", color);
	    }
	    if (activeObject.fill && activeObject.fill !== "transparent") {
	      activeObject.set("fill", color);
	    }
	  }

	  this.fabricCanvas.requestRenderAll();
	};

	updateActiveTextStyle = (styleUpdates) => {
		if (!this.fabricCanvas) return;

	  const activeObject = this.fabricCanvas.getActiveObject();
	  if (!activeObject || !["textbox", "i-text", "text"].includes(activeObject.type)) return;

	  activeObject.set(styleUpdates);
	  this.fabricCanvas.requestRenderAll();

	  this.setState({
	    annotationFontSize: activeObject.fontSize || 24,
	    annotationFontWeight: activeObject.fontWeight || "normal",
	    annotationFontStyle: activeObject.fontStyle || "normal",
	    annotationUnderline: !!activeObject.underline,
	    annotationTextAlign: activeObject.textAlign || "left"
	  });
	};

	deleteSelectedAnnotation = () => {
		if (!this.fabricCanvas) return;

	  const activeObject = this.fabricCanvas.getActiveObject();
	  if (!activeObject) return;

	  this.fabricCanvas.remove(activeObject);
	  this.fabricCanvas.discardActiveObject();
	  this.fabricCanvas.requestRenderAll();

	  this.setState({
	    annotationColor: "#ff0000"
	  });
	};

	addRectangle = () => {
	  const rect = this.applyAnnotationControls(new fabric.Rect({
	    left: 50,
	    top: 50,
	    width: 120,
	    height: 80,
	    fill: "transparent",
	    stroke: this.state.annotationColor,
	    strokeWidth: 3,
	  }));
	  this.fabricCanvas.add(rect);
	  this.fabricCanvas.setActiveObject(rect);
	  this.fabricCanvas.requestRenderAll();
	};

	addCircle = () => {
	  const circle = this.applyAnnotationControls(new fabric.Circle({
	    left: 60,
	    top: 60,
	    radius: 50,
	    fill: "transparent",
	    stroke: this.state.annotationColor,
	    strokeWidth: 3,
	  }));
	  this.fabricCanvas.add(circle);
	  this.fabricCanvas.setActiveObject(circle);
	  this.fabricCanvas.requestRenderAll();
	};

	addArrow = () => {
	  const line = new fabric.Line([80, 80, 220, 160], {
	    stroke: this.state.annotationColor,
	    strokeWidth: 4,
	  });

	  const head = new fabric.Triangle({
	    left: 220,
	    top: 160,
	    originX: "center",
	    originY: "center",
	    width: 18,
	    height: 18,
	    angle: 125,
	    fill: this.state.annotationColor,
	  });

	  const arrow = this.applyAnnotationControls(new fabric.Group([line, head], {
	    left: 0,
	    top: 0,
	  }));

	  this.fabricCanvas.add(arrow);
	  this.fabricCanvas.setActiveObject(arrow);
	  this.fabricCanvas.requestRenderAll();
	};

	addText = () => {
	  const textbox = this.applyAnnotationControls(new fabric.Textbox("Text", {
	    left: 80,
	    top: 80,
	    width: 180,
	    fontSize: this.state.annotationFontSize,
	    fontWeight: this.state.annotationFontWeight,
	    fontStyle: this.state.annotationFontStyle,
	    underline: this.state.annotationUnderline,
	    textAlign: this.state.annotationTextAlign,
	    fill: this.state.annotationColor,
	  }));
	  this.fabricCanvas.add(textbox);
	  this.fabricCanvas.setActiveObject(textbox);
	  this.fabricCanvas.requestRenderAll();
	};

	printRepairTraveler = async () => {
		const blob = await pdf(
	    <GenRepairOrder repairOrderData={this.state.repairOrderData}/>
	  ).toBlob();

	  this.openPrintWindow(URL.createObjectURL(blob), {
	    errorMessage: "Allow pop-ups to print the repair traveler.",
	    revokeObjectUrlOnClose: true
	  });
	};

	openPrintWindow = (printUrl, options = {}) => {
		const {
			errorMessage = "Allow pop-ups to print this PDF.",
			revokeObjectUrlOnClose = false
		} = options;

		const printWindow = window.open(printUrl, "_blank");

		if (!printWindow) {
			toast.error(errorMessage);
			if (revokeObjectUrlOnClose) {
				URL.revokeObjectURL(printUrl);
			}
			return;
		}

		const cleanup = () => {
			if (revokeObjectUrlOnClose) {
				URL.revokeObjectURL(printUrl);
			}
		};

		printWindow.addEventListener("load", () => {
			printWindow.focus();
			printWindow.print();
		}, { once: true });

		if (revokeObjectUrlOnClose) {
			printWindow.addEventListener("afterprint", cleanup, { once: true });
			printWindow.addEventListener("beforeunload", cleanup, { once: true });
		}
	};

	openIframePrintWindow = (printUrl, options = {}) => {
		const {
			errorMessage = "Allow pop-ups to print this PDF.",
			printDelayMs = 1500,
			preloadBeforePrint = false
		} = options;

		const printWindow = window.open("", "_blank");

		if (!printWindow) {
			toast.error(errorMessage);
			return;
		}

		const escapedUrl = printUrl.replace(/&/g, "&amp;").replace(/"/g, "&quot;");
		const rawUrl = JSON.stringify(printUrl);

		printWindow.document.write(`
			<!doctype html>
			<html>
				<head>
					<title>Print PDF</title>
					<style>
						html, body, iframe {
							margin: 0;
							padding: 0;
							width: 100%;
							height: 100%;
							border: 0;
						}
					</style>
				</head>
				<body>
					<iframe id="print-frame" src="${escapedUrl}"></iframe>
					<script>
						const frame = document.getElementById("print-frame");
						let loadCount = 0;

						function triggerPrint() {
							window.setTimeout(function () {
								try {
									if (frame.contentWindow) {
										frame.contentWindow.focus();
										frame.contentWindow.print();
										return;
									}
								} catch (error) {}

								window.focus();
								window.print();
							}, ${printDelayMs});
						}

						frame.onload = function () {
							loadCount += 1;

							if (${preloadBeforePrint} && loadCount === 1) {
								window.setTimeout(function () {
									frame.src = ${rawUrl};
								}, ${printDelayMs});
								return;
							}

							triggerPrint();
						};
					</script>
				</body>
			</html>
		`);
		printWindow.document.close();
	};

	printRepairList = async () => {
		const blob = await pdf(
			<GenInvoice data={this.state.invoiceArray} invoiceNumber={this.state.invoiceNumber} invoiceTotal={this.state.invoiceTotal} invoiceDate={this.state.invoiceDate} detailedRepair={this.state.detailedRepair} repairLogID={this.props.repairID} serialNumber={this.state.invoiceSerialNumber} />
		).toBlob();

		this.openPrintWindow(URL.createObjectURL(blob), {
			errorMessage: "Allow pop-ups to print the repair list.",
			revokeObjectUrlOnClose: true
		});
	};

	printQuote = async () => {
		let blob = {};

		if (this.state.market=="aus") {
			blob = await pdf(
				<GenIntlQuote market={this.state.market} dealers={this.state.dealerData} data={this.state.invoiceArray} invoiceNumber={this.state.invoiceNumber} invoiceTotal={this.state.invoiceTotal} invoiceFormattedUSDTotal={this.state.invoiceFormattedUSDTotal}  invoiceFormattedEuroTotal={this.state.invoiceFormattedEuroTotal} invoiceDate={this.state.invoiceDate} detailedIssue={this.state.detailedIssue} repairLog={this.state.repairLog} repairLogID={this.props.repairID} serialNumber={this.state.invoiceSerialNumber} />
			).toBlob();
		} else {
			blob = await pdf(
				<GenEuropeIntlQuote market={this.state.market} dealers={this.state.dealerData} data={this.state.invoiceArray} invoiceNumber={this.state.invoiceNumber} invoiceTotal={this.state.invoiceTotal} invoiceFormattedUSDTotal={this.state.invoiceFormattedUSDTotal}  invoiceFormattedEuroTotal={this.state.invoiceFormattedEuroTotal} invoiceDate={this.state.invoiceDate} detailedIssue={this.state.detailedIssue} repairLog={this.state.repairLog} repairLogID={this.props.repairID} serialNumber={this.state.invoiceSerialNumber} />
			).toBlob();
		}

		this.openPrintWindow(URL.createObjectURL(blob), {
			errorMessage: "Allow pop-ups to print the quote.",
			revokeObjectUrlOnClose: true
		});
	};

	printCustomerReport = async () => {
		const blob = await pdf(
			<GenCustomerReport daysInService={this.state.customerDaysInService} trackingNumber={this.state.customerTracking} rmaNumber={this.state.rmaNumber} customerName={this.state.repairLog.CustomerName} invoiceDate={this.state.invoiceDate} customerNotes={this.state.customerNotes} repairLogID={this.props.repairID} serialNumber={this.state.invoiceSerialNumber} />
		).toBlob();

		this.openPrintWindow(URL.createObjectURL(blob), {
			errorMessage: "Allow pop-ups to print the customer repair report.",
			revokeObjectUrlOnClose: true
		});
	};

	getCurrentPreviewPdfUrl = () => {
		if (this.state.lightBoxDataIndex==7 && this.state.sectionOneFiles[this.state.lightBoxIndex]) {
			return this.state.sectionOneFiles[this.state.lightBoxIndex].url;
		}

		if (this.state.lightBoxDataIndex==8 && this.state.sectionTwoFiles[this.state.lightBoxIndex]) {
			return this.state.sectionTwoFiles[this.state.lightBoxIndex].url;
		}

		if (this.state.lightBoxDataIndex==9 && this.state.sectionThreeFiles[this.state.lightBoxIndex]) {
			return this.state.sectionThreeFiles[this.state.lightBoxIndex].url;
		}

		return "";
	};

	openPdfInBrowser = (pdfUrl, errorMessage = "Allow pop-ups to open this PDF.") => {
		if (!pdfUrl) {
			toast.error("PDF is not ready yet.");
			return;
		}

		const openedWindow = window.open(pdfUrl, "_blank");

		if (!openedWindow) {
			toast.error(errorMessage);
		}
	};

	printIframeInPlace = (frameRef, errorMessage = "Unable to trigger print for this PDF.") => {
		const frame = frameRef.current;

		if (!frame || !frame.contentWindow) {
			toast.error(errorMessage);
			return;
		}

		window.setTimeout(() => {
			try {
				frame.contentWindow.focus();
				frame.contentWindow.print();
			} catch (error) {
				toast.error(errorMessage);
			}
		}, 300);
	};

	printPurchaseOrder = () => {
		const purchaseOrder = this.state.purchaseOrderFiles[0];

		if (!purchaseOrder || !purchaseOrder.url) {
			toast.error("Purchase order PDF is not ready yet.");
			return;
		}

		this.openPrintWindow(purchaseOrder.url, {
			errorMessage: "Allow pop-ups to print the purchase order."
		});
	};

	printShippingLabel = () => {
		if (!this.state.shippingLabelURL) {
			toast.error("Shipping label PDF is not ready yet.");
			return;
		}

		this.openPrintWindow(this.state.shippingLabelURL, {
			errorMessage: "Allow pop-ups to print the shipping label."
		});
	};

	printLoanerReturnLabel = () => {
		const loanerReturnLabel = this.state.loanerReturnLabelFiles[0];

		if (!loanerReturnLabel || !loanerReturnLabel.url) {
			toast.error("Loaner return label PDF is not ready yet.");
			return;
		}

		this.openPrintWindow(loanerReturnLabel.url, {
			errorMessage: "Allow pop-ups to print the loaner return label."
		});
	};

	saveEditedImage = async () => {
		const imageEl = this.editorImageRef.current;
		if (!imageEl || !this.fabricCanvas) {
	    toast.error("Editor image is not ready yet.");
	    return;
	  }

	  const naturalWidth = imageEl.naturalWidth || imageEl.width;
	  const naturalHeight = imageEl.naturalHeight || imageEl.height;
	  const displayWidth = this.fabricCanvas.getWidth();
	  const displayHeight = this.fabricCanvas.getHeight();
	  const exportScale = displayWidth ? naturalWidth / displayWidth : 1;

	  const mergedCanvas = document.createElement("canvas");
	  mergedCanvas.width = naturalWidth;
	  mergedCanvas.height = naturalHeight;

	  const mergedCtx = mergedCanvas.getContext("2d");
	  mergedCtx.drawImage(imageEl, 0, 0, naturalWidth, naturalHeight);

	  const overlayDataUrl = this.fabricCanvas.toDataURL({
	    format: "png",
	    multiplier: exportScale,
	  });

	  const overlayImage = new window.Image();

	  await new Promise((resolve, reject) => {
	    overlayImage.onload = resolve;
	    overlayImage.onerror = reject;
	    overlayImage.src = overlayDataUrl;
	  });

	  mergedCtx.drawImage(
	    overlayImage,
	    0,
	    0,
	    naturalWidth,
	    naturalHeight
	  );

	  const blob = await new Promise((resolve) => {
	    mergedCanvas.toBlob((canvasBlob) => resolve(canvasBlob), "image/png");
	  });

	  const file = new File([blob], `edited-${Date.now()}.png`, {
	    type: "image/png",
	  });

	  const preview = URL.createObjectURL(file);

	  if (this.state.editingSlot === 1) {
	    this.setState({
	      selectedFileOne: file,
	      filePreviewOne: preview,
	      loadedOne: true,
	    }, this.resetImageEditor);
	  } else if (this.state.editingSlot === 2) {
	    this.setState({
	      selectedFileTwo: file,
	      filePreviewTwo: preview,
	      loadedTwo: true,
	    }, this.resetImageEditor);
	  } else if (this.state.editingSlot === 3) {
	    this.setState({
	      selectedFileThree: file,
	      filePreviewThree: preview,
	      loadedThree: true,
	    }, this.resetImageEditor);
	  }
	};

	handleCropNext = async () => {
		const imageEl = this.cropSourceImageRef.current;
		const cropSelection = this.state.cropSelection;
	  let nextImageSrc = this.state.originalImageSrc;

	  if (
	    imageEl &&
	    cropSelection &&
	    cropSelection.width >= 2 &&
	    cropSelection.height >= 2
	  ) {
	    const displayWidth = imageEl.clientWidth;
	    const displayHeight = imageEl.clientHeight;
	    const naturalWidth = imageEl.naturalWidth;
	    const naturalHeight = imageEl.naturalHeight;
	    const scaleX = naturalWidth / displayWidth;
	    const scaleY = naturalHeight / displayHeight;
	    const cropPixels = {
	      x: Math.round(cropSelection.x * scaleX),
	      y: Math.round(cropSelection.y * scaleY),
	      width: Math.max(1, Math.round(cropSelection.width * scaleX)),
	      height: Math.max(1, Math.round(cropSelection.height * scaleY))
	    };

			const blob = await this.getCroppedImg(
	      this.state.originalImageSrc,
	      cropPixels
	    );

	    nextImageSrc = URL.createObjectURL(blob);
	  }

	  if (this.fabricCanvas) {
	    this.fabricCanvas.dispose();
	    this.fabricCanvas = null;
	  }

	  this.setState({
	    croppedImageSrc: nextImageSrc
	  });
	};

	resetImageEditor = () => {
		this.fabricInitVersion += 1;
		this.endFreeformCrop();
		this.endFreeformCropTouch();

	  if (this.fabricCanvas) {
	    this.fabricCanvas.dispose();
	    this.fabricCanvas = null;
	  }

	  this.setState({
	    imageEditorOpen: false,
	    editingSlot: null,
	    originalImageSrc: null,
	    croppedImageSrc: null,
	    editedImageBlob: null,
	    annotationColor: "#ff0000",
	    selectedAnnotationIsText: false,
	    annotationFontSize: 24,
	    annotationFontWeight: "normal",
	    annotationFontStyle: "normal",
	    annotationUnderline: false,
	    annotationTextAlign: "left",
	    cropSelection: null,
	    crop: { x: 0, y: 0 },
	    zoom: 1,
	    croppedAreaPixels: null
	  });
	};

	// handleCropNext = async () => {
	// 	const blob = await this.getCroppedImg(
	//     this.state.originalImageSrc,
	//     this.state.croppedAreaPixels
	//   );
	//
	//   const croppedUrl = URL.createObjectURL(blob);
	//
	//   this.setState({
	//     croppedImageSrc: croppedUrl
	//   }, () => {
	//     setTimeout(() => {
	//       this.initFabric("editorCanvas", croppedUrl);
	//     }, 100);
	//   });
	// };

	// onChangeHandlerOne = (event) => {
	//
	// 	var contentType = event.target.files[0].type;
	//
	// 	const contentTypeArray = contentType.split("/");
	//
	// 	let extension = contentTypeArray[1];
	//
	// 	if (this.is_video_url_extension(extension)) {
	// 		this.setState({
	//       selectedFileOne: event.target.files[0],
	// 			filePreviewOne: videoPlaceholder,
	//       loadedOne: true,
	//     })
	// 	} else {
	// 		this.setState({
	//       selectedFileOne: event.target.files[0],
	// 			filePreviewOne: URL.createObjectURL(event.target.files[0]),
	//       loadedOne: true,
	//     })
	// 	}
	//
	// 	console.log("file type: "+event.target.files[0].type);
	// }

	onChangeHandlerOne = (event) => {

		const file = event.target.files[0];

	  if (!file) return;

	  if (file.type.startsWith("image/")) {
	    this.openEditorForImage(file, 1);
	    return;
	  }

	  const extension = file.type.split("/")[1];

	  if (this.is_video_url_extension(extension)) {
	    this.setState({
	      selectedFileOne: file,
	      filePreviewOne: videoPlaceholder,
	      loadedOne: true,
	    });
	  } else {
	    this.setState({
	      selectedFileOne: file,
	      filePreviewOne: URL.createObjectURL(file),
	      loadedOne: true,
	    });
	  }

		console.log("file type: "+event.target.files[0].type);
	};

	// onChangeHandlerTwo = (event) => {
	//
	// 	var contentType = event.target.files[0].type;
	//
	// 	const contentTypeArray = contentType.split("/");
	//
	// 	let extension = contentTypeArray[1];
	//
	// 	if (this.is_video_url_extension(extension)) {
	// 		this.setState({
	//       selectedFileTwo: event.target.files[0],
	// 			filePreviewTwo: videoPlaceholder,
	//       loadedTwo: true,
	//     })
	// 	} else {
	// 		this.setState({
	//       selectedFileTwo: event.target.files[0],
	// 			filePreviewTwo: URL.createObjectURL(event.target.files[0]),
	//       loadedTwo: true,
	//     })
	// 	}
	//
	// 	console.log("file type: "+event.target.files[0].type);
	// }

	onChangeHandlerTwo = (event) => {

		const file = event.target.files[0];

	  if (!file) return;

	  if (file.type.startsWith("image/")) {
	    this.openEditorForImage(file, 2);
	    return;
	  }

	  const extension = file.type.split("/")[1];

	  if (this.is_video_url_extension(extension)) {
	    this.setState({
	      selectedFileTwo: file,
	      filePreviewTwo: videoPlaceholder,
	      loadedTwo: true,
	    });
	  } else {
	    this.setState({
	      selectedFileTwo: file,
	      filePreviewTwo: URL.createObjectURL(file),
	      loadedTwo: true,
	    });
	  }

		console.log("file type: "+event.target.files[0].type);
	};

	// onChangeHandlerThree = (event) => {
	//
	// 	var contentType = event.target.files[0].type;
	//
	// 	const contentTypeArray = contentType.split("/");
	//
	// 	let extension = contentTypeArray[1];
	//
	// 	if (this.is_video_url_extension(extension)) {
	// 		this.setState({
	//       selectedFileThree: event.target.files[0],
	// 			filePreviewThree: videoPlaceholder,
	//       loadedThree: true,
	//     })
	// 	} else {
	// 		this.setState({
	//       selectedFileThree: event.target.files[0],
	// 			filePreviewThree: URL.createObjectURL(event.target.files[0]),
	//       loadedThree: true,
	//     })
	// 	}
	//
	// 	console.log("file type: "+event.target.files[0].type);
	// }

	onChangeHandlerThree = (event) => {

		const file = event.target.files[0];

	  if (!file) return;

	  if (file.type.startsWith("image/")) {
	    this.openEditorForImage(file, 3);
	    return;
	  }

	  const extension = file.type.split("/")[1];

	  if (this.is_video_url_extension(extension)) {
	    this.setState({
	      selectedFileThree: file,
	      filePreviewThree: videoPlaceholder,
	      loadedThree: true,
	    });
	  } else {
	    this.setState({
	      selectedFileThree: file,
	      filePreviewThree: URL.createObjectURL(file),
	      loadedThree: true,
	    });
	  }

		console.log("file type: "+event.target.files[0].type);
	};

	getFileFromUrl = async (url) => {

		console.log("getFileFromUrl called");

		const defaultType = 'application/pdf';
		const name = this.props.repairID+'-shipping-label.pdf';

		try {

		  const response = await fetch(url);
		  const data = await response.blob();

			const file = new File([data], name, {
		    type: data.type || defaultType,
		  });

			this.setState({
				selectedFileThree: file,
			})

			this.getPresignedBucketURL(2);

		}
		catch (err) {
			console.log(err);
		}

	  // return new File([data], name, {
	  //   type: data.type || defaultType,
	  // });
	}

	onClickPurchaseOrderHandler = () => {

		this.getPresignedBucketURL(3);
	}

	onClickLoanerReturnLabelHandler = () => {

		this.getPresignedBucketURL(4);
	}

	onClickHandlerOne = () => {

		//this.uploadToS3(0);
		this.getPresignedBucketURL(0);
	}

	onClickHandlerTwo = () => {

		this.getPresignedBucketURL(1);
	}

	onClickHandlerThree = () => {

		this.getPresignedBucketURL(2);
	}

 	// getBase64(file) {
	//   return new Promise((resolve, reject) => {
	//     const reader = new FileReader();
	//     reader.readAsBinaryString(file);
	//     reader.onload = () => resolve(reader.result);
	//     reader.onerror = error => reject(error);
	//   });
	// }

	getBase64(file) {
	  return new Promise((resolve, reject) => {
	    const reader = new FileReader();
	    reader.readAsDataURL(file);
	    reader.onload = () => resolve(reader.result);
	    reader.onerror = error => reject(error);
	  });
	}

 	getBinaryFromFile(file) {
		return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.addEventListener("load", () => resolve(reader.result));
        reader.addEventListener("error", err => reject(err));

        reader.readAsBinaryString(file);
    });
	}

	uploadToS3 = async (section) => {

		var hash = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
		console.log('random hash: ' + hash);

		var contentType = null;
		var fileData = null;
		var fileSize = null

		if (section==0) {
			console.log("file type: "+this.state.selectedFileOne.type);
			console.log("file size: "+this.state.selectedFileOne.size);
			fileSize = this.state.selectedFileOne.size;
			contentType = this.state.selectedFileOne.type;
			fileData = this.state.selectedFileOne;
		} else if (section==1) {
			console.log("file type: "+this.state.selectedFileTwo.type);
			console.log("file size: "+this.state.selectedFileTwo.size);
			fileSize = this.state.selectedFileTwo.size;
			contentType = this.state.selectedFileTwo.type;
			fileData = this.state.selectedFileTwo;
		} else if (section==2) {
			console.log("file type: "+this.state.selectedFileThree.type);
			console.log("file size: "+this.state.selectedFileThree.size);
			fileSize = this.state.selectedFileThree.size;
			contentType = this.state.selectedFileThree.type;
			fileData = this.state.selectedFileThree;
		} else if (section==3) {
			console.log("file type: "+this.state.selectedFilePurchaseOrder.type);
			console.log("file size: "+this.state.selectedFilePurchaseOrder.size);
			fileSize = this.state.selectedFilePurchaseOrder.size;
			contentType = this.state.selectedFilePurchaseOrder.type;
			fileData = this.state.selectedFilePurchaseOrder;
		}

		const maxAllowedSize = 10 * 1024 * 1024;
		console.log("max file size: "+maxAllowedSize);

		if (fileSize>maxAllowedSize) {

			let msg = "File is too large. Maximum file size is 10MB.";

			toast.error(msg, {
				position: "top-center",
				autoClose: 4000,
				hideProgressBar: true,
				closeOnClick: true,
				pauseOnHover: true,
				draggable: true,
				progress: undefined,
				theme: "dark",
				closeButton: false
			});
		} else {
			const contentTypeArray = contentType.split("/");

			//OLD WAY
			//let fileName = this.props.repairID+"-"+hash+"."+contentTypeArray[1];
			let fileName = this.state.mediaHash+"-"+hash+"."+contentTypeArray[1];

			if (contentTypeArray[1]=="quicktime") {
				fileName = this.state.mediaHash+"-"+hash+".mov";
			}
			console.log('fileName: ' + fileName);

			if (section==3) {
				fileName = this.state.mediaHash+"-PurchaseOrder.pdf";
			}

			var url = "https://vzc88uk8pa.execute-api.us-west-2.amazonaws.com/v1/azena-repair-files/"+fileName;

			try {
				const options = {
					method: 'PUT',
					headers: {
						Authorization: this.state.currentUser.jwtToken,
						'Content-Type': contentType
					},
					body: fileData
				};

				const response = await fetch(url, options);

				//const body = await response.json();
				console.log("upload response: " + JSON.stringify(response.status));

				if (response.status == '200') {
					console.log("Upload Success!");

					if (section==3) {
						if (this.state.purchaseOrderFiles.length==0) {
							this.addFileToRepair(fileName, section);
						} else {
							document.getElementById("filePurchaseOrder").value = null;
							this.setState({ filePreviewPurchaseOrder: null, loadedPurchaseOrder: false });
						}
					} else {
						this.addFileToRepair(fileName, section);
					}
				} else {
					//ADD ERROR MESSAGE
				}
			}
			catch (err) {
				console.log("uploadToS3 error: "+err);
			}
		}

		//https://azena-repair-files.s3.us-west-2.amazonaws.com/2038-s55ktm2m1akvbz21n33ur.png
	}

	submitIntlQuoteInvoice = (event) => {
		event.preventDefault();
		this.uploadIntlQuoteToS3();
	}

	uploadIntlQuoteToS3 = async () => {

		var code = Math.floor(100000 + Math.random() * 900000);

		let fileName = this.state.invoiceNumber+"_"+code+".pdf";

		this.setState({ invoicePDFName: fileName });

		//WORKING!!!!
		//let response1 = await fetch(warrantyPDF);
		//let blob = await response1.blob(); // download as Blob object

		//let repairNotes = document.getElementById("detailedRepair").value;

		var blob = {};

		if (this.state.market=="aus") {
			blob = await pdf(<GenIntlQuote dealers={this.state.dealerData} data={this.state.invoiceArray} invoiceNumber={this.state.invoiceNumber} invoiceTotal={this.state.invoiceTotal} invoiceFormattedUSDTotal={this.state.invoiceFormattedUSDTotal}  invoiceFormattedEuroTotal={this.state.invoiceFormattedEuroTotal} invoiceDate={this.state.invoiceDate} detailedIssue={this.state.detailedIssue} repairLog={this.state.repairLog} repairLogID={this.props.repairID} serialNumber={this.state.invoiceSerialNumber} />).toBlob();
		} else {
			blob = await pdf(<GenEuropeIntlQuote market={this.state.market} dealers={this.state.dealerData} data={this.state.invoiceArray} invoiceNumber={this.state.invoiceNumber} invoiceTotal={this.state.invoiceTotal} invoiceFormattedUSDTotal={this.state.invoiceFormattedUSDTotal}  invoiceFormattedEuroTotal={this.state.invoiceFormattedEuroTotal} invoiceDate={this.state.invoiceDate} detailedIssue={this.state.detailedIssue} repairLog={this.state.repairLog} repairLogID={this.props.repairID} serialNumber={this.state.invoiceSerialNumber} />).toBlob();
		}

		var url = "https://vzc88uk8pa.execute-api.us-west-2.amazonaws.com/v1/azena-repair-files/"+fileName;

		const options = {
			method: 'PUT',
			headers: {
				Authorization: this.state.currentUser.jwtToken
			},
			body: blob
		};

		try {

			const response = await fetch(url, options);

			//const body = await response.json();
			console.log("upload response: " + JSON.stringify(response.status));

			if (response.status == '200') {
				console.log("Upload Success!");
				await this.addFileToRepair(fileName, 0);
				this.toggle12();
				//this.sendEmailToTechnician();
			} else {
				//ADD ERROR MESSAGE
			}

		}
		catch (err) {
			console.log(err);
		}

	}

	submitQuoteInvoice = (event) => {
		event.preventDefault();
		this.uploadInvoiceToS3();
	}

	uploadInvoiceToS3 = async () => {

		var code = Math.floor(100000 + Math.random() * 900000);

		let fileName = this.state.invoiceNumber+"_"+code+".pdf";

		this.setState({ invoicePDFName: fileName });

		//WORKING!!!!
		//let response1 = await fetch(warrantyPDF);
		//let blob = await response1.blob(); // download as Blob object

		//let repairNotes = document.getElementById("detailedRepair").value;

		const blob = await pdf(<GenInvoice data={this.state.invoiceArray} invoiceNumber={this.state.invoiceNumber} invoiceTotal={this.state.invoiceTotal} invoiceDate={this.state.invoiceDate} detailedRepair={this.state.detailedRepair} repairLogID={this.props.repairID} serialNumber={this.state.invoiceSerialNumber} />).toBlob();


		var url = "https://vzc88uk8pa.execute-api.us-west-2.amazonaws.com/v1/azena-repair-files/"+fileName;

		const options = {
			method: 'PUT',
			headers: {
				Authorization: this.state.currentUser.jwtToken
			},
			body: blob
		};

		try {

			const response = await fetch(url, options);

			//const body = await response.json();
			console.log("upload response: " + JSON.stringify(response.status));

			if (response.status == '200') {
				console.log("Upload Success!");
				await this.addFileToRepair(fileName, 0);
				this.toggle3();
				this.sendEmailToTechnician();
			} else {
				//ADD ERROR MESSAGE
			}

		}
		catch (err) {
			console.log(err);
		}

	}

	uploadCustomerReportToS3 = async () => {

		let fileName = this.props.repairID+"_Customer_Repair_Report.pdf";

		this.setState({ customerReportPDFName: fileName });

		//WORKING!!!!
		//let response1 = await fetch(warrantyPDF);
		//let blob = await response1.blob(); // download as Blob object

		//let repairNotes = document.getElementById("detailedRepair").value;

		const blob = await pdf(<GenCustomerReport daysInService={this.state.customerDaysInService} trackingNumber={this.state.customerTracking} rmaNumber={this.state.rmaNumber} customerName={this.state.repairLog.CustomerName} invoiceDate={this.state.invoiceDate} customerNotes={this.state.customerNotes} repairLogID={this.props.repairID} serialNumber={this.state.invoiceSerialNumber} />).toBlob();


		var url = "https://vzc88uk8pa.execute-api.us-west-2.amazonaws.com/v1/azena-repair-files/"+fileName;

		const options = {
			method: 'PUT',
			headers: {
				Authorization: this.state.currentUser.jwtToken
			},
			body: blob
		};

		try {

			const response = await fetch(url, options);

			//const body = await response.json();
			console.log("upload response: " + JSON.stringify(response.status));

			if (response.status == '200') {
				console.log("Upload Success!");

				// let fileURL = "https://azena-repair-files.s3.us-west-2.amazonaws.com/"+fileName;
				// const result = this.state.sectionThreeFiles.filter(file => file.url==fileURL);
				//
				// if (result.length==0) {
				// 	console.log("Add Report File to DB");
				// 	this.addFileToRepair(fileName, 2);
				// } else {
				// 	console.log("Report File already added to DB");
				// }

			} else {
				//ADD ERROR MESSAGE
			}

		}
		catch (err) {
			console.log(err);
		}

	}

	sendInvoice = (event) => {
		event.preventDefault();

		console.log("Send message");
		let email = event.target.email.value;
    console.log(`email is:`, email);

		this.sendEmailMessage(email, 0);
	}

	sendReport = (event) => {
		event.preventDefault();

		console.log("Send message");
		let email = event.target.email.value;
    console.log(`email is:`, email);

		this.sendEmailMessage(email, 1);
	}

	saveReport = () => {

		//this.sendEmailMessage(email, 1);

		this.toggle6();

		let fileURL = "https://azena-repair-files.s3.us-west-2.amazonaws.com/"+this.state.customerReportPDFName;
		const result = this.state.sectionThreeFiles.filter(file => file.url==fileURL);

		if (result.length==0) {
			console.log("Add Report File to DB");
			this.addFileToRepair(this.state.customerReportPDFName, 2);
		} else {
			console.log("Report File already added to DB");
		}

	}

	sendQuantityAlertEmail = async (recipient, subject, message) => {

		var url = "https://9xnwyna9id.execute-api.us-west-2.amazonaws.com/v1/send-email-to-user?EmailRecipient="+recipient+"&EmailSubject="+subject+"&EmailMessage="+encodeURIComponent(message);

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("Send Quantity Alert Email response: " + JSON.stringify(body.results));

			if (body.status == 'Success') {

				// this.toggle4();
				// this.setState({
				// 	statusSubject: "SUCCESS!",
				// 	statusMessage: "Email sent Successfully!"
				// })

			} else {

				// this.toggle4();
				// this.setState({
				// 	statusSubject: "FAILED!",
				// 	statusMessage: "Failed to send Email to "+recipient+"."
				// })

			}

		}
		catch (err) {
			console.log(err);
		}

	};

	sendEmailMessage = async (emailAddress, type) => {

		var repairLogID = this.props.repairID;
		var serialNumber = document.getElementById("SerialNum").value;

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"email-invoice?EmailRecipient="+emailAddress+"&FileName="+this.state.invoicePDFName+"&SerialNumber="+serialNumber+"&RepairLogID="+repairLogID;

		if (type==1) {
			url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"email-customer-report?EmailRecipient="+emailAddress+"&FileName="+this.state.customerReportPDFName+"&SerialNumber="+serialNumber+"&RepairLogID="+repairLogID;

			if (this.state.loanerReturnLabelFiles.length>0) {
				var loanerFileNameURL = this.state.loanerReturnLabelFiles[0].url;
				var loanerFileName = loanerFileNameURL.replace("https://azena-repair-files.s3.us-west-2.amazonaws.com/", "");
				url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"email-customer-report?EmailRecipient="+emailAddress+"&FileName="+this.state.customerReportPDFName+"&SerialNumber="+serialNumber+"&RepairLogID="+repairLogID+"&LoanerReturnLabelFile="+loanerFileName;
			}
		}

		console.log("Send Email URL: " + url);

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("Send Email response: " + JSON.stringify(body));

			if (body.status == 'Success') {

				if (type==1) {
					this.toggle6();

					let fileURL = "https://azena-repair-files.s3.us-west-2.amazonaws.com/"+this.state.customerReportPDFName;
					const result = this.state.sectionThreeFiles.filter(file => file.url==fileURL);

					if (result.length==0) {
						console.log("Add Report File to DB");
						this.addFileToRepair(this.state.customerReportPDFName, 2);
					} else {
						console.log("Report File already added to DB");
					}
				} else {
					this.toggle3();
				}

				this.setState({
					statusSubject: "SUCCESS!",
					statusMessage: "Email sent Successfully!"
				})

			} else {

				if (type==1) {
					this.toggle6();
				} else {
					this.toggle3();
				}

				this.setState({
					statusSubject: "FAILED!",
					statusMessage: "Failed to send Email to "+emailAddress+"."
				})

			}

		}
		catch (err) {
			console.log(err);

			if (type==1) {
				this.toggle6();
			} else {
				this.toggle3();
			}

			this.setState({
				statusSubject: "FAILED!",
				statusMessage: "Failed to send Email to "+emailAddress+"."
			})
		}

		this.toggle5();

	};

	addShippingLabelToRepair = async (fileURL, section) => {

		//let fileURL = "https://azena-repair-files.s3.us-west-2.amazonaws.com/"+fileName;

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"add-file-to-repair?RepairLogID="+this.state.mediaHash+"&Section="+section+"&URL="+encodeURIComponent(fileURL);

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();

			console.log("upload response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				console.log("Added File Successfully!");
				this.getFilesForRepair(section);
			} else {
				//ADD ERROR MESSAGE
			}

		}
		catch (err) {
			console.log(err);
		}

	}

	addFileToRepair = async (fileName, section) => {

		let fileURL = "https://azena-repair-files.s3.us-west-2.amazonaws.com/"+fileName;

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"add-file-to-repair?RepairLogID="+this.state.mediaHash+"&URL="+fileURL+"&Section="+section;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();

			console.log("upload response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				console.log("Added File Successfully!");
				if (section == 0) {
					this.getFilesForRepair(section);
					document.getElementById("fileSectionOne").value = null;
					this.setState({ filePreviewOne: null, loadedOne: false });
				} else if (section == 1) {
					this.getFilesForRepair(section);
					document.getElementById("fileSectionTwo").value = null;
					this.setState({ filePreviewTwo: null, loadedTwo: false });
				} else if (section == 2) {
					this.getFilesForRepair(section);
					//document.getElementById("fileSectionThree").value = null;
					//this.setState({ filePreviewThree: null, loadedThree: false });
				} else if (section == 3) {
					await this.deletePurchaseOrderFileForRepair();
					this.getFilesForRepair(section);
					document.getElementById("filePurchaseOrder").value = null;
					this.setState({ filePreviewPurchaseOrder: null, loadedPurchaseOrder: false });
				} else if (section == 4) {
					await this.deleteLoanerReturnLabelFileForRepair();
					this.getFilesForRepair(section);
					document.getElementById("fileLoanerReturnLabel").value = null;
					this.setState({ filePreviewLoanerReturnLabel: null, loadedLoanerReturnLabel: false });
				}
			} else {
				//ADD ERROR MESSAGE
			}

		}
		catch (err) {
			console.log(err);
		}
		//https://azena-repair-files.s3.us-west-2.amazonaws.com/2038-s55ktm2m1akvbz21n33ur.png
	}

	deleteFileForRepair = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-file-for-repair?RepairFileID="+this.state.file.id;

		try {
			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();

			console.log("upload response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				console.log("Added Deleted Successfully!");
				this.toggle2();
				this.getFilesForRepair(this.state.file.section);
			} else {
				//ADD ERROR MESSAGE
			}
		}
		catch (err) {
			console.log("deleteFileForRepair error: "+err);
		}

	}

	deletePurchaseOrderFileForRepair = async () => {

		if (this.state.purchaseOrderFiles.length>0) {
			var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-file-for-repair?RepairFileID="+this.state.purchaseOrderFiles[0].id;

			try {
				const response = await fetch(url, {
					method: 'GET',
					headers: {
						Authorization: this.state.currentUser.jwtToken
					},
				});

				const body = await response.json();

				console.log("upload response: " + JSON.stringify(body));

				if (body.status == 'Success') {
					console.log("Deleted Successfully!");
					//this.toggle2();
					this.getFilesForRepair(this.state.file.section);
				} else {
					//ADD ERROR MESSAGE
				}
			}
			catch (err) {
				console.log("deleteFileForRepair error: "+err);
			}
		}

	}

	deleteLoanerReturnLabelFileForRepair = async () => {

		if (this.state.loanerReturnLabelFiles.length>0) {
			var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-file-for-repair?RepairFileID="+this.state.loanerReturnLabelFiles[0].id;

			try {
				const response = await fetch(url, {
					method: 'GET',
					headers: {
						Authorization: this.state.currentUser.jwtToken
					},
				});

				const body = await response.json();

				console.log("upload response: " + JSON.stringify(body));

				if (body.status == 'Success') {
					console.log("Deleted Successfully!");
					//this.toggle2();
					this.getFilesForRepair(this.state.file.section);
				} else {
					//ADD ERROR MESSAGE
				}
			}
			catch (err) {
				console.log("deleteFileForRepair error: "+err);
			}
		}

	}

	deleteRepairLog = async () => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"delete-repair-log?RepairID="+this.props.repairID;

		try {
			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();

			console.log("delete response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				console.log("Repair Deleted Successfully!");
				this.toggle8();

				let msg = "Repair "+this.props.repairID+" Deleted Successfully";

				toast.success(msg, {
					position: "top-center",
					autoClose: 2000,
					hideProgressBar: true,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
					theme: "dark",
					closeButton: false
				});

				setTimeout(this.goToActiveRepairs, 2000);
			} else {
				//ADD ERROR MESSAGE
			}
		}
		catch (err) {
			console.log("deleteFileForRepair error: "+err);
		}

	}

	getFilesForRepair = async (section) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"get-files-for-repair?RepairLogID="+this.props.repairID+"&Section="+section+"&MediaHash="+this.state.mediaHash;
		console.log("getFilesForRepair url: " + url);
		console.log("getFilesForRepair mediaHash: " + this.state.mediaHash);

		try {
			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();

			console.log("getFilesForRepair response: " + JSON.stringify(body));

			if (body.status == 'Success') {

				if (section==0) {
					this.setState({ sectionOneFiles: body.response });
				} else if (section==1) {
					this.setState({ sectionTwoFiles: body.response });
				} else if (section==2) {
					this.setState({ sectionThreeFiles: body.response });
				} else if (section==3) {
					this.setState({ purchaseOrderFiles: body.response });
				} else if (section==4) {
					this.setState({ loanerReturnLabelFiles: body.response });
				}

			} else {
				//ADD ERROR MESSAGE
			}
		}
		catch (err) {
			console.log("getFilesForRepair error: "+err);
		}

	}

	toggleOne () {

		if (this.state.sectionOneTitle=="Open"){
			this.setState({ sectionOneTitle: "Close" });
		} else {
			this.setState({ sectionOneTitle: "Open" });
		}

		this.setState({ isOneOpen: !this.state.isOneOpen });
	}

	toggleTwo () {

		if (this.state.sectionTwoTitle=="Open"){
			this.setState({ sectionTwoTitle: "Close" });
		} else {
			this.setState({ sectionTwoTitle: "Open" });
		}

		this.setState({ isTwoOpen: !this.state.isTwoOpen });
	}

	toggleThree () {

		if (this.state.sectionThreeTitle=="Open"){
			this.setState({ sectionThreeTitle: "Close" });
		} else {
			this.setState({ sectionThreeTitle: "Open" });
		}

		this.setState({ isThreeOpen: !this.state.isThreeOpen });
	}

	saveRepairLog() {



	}

	goToRepairLog(id){
		window.location.href="/repair-log/"+id;
	}

	onChange = (event) => {

		console.log("input id: " + event.target.id);
		console.log("input value: " + event.target.value);
		console.log("checked value: " + event.target.checked);

		let id = event.target.id;
		let value = event.target.value;
		let checked = event.target.checked;

		var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));

		repairLog[id] = value;

		if (checked != undefined) {

			if (event.target.type == 'checkbox') {
				repairLog[id] = checked ? 1 : 0;
				console.log("set checked as value");
			} else if (event.target.type == 'date') {
				repairLog[id] = value;
				console.log("set checked as value");
			}

		}

		console.log("repairLog: " + JSON.stringify(repairLog));

		this.setState({repairLog});

	}

	onChangeFootpedalFlag = (event) => {

		console.log("input id: " + event.target.id);
		console.log("input value: " + event.target.value);
		console.log("checked value: " + event.target.checked);

		let id = event.target.id;
		let value = event.target.value;
		let checked = event.target.checked;

		if (checked != undefined) {

			if (event.target.type == 'checkbox') {
				this.setState({ footpedalFlag: checked });
				console.log("set checked as value");
			}

		}

		//console.log("repairLog: " + JSON.stringify(repairLog));

	}

	onChangeCategoryItemForRepair = (event, categoryItemValue) => {

		console.log("input id: " + event.target.id);
		console.log("input value: " + event.target.value);
		console.log("categoryItemValue: " + categoryItemValue);

		let id = event.target.id;
		let value = event.target.value;

		var categoryItemsForRepair = JSON.parse(JSON.stringify(this.state.categoryItemsForRepair));

		console.log("new categoryItemsForRepair to change: " + JSON.stringify(categoryItemsForRepair[categoryItemValue]));

		if (id.includes('CatItem')) {
			categoryItemsForRepair[categoryItemValue].CategoryItemID = value;
		} else if (id.includes('CustomerCaused')) {
			categoryItemsForRepair[categoryItemValue].CustomerCaused = value;
		}

		categoryItemsForRepair[categoryItemValue].RepairID = this.props.repairID;

		console.log("new categoryItemsForRepair: " + JSON.stringify(categoryItemsForRepair));

		this.setState({ categoryItemsForRepair: categoryItemsForRepair });
	}

	onChangeComponentItemForRepair = (event, componentItemValue) => {

		console.log("input id: " + event.target.id);
		console.log("input value: " + event.target.value);
		console.log("componentItemValue: " + componentItemValue);

		let id = event.target.id;
		let value = event.target.value;

		var componentItemsForRepair = JSON.parse(JSON.stringify(this.state.componentItemsForRepair));

		console.log("new componentItemsForRepair to change: " + JSON.stringify(componentItemsForRepair[componentItemValue]));

		if (id.includes('CQuantity')) {
			componentItemsForRepair[componentItemValue].Quantity = value;
		} else if (id.includes('CItem')) {
			componentItemsForRepair[componentItemValue].ComponentItemID = value;
		}

		componentItemsForRepair[componentItemValue].RepairID = this.props.repairID;

		console.log("new componentItemsForRepair: " + JSON.stringify(componentItemsForRepair));

		this.setState({ componentItemsForRepair: componentItemsForRepair });
	}

	onChangeQuoteItemForRepair = (event, quoteItemValue) => {

		console.log("input id: " + event.target.id);
		console.log("input value: " + event.target.value);
		console.log("quoteItemValue: " + quoteItemValue);

		let id = event.target.id;
		let value = event.target.value;

		var quoteItemsForRepair = JSON.parse(JSON.stringify(this.state.quoteItemsForRepair));

		console.log("new quoteItemsForRepair to change: " + JSON.stringify(quoteItemsForRepair[quoteItemValue]));

		if (id.includes('QQuantity')) {
			quoteItemsForRepair[quoteItemValue].Quantity = value;
		} else if (id.includes('QItem')) {
			quoteItemsForRepair[quoteItemValue].QuoteItemID = value;
		} else if (id.includes('QOptional')) {
			quoteItemsForRepair[quoteItemValue].Optional = value;
		}

		quoteItemsForRepair[quoteItemValue].RepairID = this.props.repairID;

		console.log("new quoteItemsForRepair: " + JSON.stringify(quoteItemsForRepair));

		this.setState({ quoteItemsForRepair: quoteItemsForRepair });
	}

	onChangeBOM = (event, bomValue) => {

		console.log("input id: " + event.target.id);
		console.log("input value: " + event.target.value);
		console.log("checked value: " + event.target.checked);

		let id = event.target.id;
		let value = event.target.value;
		//let checked = event.target.checked;

		var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));

		repairLog[id] = value;

		if (id=="IssueBOM1") {
			if (bomValue != 0) {
				var startValue = document.getElementById("IssueBOM1Quantity").value;
				var startBOMValue = document.getElementById("IssueBOM1").value;
				const result = this.state.bomData.filter(bom => bom.id==bomValue);
				console.log("Quantity: " + result[0].Quantity);
				var revisedQuantity = parseInt(result[0].Quantity) + parseInt(startValue);
				console.log("revisedQuantity: " + revisedQuantity);
				this.updateBOM(result[0], revisedQuantity);
			}
			repairLog.IssueBOM1Quantity = 0;
		} else if (id=="IssueBOM2") {
			if (bomValue != 0) {
				var startValue = document.getElementById("IssueBOM2Quantity").value;
				var startBOMValue = document.getElementById("IssueBOM2").value;
				const result = this.state.bomData.filter(bom => bom.id==bomValue);
				console.log("Quantity: " + result[0].Quantity);
				var revisedQuantity = parseInt(result[0].Quantity) + parseInt(startValue);
				console.log("revisedQuantity: " + revisedQuantity);
				this.updateBOM(result[0], revisedQuantity);
			}

			repairLog.IssueBOM2Quantity = 0;
		} else if (id=="IssueBOM3") {
			if (bomValue != 0) {
				var startValue = document.getElementById("IssueBOM3Quantity").value;
				var startBOMValue = document.getElementById("IssueBOM3").value;
				const result = this.state.bomData.filter(bom => bom.id==bomValue);
				console.log("Quantity: " + result[0].Quantity);
				var revisedQuantity = parseInt(result[0].Quantity) + parseInt(startValue);
				console.log("revisedQuantity: " + revisedQuantity);
				this.updateBOM(result[0], revisedQuantity);
			}

			repairLog.IssueBOM3Quantity = 0;
		} else if (id=="IssueBOM4") {
			if (bomValue != 0) {
				var startValue = document.getElementById("IssueBOM4Quantity").value;
				var startBOMValue = document.getElementById("IssueBOM4").value;
				const result = this.state.bomData.filter(bom => bom.id==bomValue);
				console.log("Quantity: " + result[0].Quantity);
				var revisedQuantity = parseInt(result[0].Quantity) + parseInt(startValue);
				console.log("revisedQuantity: " + revisedQuantity);
				this.updateBOM(result[0], revisedQuantity);
			}

			repairLog.IssueBOM4Quantity = 0;
		} else if (id=="IssueBOM5") {
			if (bomValue != 0) {
				var startValue = document.getElementById("IssueBOM5Quantity").value;
				var startBOMValue = document.getElementById("IssueBOM5").value;
				const result = this.state.bomData.filter(bom => bom.id==bomValue);
				console.log("Quantity: " + result[0].Quantity);
				var revisedQuantity = parseInt(result[0].Quantity) + parseInt(startValue);
				console.log("revisedQuantity: " + revisedQuantity);
				this.updateBOM(result[0], revisedQuantity);
			}

			repairLog.IssueBOM5Quantity = 0;
		} else if (id=="IssueBOM6") {
			if (bomValue != 0) {
				var startValue = document.getElementById("IssueBOM6Quantity").value;
				var startBOMValue = document.getElementById("IssueBOM6").value;
				const result = this.state.bomData.filter(bom => bom.id==bomValue);
				console.log("Quantity: " + result[0].Quantity);
				var revisedQuantity = parseInt(result[0].Quantity) + parseInt(startValue);
				console.log("revisedQuantity: " + revisedQuantity);
				this.updateBOM(result[0], revisedQuantity);
			}

			repairLog.IssueBOM6Quantity = 0;
		}

		this.setState({repairLog});

	}

	onChangeQuantity = (event, issueBom) => {

		console.log("input id: " + event.target.id);
		console.log("input value: " + event.target.value);
		console.log("checked value: " + event.target.checked);

		let id = event.target.id;
		let value = event.target.value;
		//let checked = event.target.checked;

		var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));

		console.log("id value: " + issueBom);

		const result = this.state.bomData.filter(bom => bom.id==issueBom);

		console.log("Quantity: " + result[0].Quantity);

		var startValue = repairLog[id];

		console.log("Start Value: " + startValue);

		console.log("New Value: " + value);

		var revisedQuantity = 0;

		if (value == "100") {
			let complimentaryValue = 1;
			revisedQuantity = parseInt(result[0].Quantity) + parseInt(startValue) - parseInt(complimentaryValue);
			console.log("revisedQuantity: " + revisedQuantity);
		} else {
			revisedQuantity = parseInt(result[0].Quantity) + parseInt(startValue) - parseInt(value);
			console.log("revisedQuantity: " + revisedQuantity);
		}

		if (!this.state.isInternationalRepair) {
			this.updateBOM(result[0], revisedQuantity);
		}

		repairLog[id] = value;

		this.setState({repairLog});

	}

	updateBOM = async (bom, quantity) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"edit-bill-of-materials?BomID="+bom.id+"&PartNumber="+bom.PartNumber+"&Cost="+bom.Cost+"&Description="+bom.Description+"&Quantity="+quantity;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("Update bomData response: " + JSON.stringify(body));

			if (body.status == 'Success') {

				//this.setState({deviceInfo: body.response});
				//console.log("Device Registered First Name: " + this.state.deviceInfo.userInfo.UserAttributes.filter(attribute => attribute.Name.includes("given_name")).map(filteredName => (filteredName.Value)));
				//this.state.noDataForDevices = false;
				this.getBOMData();
			} else {
				//this.state.noDataForDevices = true;
			}

		}
		catch (err) {
			console.log(err);
		}

	};


	//UNUSED, Save for possible future use.
// 	getBOMLatestChange = async (bom, quantity) => {
//
// 		if (quantity <= bom.QuantityFlag && this.state.market != "us") {
// 			console.log("Send Quantity Flag email!");
//
// 			let recipient = "ryan.a.stickel@gmail.com";
// 			let subject = "INTL Quantity Alert";
// 			let message = `The following inventory item Quantity Flag has been reached...
// Part Number: `+bom.PartNumber+`
// Cost: `+bom.Cost+`
// Description: `+bom.Description+`
// Current Quantity: `+quantity+`
// Quantity Flag Value: `+bom.QuantityFlag;
//
// 			this.sendQuantityAlertEmail(recipient, subject, message);
// 		}
//
// 	}



	// onChangeQuoteQuantity = (event, issueQuote) => {
	//
	// 	console.log("input id: " + event.target.id);
	// 	console.log("input value: " + event.target.value);
	// 	console.log("checked value: " + event.target.checked);
	//
	// 	let id = event.target.id;
	// 	let value = event.target.value;
	// 	//let checked = event.target.checked;
	//
	// 	var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));
	//
	// 	console.log("id value: " + issueQuote);
	//
	// 	const result = this.state.quoteData.filter(quote => quote.id==issueQuote);
	//
	// 	console.log("Quantity: " + result[0].Quantity);
	//
	// 	var startValue = repairLog[id];
	//
	// 	console.log("Start Value: " + startValue);
	//
	// 	console.log("New Value: " + value);
	//
	// 	var revisedQuantity = 0;
	//
	// 	if (value == "100") {
	// 		let complimentaryValue = 1;
	// 		revisedQuantity = parseInt(result[0].Quantity) + parseInt(startValue) - parseInt(complimentaryValue);
	// 		console.log("revisedQuantity: " + revisedQuantity);
	// 	} else {
	// 		revisedQuantity = parseInt(result[0].Quantity) + parseInt(startValue) - parseInt(value);
	// 		console.log("revisedQuantity: " + revisedQuantity);
	// 	}
	//
	// 	this.updateQuoteItem(result[0], revisedQuantity);
	//
	// 	repairLog[id] = value;
	//
	// 	this.setState({repairLog});
	//
	// }

	updateQuoteItem = async (quote, quantity) => {

		var url = "https://cqzybp52y3.execute-api.us-west-2.amazonaws.com"+process.env.REACT_APP_ENV+"edit-quote-item?QItemID="+quote.id+"&SKU="+quote.SKU+"&Cost="+quote.Cost+"&Description="+quote.Description+"&Quantity="+quantity;

		try {

			const response = await fetch(url, {
				method: 'GET',
				headers: {
					Authorization: this.state.currentUser.jwtToken
				},
			});

			const body = await response.json();
			console.log("Update quote item response: " + JSON.stringify(body));

			if (body.status == 'Success') {
				//this.setState({deviceInfo: body.response});
				//console.log("Device Registered First Name: " + this.state.deviceInfo.userInfo.UserAttributes.filter(attribute => attribute.Name.includes("given_name")).map(filteredName => (filteredName.Value)));
				//this.state.noDataForDevices = false;
				this.getQuoteData();
			} else {
				//this.state.noDataForDevices = true;
			}

		}
		catch (err) {
			console.log(err);
		}

	};

	onChangeProductName = (event) => {

		console.log("onChangeProductName input id: " + event.target.id);
		console.log("onChangeProductName input value: " + event.target.value);

		let id = event.target.id;
		let value = event.target.value;

		this.setState({ shipDateFormattedDate: "0000-00-00" });

		if (value != 'Select') {

			const selectedProduct = this.state.productsData.find(product => product.id==value);

			if (selectedProduct) {

				var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));

				repairLog[id] = selectedProduct.Name;

				console.log("repairLog: " + JSON.stringify(repairLog));

				//this.setState({repairLog});

				this.setSerialNumbersForProductID(value, selectedProduct.Name);

				repairLog.SerialNum = "";
				repairLog['BatchNum'] = "";
				this.setState({repairLog});

				//this.getRepairsForSerial(this.state.repairLog.SerialNum);

				setTimeout(() => {this.getRepairsForSerial(this.state.repairLog.SerialNum)}, 1000);

			}

			// if (productName=='EVO') {
			// 	let id = event.target.id;
			//
			// 	value = value.replace(' EVO', '');
			//
			// 	repairLog.SerialNum = value;
			//
			// 	const result = this.state.evoSerialNumbersAll.filter(serial => serial.SerialNumber.includes(value));
			//
			// 	console.log("onChangeSerialNumber EVO result: " + JSON.stringify(result));
			//
			// 	repairLog['BatchNum'] = result[0].BatchNumber;
			//
			// 	console.log("onChangeSerialNumber EVO repairLog: " + JSON.stringify(repairLog));
			//
			// 	this.setState({repairLog});
			// } else {
			// 	let id = event.target.id;
			//
			// 	repairLog.SerialNum = value;
			//
			// 	const result = this.state.serialNumbersAll.filter(serial => serial.SerialNumber.includes(value));
			//
			// 	console.log("onChangeSerialNumber Gemini result: " + JSON.stringify(result));
			//
			// 	repairLog['BatchNum'] = result[0].BatchNumber;
			//
			// 	console.log("onChangeSerialNumber Gemini repairLog: " + JSON.stringify(repairLog));
			//
			// 	this.setState({repairLog});
			// }

			// if (value=='EVO') {
			// 	var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));
			//
			// 	repairLog[id] = value;
			//
			// 	console.log("repairLog: " + JSON.stringify(repairLog));
			//
			// 	this.setState({repairLog});
			//
			// 	this.setState({serialNumbers: this.state.evoSerialNumbers, selectedProductName: 2});
			//
			// } else {
			// 	var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));
			//
			// 	repairLog[id] = value;
			//
			// 	console.log("repairLog: " + JSON.stringify(repairLog));
			//
			// 	this.setState({repairLog});
			//
			// 	this.setState({serialNumbers: this.state.g1SerialNumbers, selectedProductName: 1});
			// }

		}

	}

	onChangeSerialNumber = (event, value) => {

		console.log("onChangeSerialNumber input id: " + event.target.id);

		console.log("onChangeSerialNumber value: " + value);

		var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));

		console.log("repairLog ProductName: " + repairLog.ProductName);

		let productName = repairLog.ProductName;

		if (value != null) {

			let serial = value.replace(' EVO', '');

			const repair = this.state.activeRepairs.find(repair => repair.serialnum==serial && repair.ProductName==this.state.repairLog.ProductName);

			if (repair) {

				if (serial!="00003" && serial!="00004") {

					var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));

					repairLog.SerialNum = "";
					repairLog['BatchNum'] = "";
					this.setState({repairLog});

					setTimeout(() => {
					  console.log("Delayed for 1 second.");

						if (document.getElementById("SerialNum")) {

							console.log("clear SerialNum");
							document.getElementById("SerialNum").value = null;
						}

						let msg = "Active Repair "+repair.id+" already exists for serial: "+serial;

						toast.error(msg, {
							position: "top-center",
							autoClose: 4000,
							hideProgressBar: true,
							closeOnClick: true,
							pauseOnHover: true,
							draggable: true,
							progress: undefined,
							theme: "dark",
							closeButton: false,
							onClick: (() => {
								window.open(
								  "/repair-log/"+repair.id,
								  '_blank'
								);
							})
						});

					}, "500");

				}

			} else {

				if (productName=='EVO') {
					let id = event.target.id;

					value = value.replace(' EVO', '');

					repairLog.SerialNum = value;

					const result = this.state.evoSerialNumbersAll.filter(serial => serial.SerialNumber.includes(value));

					console.log("onChangeSerialNumber EVO result: " + JSON.stringify(result));

					repairLog['BatchNum'] = result[0].BatchNumber;

					this.setState({ kitType: result[0].Kit });

					if (result.length>0) {
						let udiCreationDate = result[0].creation_date;
						let udiKit = result[0].Kit;
						var udiCode = "00850010501086";
						var udiSerialCode = "G2-5-001";

						if (udiKit.toLowerCase() == "us") {
							udiCode = "00850010501062";
							udiSerialCode = "G2-5-001";
						} else if (udiKit.toLowerCase() == "intl") {
							udiCode = "00850010501079";
							udiSerialCode = "G2-5-002";
						} else if (udiKit.toLowerCase() == "demo") {
							udiCode = "00850010501086";
							udiSerialCode = "G2-5-003";
						} else if (udiKit.toLowerCase() == "brazil") {
							//TODO Add proper values
							udiCode = "00850010501161";
							udiSerialCode = "G2-005-1002";
						}

						let udiFormattedDate = Moment(udiCreationDate).utc(false).format('YYMMDD');
						console.log("onChangeSerialNumber EVO formattedDate: " + JSON.stringify(udiFormattedDate));
						console.log("onChangeSerialNumber EVO udiCode: " + JSON.stringify(udiCode));

						if (result[0].shipment_date) {
							//let shipDateFormattedDate = Moment(result[0].shipment_date).utc(false).format('YYYY-MM-DD');
							//console.log("onChangeSerialNumber EVO shipDateFormattedDate: " + JSON.stringify(shipDateFormattedDate));
							this.setState({ shipDateFormattedDate: result[0].shipment_date });
						} else {
							this.setState({ shipDateFormattedDate: "0000-00-00" });
						}

						this.setState({ udiCode: udiCode , udiDate: udiFormattedDate, udiSerialCode: udiSerialCode, warrantyPurchaseDate: result[0].WarrantyPurchaseDate, warrantyLength: result[0].WarrantyLength });
					}

					// let creationDate = result[0].creation_date;
					// let kit = result[0].Kit;
					// var udiCode = "00850010501086";
					//
					// if (kit.toLowerCase() == "us") {
					// 	udiCode = "00850010501062";
					// } else if (kit.toLowerCase() == "intl") {
					// 	udiCode = "00850010501079";
					// } else if (kit.toLowerCase() == "demo") {
					// 	udiCode = "00850010501086";
					// }
					//
					// let formattedDate = Moment(this.state.repairLog.TrackingDateAzena).utc(false).format('YYMMDD');
					// console.log("onChangeSerialNumber EVO formattedDate: " + JSON.stringify(formattedDate));
					//
					// this.setState({ udiCode: udiCode , udiDate: formattedDate });

					console.log("onChangeSerialNumber EVO repairLog: " + JSON.stringify(repairLog));

					this.setState({repairLog});
				} else {
					let id = event.target.id;

					repairLog.SerialNum = value;

					const result = this.getSerialRecordForProduct(productName, value);

					console.log("result: " + JSON.stringify(result));

					if (result) {
						if (this.isNovaProductName(productName)) {
							const novaUDI = this.getNovaUDIValues(result, value);
							this.setState({
								kitType: result.Kit,
								udiCode: novaUDI.udiCode,
								udiDate: novaUDI.udiDate,
								udiSerialCode: novaUDI.udiSerialCode,
								warrantyPurchaseDate: result.WarrantyPurchaseDate,
								warrantyLength: result.WarrantyLength
							});
						} else {
							let udiDate = result.MFGDate;
							let udiKit = result.BatchNumber;
							this.setState({ kitType: result.BatchNumber });
							var udiCode = result.udiCode;
							var udiSerialCode = result.SerialCode;

							this.setState({ udiCode: udiCode , udiDate: udiDate, udiSerialCode: udiSerialCode });
						}

						repairLog['BatchNum'] = result.BatchNumber;

						console.log("onChangeSerialNumber Gemini repairLog: " + JSON.stringify(repairLog));
					}

					this.setState({repairLog});

				}

			}

		} else {
			var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));

			repairLog.SerialNum = "";
			repairLog['BatchNum'] = "";
			this.setState({repairLog});
		}

	}

	onChangeCountry = (event, value) => {

		console.log("onChangeCountry input id: " + event.target.id);

		console.log("onChangeCountry value: " + value);

		var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));

		console.log("repairLog Country: " + repairLog.Country);

		//let countryName = repairLog.Country;

		if (value != null) {

			//let id = event.target.id;

			repairLog.Country = value;

			this.setState({repairLog});

		} else {
			//var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));

			repairLog.Country = "";
			//repairLog['BatchNum'] = "";
			this.setState({repairLog});
		}

	}

	onChangeRepairSelection = (event) => {

		console.log("onChangeCustomerNotesSelect input id: " + event.target.id);
		console.log("onChangeCustomerNotesSelect input value: " + event.target.value);

		let id = event.target.id;
		let value = event.target.value;

		this.setState({ selectedModalRepair: value });

	}

	onChangeCustomerNotesSelect = (event) => {

		console.log("onChangeCustomerNotesSelect input id: " + event.target.id);
		console.log("onChangeCustomerNotesSelect input value: " + event.target.value);
		console.log("onChangeCustomerNotesSelect checked value: " + event.target.checked);

		let id = event.target.id;
		let value = event.target.value;
		let checked = event.target.checked;

		const result = this.state.repairCustomerNotes.filter(note => note.id==value);
		console.log("onChangeCustomerNotesSelect result: " + JSON.stringify(result));

		this.setState({ selectedCustomerNoteID: value});
		// this.setState({ customerNotes: result[0].Message});
		// document.getElementById("customerNotes").value = result[0].Message;

	}

	addCustomerNote = () => {

		const result = this.state.repairCustomerNotes.filter(note => note.id==this.state.selectedCustomerNoteID);
		console.log("addCustomerNote result: " + JSON.stringify(result));

		if (document.getElementById("customerNotes")) {
			var customerNotesString = document.getElementById("customerNotes").value;

			customerNotesString = customerNotesString + "\n\n" + result[0].Message
			this.setState({ customerNotes: customerNotesString});
			document.getElementById("customerNotes").value = customerNotesString;
		}

	}

	onChangeTAMName = (event) => {

		console.log("onChangeTAMName input id: " + event.target.id);
		console.log("onChangeTAMName input value: " + event.target.value);
		console.log("onChangeTAMName checked value: " + event.target.checked);

		let id = event.target.id;
		let value = event.target.value;
		let checked = event.target.checked;

		var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));

		repairLog[id] = value;

		const result = this.state.tamData.filter(tam => tam.name.includes(value));

		console.log("onChangeTAMName result: " + JSON.stringify(result));

		repairLog['TamPhone'] = result[0].phone;

		console.log("onChangeTAMName repairLog: " + JSON.stringify(repairLog));

		this.setState({repairLog});

	}

	onChangeDealerName = (event) => {

		console.log("onChangeDealerName input id: " + event.target.id);
		console.log("onChangeDealerName input value: " + event.target.value);
		console.log("onChangeDealerName checked value: " + event.target.checked);

		let id = event.target.id;
		let value = event.target.value;
		let checked = event.target.checked;

		var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));

		repairLog[id] = value;

		// const result = this.state.tamData.filter(tam => tam.name.includes(value));
		//
		// console.log("onChangeTAMName result: " + JSON.stringify(result));
		//
		// repairLog['TamPhone'] = result[0].phone;

		console.log("onChangeDealerName repairLog: " + JSON.stringify(repairLog));

		this.setState({repairLog});

	}

	onChangeUnitType = (event) => {

		console.log("onChangeUnitType input id: " + event.target.id);
		console.log("onChangeUnitType input value: " + event.target.value);
		console.log("onChangeUnitType checked value: " + event.target.checked);

		let id = event.target.id;
		let value = event.target.value;
		let checked = event.target.checked;

		var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));

		repairLog[id] = value;

		if (value=="INTL") {
			this.setState({ isInternationalRepair: true });
		} else {
			this.setState({ isInternationalRepair: false });
		}

		console.log("onChangeUnitType repairLog: " + JSON.stringify(repairLog));

		this.setState({repairLog});

	}

	onChangeMarket = (event) => {

		console.log("onChangeMarket input id: " + event.target.id);
		console.log("onChangeMarket input value: " + event.target.value);

		let id = event.target.id;
		let value = event.target.value;

		this.setState({ market: value });

		var repairLog = JSON.parse(JSON.stringify(this.state.repairLog));

		repairLog[id] = value;

		this.setState({repairLog});

		//await this.getTAMData();
		//await this.getDealerData();
		setTimeout(this.getTAMData, 300);
		setTimeout(this.getDealerData, 300);

	}

	onChangeRepairNotes = (event) => {

		console.log("onChangeRepairNotes input id: " + event.target.id);
		console.log("onChangeRepairNotes input value: " + event.target.value);

		let id = event.target.id;
		let value = event.target.value;

		this.setState({ detailedRepair: value});

	}

	onChangeCustomerNotes = (event) => {

		console.log("onChangeCustomerNotes input id: " + event.target.id);
		console.log("onChangeCustomerNotes input value: " + event.target.value);

		let id = event.target.id;
		let value = event.target.value;

		this.setState({ customerNotes: value});

	}

	onChangeManualTAMChecked = (event) => {

		console.log("input id: " + event.target.id);
		console.log("input value: " + event.target.value);
		console.log("checked value: " + event.target.checked);

		let id = event.target.id;
		let value = event.target.value;
		let checked = event.target.checked;

		if (checked != undefined) {

			if (event.target.type == 'checkbox') {
				//repairLog[id] = checked ? 1 : 0;
				console.log("set checked as value");
				this.setState({manualTAMChecked: checked});
			}

		}

	}

	onTextAreaChange = (value) => {
    this.setState({detailedIssue:value});
    // if (this.props.onChange) {
    //   // Send the changes up to the parent component as an HTML string.
    //   // This is here to demonstrate using `.toString()` but in a real app it
    //   // would be better to avoid generating a string on each change.
    //   this.props.onChange(
    //     value.toString('html')
    //   );
    // }
  };

	goToRepairLog2(id){
		//window.location.href="/repair-log/"+id;
		window.open(
		  "/repair-log/"+id,
		  '_blank'
		);
	}

	createSnapShot() {

		console.log('createSnapShot Clicked!');

		var node = document.getElementById('UPICard');

		html2canvas(node).then((canvas)=>{
				var image = canvas.toDataURL('image/png', 1.0);
				//saveAs(image, 'exported-vis.png')
				this.setState({ testImageFile: image });
		})

		// htmlToImage.toPng(node)
		//   .then(function (dataUrl) {
		// 		console.log('Snapshot Success!');
		//     //var img = new Image();
		// 		console.log('Snapshot url:'+dataUrl);
		// 		//this.setState({ testImageFile: dataUrl });
		// 		var image = dataUrl.toDataURL('image/png', 1.0);
		// 		this.setState({ testImageFile: image });
		//
		//     //img.src = dataUrl;
		//     //document.body.appendChild(img);
		//   })
		//   .catch(function (error) {
		//     console.error('oops, something went wrong!', error);
		//   });

  };

	is_video_url_extension (url) {

		var ext = url.split(/[#?]/)[0].split('.').pop().trim();

		var isVideo = false;

		if (ext == "mp4") {
			isVideo = true;
		} else if (ext == "m4a") {
			isVideo = true;
		} else if (ext == "m4p") {
			isVideo = true;
		} else if (ext == "m4b") {
			isVideo = true;
		} else if (ext == "m4r") {
			isVideo = true;
		} else if (ext == "m4v") {
			isVideo = true;
		} else if (ext == "mov") {
			isVideo = true;
		} else if (ext == "m4v") {
			isVideo = true;
		}

	  return isVideo;
	}

	is_pdf_url_extension (url) {

		var ext = url.split(/[#?]/)[0].split('.').pop().trim();

		var isPDF = false;

		if (ext == "pdf") {
			isPDF = true;
		}

	  return isPDF;
	}

	video_url_extension (url) {

		var ext = url.split(/[#?]/)[0].split('.').pop().trim();

	  return ext;
	}

  render() {

		var userName = "";
		var techEmail = "";
		var techRepair = "";
		var isAdmin = false;

		if (this.state.currentUser.payload['custom:role']==2) {
			isAdmin = true;
		}

		if (this.state.currentUser) {
			userName = this.state.currentUser.payload.given_name + " " + this.state.currentUser.payload.family_name;
			console.log("userName: " + userName);

			techEmail = this.state.currentUser.payload.email;
			console.log("techEmail: " + techEmail);

		}

		if (this.state.isNewRepairLog) {

			if (this.state.currentUser.payload['custom:market'] && this.state.currentUser.payload['custom:market']=="us-azena") {
				techRepair = userName;
			}

		} else {

			userName = this.state.repairLog.TechnicianLog;
			techEmail = this.state.repairLog.TechnicianEmail;

			if (this.state.repairLog.TechnicianRepair) {

				if (this.state.repairLog.TechnicianRepair.length>0) {
					techRepair = this.state.repairLog.TechnicianRepair;
				} else {
					if (this.state.currentUser.payload['custom:market'] && this.state.currentUser.payload['custom:market']=="us-azena") {
						techRepair = userName;
					}
				}

			} else {

				if (this.state.currentUser.payload['custom:market'] && this.state.currentUser.payload['custom:market']=="us-azena") {
					techRepair = userName;
				}
				//console.log("techRepair: " + techRepair);
			}

		}

		if (this.state.userName != userName || this.state.techEmail != techEmail) {
			this.setState({ userName, techEmail });
		}

		if (this.state.techRepair != techRepair) {
			this.setState({ techRepair });
		}

		console.log("techRepair: " + techRepair);
		console.log("userName: " + userName);

		var sectionOneUrl = {};

		if (this.state.sectionOneFiles.length>0) {
			sectionOneUrl = this.state.sectionOneFiles[this.state.lightBoxIndex];
			console.log("sectionOneUrl: " + JSON.stringify(sectionOneUrl));
		}

		var sectionTwoUrl = {};

		if (this.state.sectionTwoFiles.length>0) {
			sectionTwoUrl = this.state.sectionTwoFiles[this.state.lightBoxIndex];
			console.log("sectionTwoUrl: " + JSON.stringify(sectionTwoUrl));
		}

		var sectionThreeUrl = {};

		if (this.state.sectionThreeFiles.length>0) {
			sectionThreeUrl = this.state.sectionThreeFiles[this.state.lightBoxIndex];
			console.log("sectionThreeUrl: " + JSON.stringify(sectionThreeUrl));
		}

		var purchaseOrderURL = {};

		if (this.state.purchaseOrderFiles.length>0) {
			purchaseOrderURL = this.state.purchaseOrderFiles[0];
			console.log("purchaseOrderURL: " + JSON.stringify(purchaseOrderURL));
		}

		var loanerReturnLabelURL = {};

		if (this.state.loanerReturnLabelFiles.length>0) {
			loanerReturnLabelURL = this.state.loanerReturnLabelFiles[0];
			console.log("loanerReturnLabelURL: " + JSON.stringify(loanerReturnLabelURL));
		}

		//NEED TO CHANGE BASED ON REPAIR ID<3000**********
		//var old = Moment(this.state.repairLog.DateCreated).isBefore('2021-07-31');
		var old = false;
		if (this.props.repairID<3000) {
			old = true;
		}
		console.log("is old: " + old);


		//3608

		var d1 = Moment(this.state.repairLog.OriginalShipDate);
		var d2 = Moment();

		if (this.state.repairLog.DateCreated) {
			d2 = Moment(this.state.repairLog.DateCreated).utc(false);
		}

		var underWarrantyValue = "Unit out of warranty";

		console.log("d1: " + d1);
		console.log("d2: " + d2);

		console.log("date diff: " + d2.diff(d1, 'days'));

		if (d2.diff(d1, 'days')<731) {
			underWarrantyValue = "Unit under warranty"
		}

		if (this.state.warrantyLength==2 || this.state.warrantyLength==3) {
			//var wd1 = Moment(this.state.warrantyPurchaseDate).utc(false);
			var wd2 = Moment().utc(false);

			if (this.state.repairLog.DateCreated) {
				wd2 = Moment(this.state.repairLog.DateCreated).utc(false);
			}

			//console.log("wd1: " + wd1);
			console.log("wd2: " + wd2);

			console.log("date diff: " + wd2.diff(d1, 'years', true));

			if (wd2.diff(d1, 'years', true)<(2+parseInt(this.state.warrantyLength))) {
				underWarrantyValue = "Unit under warranty"
			}
		}

		var checkBatteryValue = "Battery Ok";

		if (d2.diff(d1, 'days')>548) {
			checkBatteryValue = "Check Battery"
		}

		let showQuoting = true;

		const unsavedQuoteItems = this.state.quoteItemsForRepair.filter(qItemA => qItemA.id==null);
		const unsavedComponentItems = this.state.componentItemsForRepair.filter(cItemA => cItemA.id==null);

		var dealer = {};

		if (this.state.dealerData) {
			dealer = this.state.dealerData.find(dealer => dealer.Name==this.state.repairLog.DealerName);
		}

		// if (this.state.repairLog) {
		// 	const udiSerial = this.state.evoSerialNumbersAll.filter(serial => serial.SerialNumber.includes(this.state.repairLog.SerialNum));
		//
		// 	console.log("udiSerial: " + JSON.stringify(udiSerial));
		//
		// 	if (udiSerial.length>0) {
		// 		let udiCreationDate = udiSerial[0].creation_date;
		// 		let udiKit = udiSerial[0].Kit;
		// 		var udiCode = "00850010501086";
		//
		// 		if (udiKit.toLowerCase() == "us") {
		// 			udiCode = "00850010501062";
		// 		} else if (udiKit.toLowerCase() == "intl") {
		// 			udiCode = "00850010501079";
		// 		} else if (udiKit.toLowerCase() == "demo") {
		// 			udiCode = "00850010501086";
		// 		}
		//
		// 		let udiFormattedDate = Moment(udiCreationDate).utc(false).format('YYMMDD');
		// 		console.log("udiSerial EVO formattedDate: " + JSON.stringify(udiFormattedDate));
		// 		console.log("udiSerial EVO udiCode: " + JSON.stringify(udiCode));
		//
		// 		this.setState({ udiCode: udiCode , udiDate: udiFormattedDate });
		// 	}
		// }

		var purchaseDateDisabled = false;

		if (isAdmin) {
			purchaseDateDisabled = false;
		} else {

			if (this.state.repairLog.ProductName=="EVO") {
				purchaseDateDisabled = true;

				if (this.state.isInternationalRepair || this.state.kitType=='Intl' || this.state.kitType=='Demo' || this.state.kitType=='Brazil') {
					purchaseDateDisabled = false;
				}

			} else {
				purchaseDateDisabled = false;
			}

		}

		console.log("this.state.repairLog.TamName: "+this.state.repairLog.TamName)

		return (
			<Fragment>
				{this.state.loadingRepair ? (
					<Fragment>
						<Fade in="true">
							<Row className="justify-content-center">
								<Loader type="ThreeDots" color="#ffc108" height={200} width={200}/>
							</Row>
						</Fade>
					</Fragment>
				) : (
				<Fragment>
				<div
				  className="repair-log-fixed-header pb-2 border-bottom pr-3"
				  style={{
				    position: "fixed",
				    top: 0,
				    right: 0,
				    zIndex: 1,
				    paddingTop: "80px",
						paddingLeft: "30px",
				    backgroundColor: "#282B31"
				  }}
				>
				  {this.state.isNewRepairLog ? (
				    <Row className="align-items-center">
				      <Col xs="12" className="d-flex justify-content-between align-items-center flex-wrap">
				        <h1 style={{ color: "#737782", marginBottom: 0 }}>New Repair Log</h1>

				        <Button
				          size="lg"
				          color="yellow"
				          title="Save"
				          onClick={() => this.updateRepairLog()}
				          disabled={this.state.isBeingSaved}
				        >
				          Save
				        </Button>
				      </Col>
				    </Row>
				  ) : (
				    <Row className="align-items-start">
				      <Col xs="12" lg="8" className="mb-2">
				        <div className="d-flex flex-column align-items-start">
				          <h1 style={{ color: "#737782", marginBottom: 0 }}>
				            Repair Log - {this.props.repairID}
				          </h1>

				          <div
				            className="d-flex align-items-start flex-wrap"
				            style={{
				              marginTop: "8px",
				              gap: "12px"
				            }}
				          >
				            <Button
				              size="sm"
				              color="yellow"
				              title="View Update History"
				              onClick={() => this.getAndShowRepairHistoryLogs()}
				            >
				              Update History
				            </Button>

				            <div
				              style={{
				                color: "#a1a5b1",
				                fontSize: "12px",
				                lineHeight: "1.5",
				                textAlign: "left"
				              }}
				            >
				              <div>Created: {this.state.initialSaveLabel}</div>
				              <div>Last Update: {this.state.latestUpdateLabel}</div>
				            </div>
				          </div>
				        </div>
				      </Col>

				      <Col xs="12" lg="4">
				        <div
				          className="d-flex justify-content-lg-end flex-wrap"
				          style={{ gap: "10px" }}
				        >
				          {this.state.currentUser &&
				            this.state.currentUser.payload["custom:role"] &&
				            this.state.currentUser.payload["custom:role"] > 1 && (
				              <Button
				                size="lg"
				                color="danger"
				                title="Delete"
				                onClick={() => this.toggle8()}
				              >
				                Delete
				              </Button>
				            )}

				          <Button
				            size="lg"
				            color="yellow"
				            title="Update"
				            onClick={() => this.updateRepairLog()}
				            disabled={this.state.isBeingSaved}
				          >
				            Update
				          </Button>
				        </div>
				      </Col>
				    </Row>
				  )}
				</div>
				<Row style={{ paddingTop: "100px" }}>
					<Col md="6">
						<h1 style={{color:'#737782'}}>UPI Technical Information</h1>
					</Col>
					<Col md="6">
						{this.state.isOneOpen ? (
							<Fragment>
								<i style={{color:'#ffc108'}} className="mdi mdi-arrow-up-drop-circle-outline mdi-36px float-right" onClick={this.toggleOne}/>
							</Fragment>
						) : (
							<Fragment>
								<i style={{color:'#ffc108'}} className="mdi mdi-arrow-down-drop-circle-outline mdi-36px float-right" onClick={this.toggleOne}/>
							</Fragment>
						)}
					</Col>
				</Row>
				<Collapse isOpen={this.state.isOneOpen}>
					<Row>
						<Col md="12">
							<Card className="card-hover">
								<CardBody id="UPICard">
									<Row className="mb-3">
										<Col md="6">
											<Row className="">
												<Col xs="4" md="4" lg="4">
													<Label style={{fontSize:'18px'}}>Technician Name:</Label>
												</Col>
												<Col xs="7" md="7" lg="7">
													{this.state.isNewRepairLog ? (
														<Label style={{fontSize:'18px'}} id="TechnicianLog">{userName}</Label>
													) : (
														<Label style={{fontSize:'18px'}} id="TechnicianLog">{userName}</Label>
													)}
												</Col>
											</Row>
											<Row className="">
												<Col xs="4" md="4" lg="4">
													<Label style={{fontSize:'18px'}}>Technician Email:</Label>
												</Col>
												<Col xs="7" md="7" lg="7">
													{this.state.isNewRepairLog ? (
														<Label style={{fontSize:'18px'}} id="TechnicianEmail">{techEmail}</Label>
													) : (
														<Label style={{fontSize:'18px'}} id="TechnicianEmail">{techEmail}</Label>
													)}
												</Col>
											</Row>
											<Row className="">
												<Col xs="4" md="4" lg="4">
													<Label style={{fontSize:'18px'}} for="ProductName">Product Name:</Label>
												</Col>
												<Col xs="7" md="7" lg="7">
													<Input style={{height: '30px', padding: '3px'}} type="select" name="ProductName" id="ProductName" value={this.state.selectedProductName} onChange={this.onChangeProductName}>
														<option value="Select">Select One</option>
														{this.state.productsData.map((product, i) => (
															<option value={product.id}>{product.Name}</option>
														))}
													</Input>
												</Col>
											</Row>
											{this.state.repairLog.ProductName && this.state.repairLog.ProductName != "" &&
												<Row className="pt-1">
													<Col xs="4" md="4" lg="4">
														<Label style={{fontSize:'18px', lineHeight:'3.4'}} for="SerialNum">Unit Serial Number:</Label>
													</Col>
													<Col xs="7" md="7" lg="7">
													{
														<ThemeProvider theme={theme}>
															<AutoCompleteInput
																value={((this.state.repairLog.ProductName=="EVO" && this.state.repairLog.SerialNum) ? this.state.repairLog.SerialNum+" EVO" : this.state.repairLog.SerialNum) || ""}
																onChange={this.onChangeSerialNumber}
																getItemValue={(item) => item.name}
																name="SerialNum"
																id="SerialNum"
																blurOnSelect={true}
																options={this.state.serialNumbers}
																renderOption={(option) => {

																	let serial = option.replace(' EVO', '');

																	const repair = this.state.activeRepairs.find(repair => repair.serialnum==serial && repair.ProductName==this.state.repairLog.ProductName);

																	if (repair) {

																		if (this.state.repairLog.SerialNum==repair.serialnum) {
																			return option;
																		} else if (serial=="00003" || serial=="00004") {
																			return option;
																		} else {
																			return (
																				<Fragment>
																            <div>{option} | ACTIVE LOG - <a href={"/repair-log/"+repair.id} target="_blank">{repair.id}</a></div>
																        </Fragment>
																			)
																		}

																	} else {
																		return option;
																	}

																	//return option;

																}}
																getOptionLabel={(option) => {

																	//console.log("AutoCompleteInput option: "+option);

																	let serial = option.replace(' EVO', '');

																	const repair = this.state.activeRepairs.find(repair => repair.serialnum==serial && repair.ProductName==this.state.repairLog.ProductName);

																	if (repair) {

																		if (this.state.repairLog.SerialNum==repair.serialnum) {
																			return option;
																		} else if (serial=="00003" || serial=="00004") {
																			return option;
																		} else {
																			return option + " | ACTIVE LOG - " + repair.id;
																		}

																	} else {
																		return option;
																	}


																	//return option;

																	//return ((this.state.repairLog.ProductName=="EVO" && this.state.repairLog.SerialNum) ? this.state.repairLog.SerialNum+" EVO" : this.state.repairLog.SerialNum) || "";

																}}
																getOptionDisabled={(option) => {

																	// let serial = option.replace(' EVO', '');
																	//
																	// const repair = this.state.activeRepairs.find(repair => repair.serialnum==serial && repair.ProductName==this.state.repairLog.ProductName);
																	//
																	// if (repair) {
																	//
																	// 	if (this.state.repairLog.SerialNum==repair.serialnum) {
																	// 		return false;
																	// 	} else {
																	// 		return true;
																	// 	}
																	//
																	// } else {
																	// 	return false;
																	// }

																	return false;

													      }}
																style={{ width: '100%', color: '#b2b9bf' }}
																renderInput={(params) => {

																	return <TextField {...params} id="SerialNumTextField" label="Serial Number" />;

																}}
															/>
														</ThemeProvider>
													}
													{
														// <Input style={{height: '30px', padding: '3px'}} type="select" name="SerialNum" id="SerialNum" value={this.state.repairLog.SerialNum} onChange={this.onChangeSerialNumber}>
														// 	<option value="0">Select Serial Number</option>
														// 	{this.state.serialNumbers.map((serial, i) => (
														// 		<Fragment>
														// 		{serial.SerialNumber.includes('EL-') ? (
														// 			<Fragment>
														// 				<option value={serial.SerialNumber.substring(serial.SerialNumber.length - 5)}>{serial.SerialNumber.substring(serial.SerialNumber.length - 5)}</option>
														// 			</Fragment>
														// 		) : (
														// 			<Fragment>
														// 				<option value={serial.SerialNumber}>{serial.SerialNumber}</option>
														// 			</Fragment>
														// 		)}
														// 		</Fragment>
														// 	))}
														// </Input>
													}
													</Col>
												</Row>
											}
											{this.state.repairLog.SerialNum && this.state.repairLog.SerialNum != "" &&
												<Row className="">
													<Col xs="4" md="4" lg="4">
														<Label style={{fontSize:'18px'}} for="BatchNum">Unit Batch Number:</Label>
													</Col>
													<Col xs="7" md="7" lg="7">
														<Label style={{fontSize:'18px'}} id="BatchNum">{this.state.repairLog.BatchNum}</Label>
													</Col>
												</Row>
											}
											{(this.state.repairLog.ProductName=="EVO" || this.isNovaProductName(this.state.repairLog.ProductName)) && this.state.repairLog.SerialNum && this.state.repairLog.SerialNum != "" &&
												<Row className="">
													<Col xs="4" md="4" lg="4">
														<Label style={{fontSize:'18px'}} for="KitType">Unit Kit Type:</Label>
													</Col>
													<Col xs="7" md="7" lg="7">
														<Label style={{fontSize:'18px'}} id="KitType">{this.state.kitType}</Label>
													</Col>
												</Row>
											}
											{this.state.udiCode && this.state.repairLog.SerialNum && this.state.repairLog.SerialNum != "" &&
												<Row className="mt-2 mb-2">
													<Col xs="4" md="4" lg="4">
														<Label style={{fontSize:'18px'}} for="UDI">UDI:</Label>
													</Col>
													<Col xs="7" md="7" lg="7">
														<div width="100%">
															<Label style={{fontSize:'14px'}} id="UDI">(01){this.state.udiCode} (11){this.state.udiDate}</Label>
														</div>
														<div width="100%">
															<Label style={{fontSize:'14px'}} id="UDI">(21){this.state.udiSerialCode}/{this.state.repairLog.SerialNum} (10){this.state.repairLog.BatchNum}</Label>
														</div>
													</Col>
												</Row>
											}
											{!this.state.udiCode && this.state.repairLog.SerialNum && this.state.repairLog.SerialNum != "" &&
												<Row className="mt-2 mb-2">
													<Col xs="4" md="4" lg="4">
														<Label style={{fontSize:'18px'}} for="UDI">UDI:</Label>
													</Col>
													<Col xs="7" md="7" lg="7">
														<div width="100%">
															<Label style={{fontSize:'14px'}} id="UDI">N/A</Label>
														</div>
													</Col>
												</Row>
											}
											{!this.state.isInternationalRepair &&
												<Fragment>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="RMANum">RMA Number:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{width:'100%', height: '30px'}} type="text" name="RMANum" id="RMANum" defaultValue={this.state.repairLog.RMANum}/>
														</Col>
													</Row>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="AgileNum">Agile Number:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{width:'100%', height: '30px'}} type="text" name="AgileNum" id="AgileNum" defaultValue={this.state.repairLog.AgileNum}/>
														</Col>
													</Row>
												</Fragment>
											}
											{this.state.currentUser.payload['custom:market'] && this.state.currentUser.payload['custom:market'].includes("us") && this.state.currentUser.payload['custom:role']==1 &&
											<Row className="">
												<Col xs="4" md="4" lg="4">
													<Label style={{fontSize:'18px'}} for="UnitType">Customer Type:</Label>
												</Col>
												{this.props.repairID ? (
													<Fragment>
													<Col xs="7" md="7" lg="7">
														{(this.state.currentUser && this.state.currentUser.payload['custom:role'] && this.state.currentUser.payload['custom:role']>1) || !this.state.isInternationalRepair ? (
															<Input style={{height: '30px', padding: '3px'}} type="select" name="UnitType" id="UnitType" value={this.state.repairLog.UnitType} onChange={this.onChangeUnitType} disabled={(this.state.market=="aus" || this.state.market=="europe" || this.state.market=="brazil" || this.state.market=="taiwan" || this.state.market=="colombia" || this.state.market=="mexico" || this.state.market=="czech") && this.state.currentUser.payload['custom:role']!=2}>
																<option value="LGP">LGP</option>
																<option value="UNIV">UNIV</option>
																<option value="DOM">DOM</option>
																<option value="GOV">GOV</option>
																<option value="INTL">INTL</option>
																<option value="LATAM">LATAM</option>
																<option value="APAC">APAC</option>
																<option value="DGS">DGS</option>
															</Input>
														) : (
															<Label style={{fontSize:'18px'}} id="UnitType">{this.state.repairLog.UnitType}</Label>
														)}
													</Col>
													</Fragment>
												) : (
													<Fragment>
													<Col xs="7" md="7" lg="7">
														{(this.state.currentUser && this.state.currentUser.payload['custom:role'] && this.state.currentUser.payload['custom:role']>1) || !this.state.isInternationalRepair ? (
															<Input style={{height: '30px', padding: '3px'}} type="select" name="UnitType" id="UnitType" value={this.state.repairLog.UnitType} onChange={this.onChangeUnitType} disabled={(this.state.market=="aus" || this.state.market=="europe" || this.state.market=="brazil" || this.state.market=="taiwan" || this.state.market=="colombia" || this.state.market=="mexico" || this.state.market=="czech") && this.state.currentUser.payload['custom:role']!=2}>
																<option value="LATAM">LATAM</option>
																<option value="APAC">APAC</option>
																<option value="DOM">DOM</option>
																<option value="DGS">DGS</option>
															</Input>
														) : (
															<Label style={{fontSize:'18px'}} id="UnitType">{this.state.repairLog.UnitType}</Label>
														)}
													</Col>
													</Fragment>
												)}
											</Row>
											}
											{this.state.currentUser.payload['custom:role']>1 &&
												<Row className="">
													<Col xs="4" md="4" lg="4">
														<Label style={{fontSize:'18px'}} for="UnitType">Customer Type:</Label>
													</Col>
													{this.props.repairID ? (
														<Fragment>
														<Col xs="7" md="7" lg="7">
															{(this.state.currentUser && this.state.currentUser.payload['custom:role'] && this.state.currentUser.payload['custom:role']>1) || !this.state.isInternationalRepair ? (
																<Input style={{height: '30px', padding: '3px'}} type="select" name="UnitType" id="UnitType" value={this.state.repairLog.UnitType} onChange={this.onChangeUnitType} disabled={(this.state.market=="aus" || this.state.market=="europe" || this.state.market=="brazil" || this.state.market=="taiwan" || this.state.market=="colombia" || this.state.market=="mexico" || this.state.market=="czech") && this.state.currentUser.payload['custom:role']!=2}>
																	<option value="LGP">LGP</option>
																	<option value="UNIV">UNIV</option>
																	<option value="DOM">DOM</option>
																	<option value="GOV">GOV</option>
																	<option value="INTL">INTL</option>
																	<option value="LATAM">LATAM</option>
																	<option value="APAC">APAC</option>
																	<option value="DGS">DGS</option>
																</Input>
															) : (
																<Label style={{fontSize:'18px'}} id="UnitType">{this.state.repairLog.UnitType}</Label>
															)}
														</Col>
														</Fragment>
													) : (
														<Fragment>
														<Col xs="7" md="7" lg="7">
															{(this.state.currentUser && this.state.currentUser.payload['custom:role'] && this.state.currentUser.payload['custom:role']>1) || !this.state.isInternationalRepair ? (
																<Input style={{height: '30px', padding: '3px'}} type="select" name="UnitType" id="UnitType" value={this.state.repairLog.UnitType} onChange={this.onChangeUnitType} disabled={(this.state.market=="aus" || this.state.market=="europe" || this.state.market=="brazil" || this.state.market=="taiwan" || this.state.market=="colombia" || this.state.market=="mexico" || this.state.market=="czech") && this.state.currentUser.payload['custom:role']!=2}>
																	<option value="LATAM">LATAM</option>
																	<option value="APAC">APAC</option>
																	<option value="DOM">DOM</option>
																	<option value="DGS">DGS</option>
																</Input>
															) : (
																<Label style={{fontSize:'18px'}} id="UnitType">{this.state.repairLog.UnitType}</Label>
															)}
														</Col>
														</Fragment>
													)}
												</Row>
											}
											{!this.props.repairID && this.state.currentUser && this.state.currentUser.payload['custom:role'] && this.state.currentUser.payload['custom:role']>1 ? (
												<Row className="">
													<Col xs="4" md="4" lg="4">
														<Label style={{fontSize:'18px'}} for="market">Repair Center Location:</Label>
													</Col>
													<Col xs="7" md="7" lg="7">
														<Input style={{height: '30px', padding: '3px'}} type="select" name="market" id="market" defaultValue={this.state.repairLog.market} onChange={this.onChangeMarket}>
															<option value="us">US</option>
															<option value="europe">Europe</option>
															<option value="aus">Australia</option>
															<option value="brazil">Brazil</option>
															<option value="taiwan">Taiwan</option>
															<option value="colombia">Colombia</option>
															<option value="mexico">Mexico</option>
															<option value="czech">Czech</option>
														</Input>
													</Col>
												</Row>
											) : (
												<Row className="">
													<Col xs="4" md="4" lg="4">
														<Label style={{fontSize:'18px'}} for="market">Repair Center Location:</Label>
													</Col>
													<Col xs="7" md="7" lg="7">
														{this.state.currentUser.payload['custom:role']>1 ? (
															<Input style={{height: '30px', padding: '3px'}} type="select" name="market" id="market" defaultValue={this.state.repairLog.market} onChange={this.onChangeMarket}>
																<option value="us">US</option>
																<option value="europe">Europe</option>
																<option value="aus">Australia</option>
																<option value="brazil">Brazil</option>
																<option value="taiwan">Taiwan</option>
																<option value="colombia">Colombia</option>
																<option value="mexico">Mexico</option>
																<option value="czech">Czech</option>
															</Input>
														) : (
															<Fragment>
															{this.state.market == "us" &&
																<Label style={{fontSize:'18px'}} id="Market">US</Label>
															}
															{this.state.market == "aus" &&
																<Label style={{fontSize:'18px'}} id="Market">Australia</Label>
															}
															{this.state.market == "europe" &&
																<Label style={{fontSize:'18px'}} id="Market">Europe</Label>
															}
															{this.state.market == "brazil" &&
																<Label style={{fontSize:'18px'}} id="Market">Brazil</Label>
															}
															{this.state.market == "taiwan" &&
																<Label style={{fontSize:'18px'}} id="Market">Taiwan</Label>
															}
															{this.state.market == "colombia" &&
																<Label style={{fontSize:'18px'}} id="Market">Colombia</Label>
															}
															{this.state.market == "mexico" &&
																<Label style={{fontSize:'18px'}} id="Market">Mexico</Label>
															}
															{this.state.market == "czech" &&
																<Label style={{fontSize:'18px'}} id="Market">Czech</Label>
															}
															</Fragment>
														)}
													</Col>
												</Row>
											)}
											<Row className="pb-3">
												<Col xs="4" md="4" lg="4">
													<Label style={{fontSize:'18px'}} for="UnitType">Log Creation Date:</Label>
												</Col>
												<Col xs="7" md="7" lg="7">
													<Input style={{width:'100%', height: '30px'}} type="date" name="DateCreated" id="DateCreated" value={Moment(this.state.repairLog.DateCreated).format('YYYY-MM-DD')} onChange={this.onChange} disabled/>
												</Col>
											</Row>
											<Row className="pb-1">
												<Col xs="4" md="4" lg="4">
												</Col>
												<Col xs="7" md="7" lg="7">
													<Label className="pr-4" style={{fontSize:'18px'}} for="UnitType">Manually Enter TAM Info: </Label><Input type="checkbox" name="manualTAMChecked" id="manualTAMChecked" checked={!!this.state.manualTAMChecked} onChange={this.onChangeManualTAMChecked}/>
												</Col>
											</Row>
											{this.state.manualTAMChecked ? (
												<Fragment>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="TamName">TAM Name:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{width:'100%', height: '30px'}} type="text" name="ManualTamName" id="ManualTamName" placeholder="Enter TAM Name" defaultValue={this.state.repairLog.TamName || ""}/>
														</Col>
													</Row>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="TamPhone">TAM Phone:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{width:'100%', height: '30px'}} type="text" name="ManualTamPhone" id="ManualTamPhone" placeholder="Enter TAM Phone Number" defaultValue=""/>
														</Col>
													</Row>
												</Fragment>
											) : (
												<Fragment>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="TamName">TAM Name:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{height: '30px', padding: '3px'}} type="select" name="TamName" id="TamName"
															value={
																(() => {

																	const tamName = this.state.repairLog.TamName;
																	console.log("Looking for:", tamName);

																	const match = this.state.tamData.find((tam) => {
																	  console.log("Comparing:", tam.name, "vs", tamName);
																	  return tam.name?.trim().toLowerCase() === tamName?.trim().toLowerCase();
																	});

																	console.log("match: "+match)

														      // If match found → canonical TAM name
														      if (match) {
														        return match.name;
														      }

														      return this.state.repairLog.TamName || "0";
														    })()
														  }
															onChange={this.onChangeTAMName}>
																<option value="0">Select TAM Name</option>
																{this.state.tamData.map((tam, i) => (
																	<option key={i} value={tam.name}>{tam.name}</option>
																))}
															</Input>
														</Col>
													</Row>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="TamPhone">TAM Phone:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{width:'100%', height: '30px'}} type="text" name="TamPhone" id="TamPhone" value={this.state.repairLog.TamPhone}/>
														</Col>
													</Row>
												</Fragment>
											)}
											{!this.state.isInternationalRepair &&
												<Row className="pt-2">
													<Col xs="4" md="4" lg="4">
														<Label style={{fontSize:'18px'}} for="UPIClosed">UPI Closed?</Label>
													</Col>
													<Col xs="7" md="7" lg="7">
														<Input style={{height: '30px', padding: '3px'}} type="select" name="UPIClosed" id="UPIClosed" value={this.state.repairLog.UPIClosed} onChange={this.onChange}>
															<option value=""></option>
															<option value="1">Yes</option>
															<option value="0">No</option>
														</Input>
													</Col>
												</Row>
											}
											<Row className="">
												<Col xs="4" md="4" lg="4">
													<Label style={{fontSize:'18px'}} for="Status">Status:</Label>
												</Col>
												<Col xs="7" md="7" lg="7">
													<Input style={{height: '30px', padding: '3px'}} type="select" name="Status" id="Status" value={this.state.repairLog.Status} onChange={this.onChange}>
														{!this.state.isNewRepairLog &&
															<option value="In Progress">In Progress</option>
														}
														<option value="Pending product return">Pending product return</option>
														<option value="Completed">Completed</option>
														<option value="Pending customer approval">Pending customer approval</option>
														<option value="Customer approved work">Customer approved work</option>
														<option value="Customer Denied - Return">Customer Denied - Return</option>
														{
															//<option value="Closed">Closed</option>
														}
													</Input>
												</Col>
											</Row>
											{this.state.isInternationalRepair && this.state.market!="brazil" &&
												<Fragment>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="TamName">Dealer Name:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{height: '30px', padding: '3px'}} type="select" name="DealerName" id="DealerName" value={this.state.repairLog.DealerName} onChange={this.onChangeDealerName}>
																<option value="0">Select Dealer</option>
																{this.state.dealerData.map((dealer, i) => (
																	<option value={dealer.Name}>{dealer.Name}</option>
																))}
															</Input>
														</Col>
													</Row>
													{dealer && this.state.repairLog.DealerName!=0 &&
														<Fragment>
														<Row className="mt-1">
															<Col xs="4" md="4" lg="4">
															</Col>
															<Col xs="7" md="7" lg="7">
																<Label style={{fontSize:'14px'}}>Contact Name: {dealer.ContactName}</Label>
															</Col>
														</Row>
														{dealer.Phone &&
														<Row className="mt-1">
															<Col xs="4" md="4" lg="4">
															</Col>
															<Col xs="7" md="7" lg="7">
																<Label style={{fontSize:'14px'}}>Phone: {dealer.Phone}</Label>
															</Col>
														</Row>
														}
														{dealer.Email &&
														<Row className="mt-1">
															<Col xs="4" md="4" lg="4">
															</Col>
															<Col xs="7" md="7" lg="7">
																<Label style={{fontSize:'14px'}}>Email: {dealer.Email}</Label>
															</Col>
														</Row>
														}
														<Row className="">
															<Col xs="4" md="4" lg="4">
															</Col>
															<Col xs="7" md="7" lg="7">
																<Label style={{fontSize:'14px'}}>Address: {dealer.Address}</Label>
															</Col>
														</Row>
														{dealer.Address2 &&
															<Row className="">
																<Col xs="4" md="4" lg="4">
																</Col>
																<Col xs="7" md="7" lg="7">
																	<Label style={{fontSize:'14px'}}>Address 2: {dealer.Address2}</Label>
																</Col>
															</Row>
														}
														<Row className="">
															<Col xs="4" md="4" lg="4">
															</Col>
															<Col xs="7" md="7" lg="7">
																<Label style={{fontSize:'14px'}}>City: {dealer.City}</Label>
															</Col>
														</Row>
														{dealer.County &&
															<Row className="">
																<Col xs="4" md="4" lg="4">
																</Col>
																<Col xs="7" md="7" lg="7">
																	<Label style={{fontSize:'14px'}}>County: {dealer.County}</Label>
																</Col>
															</Row>
														}
														<Row className="">
															<Col xs="4" md="4" lg="4">
															</Col>
															<Col xs="7" md="7" lg="7">
																<Label style={{fontSize:'14px'}}>State: {dealer.State}</Label>
															</Col>
														</Row>
														{dealer.Province &&
															<Row className="">
																<Col xs="4" md="4" lg="4">
																</Col>
																<Col xs="7" md="7" lg="7">
																	<Label style={{fontSize:'14px'}}>Province: {dealer.Province}</Label>
																</Col>
															</Row>
														}
														{dealer.Country &&
															<Row className="">
																<Col xs="4" md="4" lg="4">
																</Col>
																<Col xs="7" md="7" lg="7">
																	<Label style={{fontSize:'14px'}}>Country: {dealer.Country}</Label>
																</Col>
															</Row>
														}
														{dealer.PostalCode &&
															<Row className="">
																<Col xs="4" md="4" lg="4">
																</Col>
																<Col xs="7" md="7" lg="7">
																	<Label style={{fontSize:'14px'}}>Postal Code: {dealer.PostalCode}</Label>
																</Col>
															</Row>
														}
														</Fragment>
													}
												</Fragment>
											}
										</Col>
										<Col md="6">
											<Row className="">
												<Col xs="4" md="4" lg="4">
													<Label style={{fontSize:'18px'}} for="CustomerName">Office Name:</Label>
												</Col>
												<Col xs="7" md="7" lg="7">
													<Input style={{width:'100%', height: '30px'}} type="text" name="CustomerName" id="CustomerName" defaultValue={this.state.repairLog.CustomerName}/>
												</Col>
											</Row>
											<Row className="">
												<Col xs="4" md="4" lg="4">
													<Label style={{fontSize:'18px'}} for="ContactName">Contact Name:</Label>
												</Col>
												<Col xs="7" md="7" lg="7">
													<Input style={{width:'100%', height: '30px'}} type="text" name="ContactName" id="ContactName" defaultValue={this.state.repairLog.ContactName}/>
												</Col>
											</Row>
											{!this.state.isInternationalRepair ? (
												<Fragment>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="Address">Address:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
														{
															<Autocomplete className="form-control" style={{width:'100%', height: '30px', color: '#b2b9bf', backgroundColor: 'rgba(255, 255, 255, 0.0)'}} type="text" name="Address" id="Address" defaultValue={this.state.repairLog.Address}
																options={{
																	types: ["address"],
																	componentRestrictions: { country: "us" },
																}}
																onPlaceSelected={(place) => {
																	console.log(place);

																	var streetNumber = '';
																	var streetName = '';
																	var city = '';
																	var state = '';
																	var zip = '';

																	for (var i=0; i<place.address_components.length; i++) {

																		var component = place.address_components[i];

																		//console.log(component);

																		if (component.types[0]=='street_number') {
																			streetNumber = component.long_name;
																			console.log("streetNumber: " + streetNumber);
																		} else if (component.types[0]=='route') {
																			streetName = component.short_name;
																			console.log("streetName: " + streetName);
																		} else if (component.types[0]=='locality') {
																			city = component.short_name;
																			console.log("city: " + city);
																		} else if (component.types[0]=='administrative_area_level_1') {
																			state = component.short_name;
																			console.log("state: " + state);
																		} else if (component.types[0]=='postal_code') {
																			zip = component.short_name;
																			console.log("zip: " + zip);
																		}
																	}

																	document.getElementById("Address").value = streetNumber+" "+streetName;
																	document.getElementById("City").value = city;
																	document.getElementById("State").value = state;
																	document.getElementById("Zip").value = zip;

																}}
															/>
														}
														{
															//<Input style={{width:'100%', height: '30px'}} type="text" name="Address" id="Address" defaultValue={this.state.repairLog.Address} />
														}
														</Col>
													</Row>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="City">City:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{width:'100%', height: '30px'}} type="text" name="City" id="City" defaultValue={this.state.repairLog.City}/>
														</Col>
													</Row>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="State">State:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{width:'100%', height: '30px'}} type="text" name="State" id="State" defaultValue={this.state.repairLog.State}/>
														</Col>
													</Row>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="Zip">Zip Code:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{width:'100%', height: '30px'}} type="text" name="Zip" id="Zip" defaultValue={this.state.repairLog.Zip}/>
														</Col>
													</Row>
												</Fragment>
											) : (
												<Fragment>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="Address">Address:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
														{
															<Input style={{width:'100%', height: '30px'}} type="text" name="Address" id="Address" defaultValue={this.state.repairLog.Address} />
														}
														</Col>
													</Row>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="Address2">Address 2:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
														{
															<Input style={{width:'100%', height: '30px'}} type="text" name="Address2" id="Address2" defaultValue={this.state.repairLog.Address2} />
														}
														</Col>
													</Row>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="City">City:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{width:'100%', height: '30px'}} type="text" name="City" id="City" defaultValue={this.state.repairLog.City}/>
														</Col>
													</Row>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="Country">County:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{width:'100%', height: '30px'}} type="text" name="County" id="County" defaultValue={this.state.repairLog.County}/>
														</Col>
													</Row>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="State">State | Territory:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{width:'100%', height: '30px'}} type="text" name="State" id="State" defaultValue={this.state.repairLog.State}/>
														</Col>
													</Row>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="Province">Province:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{width:'100%', height: '30px'}} type="text" name="Province" id="Province" defaultValue={this.state.repairLog.Province}/>
														</Col>
													</Row>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="Zip">Postal Code:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{width:'100%', height: '30px'}} type="text" name="Zip" id="Zip" defaultValue={this.state.repairLog.Zip}/>
														</Col>
													</Row>
													{
														// <Row className="">
														// 	<Col xs="4" md="4" lg="4">
														// 		<Label style={{fontSize:'18px'}} for="Country2">Country:</Label>
														// 	</Col>
														// 	<Col xs="7" md="7" lg="7">
														// 		<Input style={{width:'100%', height: '30px'}} type="text" name="Country2" id="Country2" defaultValue={this.state.repairLog.Country}/>
														// 	</Col>
														// </Row>
													}
													<Row className="pt-1">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="Country">Country:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<ThemeProvider theme={theme}>
																<AutoCompleteInput
																	value={this.state.repairLog.Country}
																	onChange={this.onChangeCountry}
																	getItemValue={(item) => item.name}
																	name="Country"
																	id="Country"
																	options={countryData}
																	getOptionLabel={(option) => option}
																	style={{ width: '100%', color: '#b2b9bf' }}
																	renderInput={(params) => <TextField {...params} />}
																/>
															</ThemeProvider>
														</Col>
													</Row>
												</Fragment>
											)}
											<Row className="pt-2">
												<Col xs="4" md="4" lg="4">
													<Label style={{fontSize:'18px'}} for="email">Email:</Label>
												</Col>
												<Col xs="7" md="7" lg="7">
													<Input style={{width:'100%', height: '30px'}} type="text" name="email" id="email" defaultValue={this.state.repairLog.email} placeholder="You can add multiple emails with a coma"/>
												</Col>
											</Row>
											<Row className="">
												<Col xs="4" md="4" lg="4">
													<Label style={{fontSize:'18px'}} for="Action">Action:</Label>
												</Col>
												<Col xs="7" md="7" lg="7">
													<Input style={{height: '30px', padding: '3px'}} type="select" name="Action" id="Action" value={this.state.repairLog.Action} onChange={this.onChange}>
														<option value="Return to Customer">Return to Customer</option>
														<option value="Return to UPI">Return to UPI</option>
														{this.state.isInternationalRepair &&
															<Fragment>
															<option value="Return to Dealer">Return to Dealer</option>
															</Fragment>
														}
													</Input>
												</Col>
											</Row>
											<Row className="pb-1">
												<Col xs="4" md="4" lg="4">
													<Label style={{fontSize:'17px'}} for="TrackingNum">Tracking # to Repair Center:</Label>
												</Col>
												<Col xs="7" md="7" lg="7">
													<Input style={{width:'100%', height: '30px'}} type="text" name="TrackingNum" id="TrackingNum" defaultValue={this.state.repairLog.TrackingNum}/>
												</Col>
											</Row>
											<Row className="">
												<Col xs="4" md="4" lg="4">
													<Label style={{fontSize:'18px'}} for="TrackingDateAzena">Tracking Label Date:</Label>
												</Col>
												<Col xs="7" md="7" lg="7">
													<Input style={{width:'100%', height: '30px'}} type="date" name="TrackingDateAzena" id="TrackingDateAzena" value={Moment(this.state.repairLog.TrackingDateAzena).utc(false).format('YYYY-MM-DD')} onChange={this.onChange}/>
												</Col>
											</Row>
											{
												// <Row className="">
												// 	<Col xs="4" md="4" lg="4">
												// 		<Label style={{fontSize:'18px'}} for="ExpectedRepairDate">Expected Repair By:</Label>
												// 	</Col>
												// 	<Col xs="7" md="7" lg="7">
												// 		<Input style={{width:'100%', height: '30px'}} type="date" name="ExpectedRepairDate" id="ExpectedRepairDate" value={Moment(this.state.repairLog.ExpectedRepairDate).utc(false).format('YYYY-MM-DD')} onChange={this.onChange}/>
												// 	</Col>
												// </Row>
											}
											<Row className="">
												<Col xs="4" md="4" lg="4">
													<Label style={{fontSize:'18px'}} for="OriginalShipDate">Product Purchase Date:</Label>
												</Col>
												<Col xs="7" md="7" lg="7">
													<Input style={{width:'100%', height: '30px'}} type="date" name="OriginalShipDate" id="OriginalShipDate" value={this.state.repairLog.OriginalShipDate ? Moment(this.state.repairLog.OriginalShipDate).utc(false).format('YYYY-MM-DD') : Moment(this.state.shipDateFormattedDate).utc(false).format('YYYY-MM-DD')} onChange={this.onChange} disabled={purchaseDateDisabled}/>
												</Col>
											</Row>
											{this.state.repairLog.ProductName=="EVO" && this.state.repairLog.SerialNum && this.state.repairLog.SerialNum != "" && this.state.currentUser.payload['custom:market']!="brazil" &&
												<Row className="pt-1 pb-1">
													<Col xs="4" md="4" lg="4">
														<Label style={{fontSize:'18px'}} for="WarrantyLength">Extended Warranty:</Label>
													</Col>
													<Col className="text-center" xs="2" md="2" lg="2">
														{this.state.warrantyLength==2 || this.state.warrantyLength==3 ? (
															<Label style={{fontSize:'18px', color: "#ffc107"}} id="WarrantyLength">{this.state.warrantyLength} years</Label>
														) : (
															<Label style={{fontSize:'18px', color: "#ffc107"}} id="WarrantyLength">NO</Label>
														)}
													</Col>
													<Col xs="5" md="5" lg="5">
														{this.state.warrantyLength==2 || this.state.warrantyLength==3 ? (
															<Fragment>
																<Input className="float-right" style={{width:'60%', height: '30px'}} type="date" name="WarrantyPurchaseDate" id="WarrantyPurchaseDate" value={this.state.warrantyPurchaseDate ? Moment(this.state.warrantyPurchaseDate).utc(false).format('YYYY-MM-DD') : "0000-00-00"} disabled={true}/><Label className="float-right mr-3" style={{fontSize:'18px'}} id="KitType">Purchased: </Label>
															</Fragment>
														) : (
															<Label style={{fontSize:'18px', color: "#ffc107"}} id="KitType"></Label>
														)}
													</Col>
												</Row>
											}
											{this.state.deviceRepairs.length > 0 &&
												<Row className="pt-1">
													<Col xs="4" md="4" lg="4">
														<Label style={{fontSize:'18px'}} for="RepairIDsOne">Other Repairs Made:</Label>
													</Col>
													<Col xs="4" md="4" lg="4">
														<Input style={{height: '30px', padding: '3px'}} type="select" name="RepairIDsOne" id="RepairIDsOne" value={this.state.selectedModalRepair} onChange={this.onChangeRepairSelection}>
															<option value="0">Select Repair</option>
															{this.state.deviceRepairs.map((repair, i) => (
																<Fragment>
																<option value={repair.ID}>{repair.ID}</option>
																</Fragment>
															))}
														</Input>
													</Col>
													<Col xs="4" md="4" lg="4">
														<Button className="" color="yellow" title="Preview" onClick={() => this.toggle7()}>
															Preview
														</Button>
													</Col>
												</Row>
											}
											{!this.state.isInternationalRepair &&
												<Fragment>
												<Row className="">
													<Col xs="6" md="6" lg="6">
														<Row className="pt-4">
															<Col xs="12" md="12" lg="12">
																<Label style={{fontSize:'18px'}} for="filePurchaseOrder">Upload Purchase Order:</Label>
															</Col>
														</Row>
														{!this.state.isUploadingFile ? (
															<Row className="">
																<Col xs="7" md="7" lg="7">
																	<Input className="" type="file" name="filePurchaseOrder" id="filePurchaseOrder" onChange={this.onChangePurchaseOrderHandler} onClick={e => (e.target.value = null)}/>
																</Col>
																<Col xs="2" md="2" lg="2">
																	{this.state.loadedPurchaseOrder &&
																		<Button className="" size="sm" color="yellow" title="Upload" onClick={this.onClickPurchaseOrderHandler}>
																			Upload
																		</Button>
																	}
																</Col>
																<Col xs="3" md="3" lg="3">
																	{this.state.loadedPurchaseOrder &&
																		<img style={{ marginTop: "-3px"}} className="ml-2" src={pdfPlaceholder} width="30"/>
																	}
																</Col>
															</Row>
														) : (
															<Row className="pl-4 pl-4">
																	<Fade in="true">
																		<Row className="justify-content-center">
																			<Loader type="ThreeDots" color="#ffc108" height={30} width={200}/>
																		</Row>
																	</Fade>
															</Row>
														)}
													</Col>
													<Col xs="6" md="6" lg="6">
													{this.state.purchaseOrderFiles.length>0 &&
														<Fragment>
															<Row className="pt-4">
																<Col xs="12" md="12" lg="12">
																	<Label style={{fontSize:'18px'}} for="filePurchaseOrder">View Purchase Order:</Label>
																</Col>
															</Row>
															<Row className="">
																<Col xs="8" md="8" lg="8">
																	<Card style={{ backgroundColor: "#313642", width: "75%" }}>
																			<div style={{ height: '5px', width: '100%', top: '0px', right: '0px'}}>
																			<Button
																				onClick={() => {
																					this.setState({
																						modal2: !this.state.modal2,
																						file: this.state.purchaseOrderFiles[0]
																					});
																				}}
																				color="link"
																				size="sm"
																				round="true"
																				icon="true"
																				className="float-right"
																			>
																				<i className="fa fa-trash-alt fa-lg" />
																			</Button>
																			</div>
																			<CardBody>

																				<div className="text-center" style={{ height: '50px', width: '100%'}}>
																				<img key={this.state.purchaseOrderFiles[0].id} style={{ height: 'inherit', maxWidth: '100%', cursor:"pointer" }} className="mr-2" src={pdfPlaceholder} onClick={() => {
																					this.setState({
																						modal4: !this.state.modal4
																					});
																				}}/>
																				</div>

																			</CardBody>
																	</Card>
																</Col>
																{
																	// <Col xs="12" md="12" lg="12">
																	// 	<Button className="" size="lg" color="yellow" title="View and Download" onClick={() => {
																	// 		this.setState({
																	// 			modal4: !this.state.modal4
																	// 		});
																	// 	}}>
																	// 		View and Download
																	// 	</Button>
																	// </Col>
																}
															</Row>
														</Fragment>
													}
													</Col>
												</Row>
												{
													<Row className="mt-3">
														<Col xs="6" md="6" lg="6">
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Label style={{fontSize:'18px'}} for="fileLoanerReturnLabel">Upload Loaner Return Label:</Label>
																</Col>
															</Row>
															{!this.state.isUploadingFile ? (
																<Row className="pb-4">
																	<Col xs="7" md="7" lg="7">
																		<Input className="" type="file" name="fileLoanerReturnLabel" id="fileLoanerReturnLabel" onChange={this.onChangeLoanerReturnLabelHandler} onClick={e => (e.target.value = null)}/>
																	</Col>
																	<Col xs="2" md="2" lg="2">
																		{this.state.loadedLoanerReturnLabel &&
																			<Button className="" size="sm" color="yellow" title="Upload" onClick={this.onClickLoanerReturnLabelHandler}>
																				Upload
																			</Button>
																		}
																	</Col>
																	<Col xs="3" md="3" lg="3">
																		{this.state.loadedLoanerReturnLabel &&
																			<img style={{ marginTop: "-3px"}} className="ml-2" src={pdfPlaceholder} width="30"/>
																		}
																	</Col>
																</Row>
															) : (
																<Row className="pb-4 pl-4 pl-4">
																		<Fade in="true">
																			<Row className="justify-content-center">
																				<Loader type="ThreeDots" color="#ffc108" height={30} width={200}/>
																			</Row>
																		</Fade>
																</Row>
															)}
														</Col>
														<Col xs="6" md="6" lg="6">
														{this.state.loanerReturnLabelFiles.length>0 &&
															<Fragment>
																<Row className="">
																	<Col xs="12" md="12" lg="12">
																		<Label style={{fontSize:'18px'}} for="fileLoanerReturnLabel">View Loaner Return Label:</Label>
																	</Col>
																</Row>
																<Row className="">
																	<Col xs="8" md="8" lg="8">
																		<Card style={{ backgroundColor: "#313642", width: "75%" }}>
																				<div style={{ height: '5px', width: '100%', top: '0px', right: '0px'}}>
																				<Button
																					onClick={() => {
																						this.setState({
																							modal2: !this.state.modal2,
																							file: this.state.loanerReturnLabelFiles[0]
																						});
																					}}
																					color="link"
																					size="sm"
																					round="true"
																					icon="true"
																					className="float-right"
																				>
																					<i className="fa fa-trash-alt fa-lg" />
																				</Button>
																				</div>
																				<CardBody>

																					<div className="text-center" style={{ height: '50px', width: '100%'}}>
																					<img key={this.state.loanerReturnLabelFiles[0].id} style={{ height: 'inherit', maxWidth: '100%', cursor:"pointer" }} className="mr-2" src={pdfPlaceholder} onClick={() => {
																						this.setState({
																							modal11: !this.state.modal11
																						});
																					}}/>
																					</div>

																				</CardBody>
																		</Card>
																	</Col>
																	{
																		// <Col xs="12" md="12" lg="12">
																		// 	<Button className="" size="lg" color="yellow" title="View and Download" onClick={() => {
																		// 		this.setState({
																		// 			modal4: !this.state.modal4
																		// 		});
																		// 	}}>
																		// 		View and Download
																		// 	</Button>
																		// </Col>
																	}
																</Row>
															</Fragment>
														}
														</Col>
													</Row>
												}
												</Fragment>
											}
										</Col>
									</Row>
									<Row className="pt-5">
										<Col md="12">
											<Row className="mb-2">
 <Col xs="12"><p className="mb-0"><strong>MDR</strong> = Medical Device Reporting.</p></Col>
 </Row>
 <Row className="">
												<Col xs="2" md="2" lg="2">
													<Label style={{fontSize:'18px'}} for="MDRRequired">MDR Required?</Label>
												</Col>
												<Col xs="3" md="3" lg="3">
													<Input style={{height: '30px', padding: '3px'}} type="select" name="MDRRequired" id="MDRRequired" value={this.state.repairLog.MDRRequired} onChange={this.onChange}>
														<option value="0">No</option>
														<option value="1">Yes</option>
													</Input>
												</Col>
											</Row>
											<Row className="">
												<Col xs="2" md="2" lg="2">
													<Label style={{fontSize:'18px'}} for="IncidentInvolved">Incident Involved:</Label>
												</Col>
												<Col xs="4" md="4" lg="4">
													<Input style={{height: '30px', padding: '3px'}} type="select" name="IncidentInvolved" id="IncidentInvolved" value={this.state.repairLog.IncidentInvolved} onChange={this.onChange}>
														<option value="0">No injury</option>
														<option value="1">Minor injury</option>
														<option value="2">Major injury</option>
														<option value="3">Serious malfunction</option>
													</Input>
												</Col>
											</Row>
											<Row className="">
												<Col xs="2" md="2" lg="2">
													<Label style={{fontSize:'18px'}} for="MDRJustification">MDR Justification:</Label>
												</Col>
												<Col xs="7" md="7" lg="7">
													<Input style={{height: '30px', padding: '3px'}} type="select" name="MDRJustification" id="MDRJustification" value={this.state.repairLog.MDRJustification} onChange={this.onChange}>
														<option value="0">No device related death, serious injury or malfunction that could result in death or serious injury</option>
														<option value="1">Death or serious injury to operator</option>
														<option value="2">Death or serious injury to patient</option>
														<option value="3">Malfunction that could result in death or serious injury</option>
													</Input>
												</Col>
											</Row>
											<Row className="pt-4">
												<Col xs="12" md="12" lg="12">
													<Label style={{fontSize:'18px'}} for="detailedIssue">Detailed Issue Info:</Label>
													{
														<Input style={{width:'100%', height: '200px'}} type="textarea" name="detailedIssue" id="detailedIssue" defaultValue={this.state.detailedIssue}/>
														//<RichTextEditor style={{width:'100%', height: '300px'}} name="detailedIssue" id="detailedIssue" value={this.state.detailedIssue} onChange={this.onTextAreaChange}/>
													}

												</Col>
											</Row>
											{!this.state.isUploadingFile ? (
												<Row className="pt-4 pb-4">
													<Col xs="2" md="2" lg="2">
														<Input className="" type="file" name="fileSectionOne" id="fileSectionOne" onChange={this.onChangeHandlerOne} onClick={e => (e.target.value = null)}/>
													</Col>
													<Col xs="1" md="1" lg="1">
														{this.state.loadedOne &&
															<Button className="" size="sm" color="yellow" title="Upload" onClick={this.onClickHandlerOne}>
																Upload
															</Button>
														}
													</Col>
													<Col xs="2" md="2" lg="2">
														{this.state.loadedOne &&
															<img className="mr-2" src={this.state.filePreviewOne} width="100"/>
														}
													</Col>
												</Row>
											) : (
												<Row className="pt-4 pb-4 pl-4">
														<Fade in="true">
															<Row className="justify-content-center">
																<Loader type="ThreeDots" color="#ffc108" height={30} width={200}/>
															</Row>
														</Fade>
												</Row>
											)}
											<Row xs={3} className="text-center" style={{ display: 'flex', alignItems: 'center'}}>
											{this.state.sectionOneFiles.map((file, key) => {
												return (

				 									<Col xs="2" md="2" lg="2">
														<Card style={{ backgroundColor: "#313642" }}>
																<div style={{ height: '5px', width: '100%', top: '0px', right: '0px'}}>
																<Button
																	onClick={() => {
																		this.setState({
																			modal2: !this.state.modal2,
																			file: file
																		});
																	}}
																	color="link"
																	size="sm"
																	round="true"
																	icon="true"
																	className="float-right"
																>
																	<i className="fa fa-trash-alt fa-lg" />
																</Button>
																</div>
			                          <CardBody>

																	<div style={{ height: '100px', width: '100%'}}>
																		{this.is_video_url_extension(file.url) ? (
																			<ReactPlayer style={{ cursor:"pointer" }} width="100%" height="100%" url={file.url} onClick={() => { this.lightBoxHandler(4, key); }}/>
																		) : (
																			<Fragment>
																			{this.is_pdf_url_extension(file.url) ? (
																				<Fragment>
																				<img key={file.id} style={{ height: 'inherit', maxWidth: '100%', cursor:"pointer" }} className="mr-2" src={pdfPlaceholder} onClick={() => { this.lightBoxHandler(7, key); }}/>
																				</Fragment>
																			) : (
																				<Fragment>
																				<img key={file.id} style={{ height: 'inherit', maxWidth: '100%', cursor:"pointer" }} className="mr-2" src={file.url} onClick={() => { this.lightBoxHandler(1, key); }}/>
																				</Fragment>
																			)}
																			</Fragment>
																		)}
																	</div>

			                          </CardBody>
			                      </Card>
				 									</Col>

				 									);
				 							 })}
											</Row>
											<Row className="pt-4 text-center">
												<Col xs="12" md="12" lg="12">
													{this.state.isNewRepairLog ? (
														<Button className="ml-3" size="lg" color="yellow" title="Save" onClick={() => this.updateRepairLog()} disabled={this.state.isBeingSaved}>
															Save
														</Button>
													) : (
														<Fragment>
														<Button className="ml-3" size="lg" color="yellow" title="Update" onClick={() => this.updateRepairLog()} disabled={this.state.isBeingSaved}>
															Update
														</Button>
														{
															// <Button className="ml-3" size="lg" color="yellow" title="Update" onClick={() => this.createSnapShot()}>
															// 	Create Snapshot
															// </Button>
															// {this.state.testImageFile &&
															// 	<img className="mr-2" src={this.state.testImageFile} width="100"/>
															// }
														}
														</Fragment>
													)}
												</Col>
											</Row>
										</Col>
									</Row>
								</CardBody>
							</Card>
						</Col>
					</Row>
				</Collapse>
				{!this.state.isUPI &&
					<Fragment>
						<Row>
							<Col md="6">
								<h1 style={{color:'#737782'}}>Repair Information</h1>
							</Col>
							<Col md="6">
								{this.state.isTwoOpen ? (
									<Fragment>
										<i style={{color:'#ffc108'}} className="mdi mdi-arrow-up-drop-circle-outline mdi-36px float-right" onClick={this.toggleTwo}/>
									</Fragment>
								) : (
									<Fragment>
										<i style={{color:'#ffc108'}} className="mdi mdi-arrow-down-drop-circle-outline mdi-36px float-right" onClick={this.toggleTwo}/>
									</Fragment>
								)}
							</Col>
						</Row>
						<Collapse isOpen={this.state.isTwoOpen}>
							<Row>
								<Col md="12">
									<Card className="card-hover">
										<CardBody>
											<Row className="mb-3">
												<Col md="6">
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="TechnicianRepair">Technician Name:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															{this.state.isNewRepairLog ? (
																<Fragment>
																{this.state.currentUser.payload['custom:market'] && this.state.currentUser.payload['custom:market']=="us-azena" &&
																	<Label style={{fontSize:'18px'}} id="TechnicianRepair">{techRepair}</Label>
																}
																</Fragment>
															) : (
																<Fragment>
																{this.state.repairLog.TechnicianRepair ? (
																	<Fragment>
																	{this.state.repairLog.TechnicianRepair.length>0 ? (
																		<Label style={{fontSize:'18px'}} id="TechnicianRepair">{techRepair}</Label>
																	) : (
																		<Fragment>
																		{this.state.currentUser.payload['custom:market'] && this.state.currentUser.payload['custom:market']=="us-azena" &&
																			<Label style={{fontSize:'18px'}} id="TechnicianRepair">{techRepair}</Label>
																		}
																		</Fragment>
																	)}
																	</Fragment>
																) : (
																	<Fragment>
																	{this.state.currentUser.payload['custom:market'] && this.state.currentUser.payload['custom:market']=="us-azena" &&
																		<Label style={{fontSize:'18px'}} id="TechnicianRepair">{techRepair}</Label>
																	}
																	</Fragment>
																)}
																</Fragment>
															)}
														</Col>
													</Row>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="Status">Status:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{height: '30px', padding: '3px'}} type="select" name="Status" id="Status" value={this.state.repairLog.Status} onChange={this.onChange}>
																{!this.state.isNewRepairLog &&
																	<option value="In Progress">In Progress</option>
																}
																<option value="Pending product return">Pending product return</option>
																<option value="Completed">Completed</option>
																<option value="Pending customer approval">Pending customer approval</option>
																<option value="Customer approved work">Customer approved work</option>
																<option value="Customer Denied - Return">Customer Denied - Return</option>
																{
																	//<option value="Closed">Closed</option>
																}
															</Input>
														</Col>
													</Row>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="Status">Unit under warranty</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															{underWarrantyValue=="Unit out of warranty" ? (
																<Label style={{fontSize:'18px', color: '#e42128'}} for="Status">{underWarrantyValue}</Label>
															) : (
																<Label style={{fontSize:'18px', color: '#48b203'}} for="Status">{underWarrantyValue}</Label>
															)}
														</Col>
													</Row>
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="Status">Check Battery</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															{checkBatteryValue=="Check Battery" ? (
																<Label style={{fontSize:'18px', color: '#e42128'}} for="Status">{checkBatteryValue}</Label>
															) : (
																<Label style={{fontSize:'18px', color: '#48b203'}} for="Status">{checkBatteryValue}</Label>
															)}
														</Col>
													</Row>
												</Col>
												<Col md="6">
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="ReceivedDate">Date Received:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{width:'100%', height: '30px'}} type="date" name="ReceivedDate" id="ReceivedDate" value={Moment(this.state.repairLog.ReceivedDate).utc(false).format('YYYY-MM-DD')} onChange={this.onChange}/>
														</Col>
													</Row>
													{this.state.deviceRepairs.length > 0 &&
														<Row className="pt-1">
															<Col xs="4" md="4" lg="4">
																<Label style={{fontSize:'18px'}} for="ReceivedDate">Other Repairs Made:</Label>
															</Col>
															<Col xs="4" md="4" lg="4">
																<Input style={{height: '30px', padding: '3px'}} type="select" name="RepairIDs" id="RepairIDs" value={this.state.selectedModalRepair} onChange={this.onChangeRepairSelection}>
																	<option value="0">Select Repair</option>
																	{this.state.deviceRepairs.map((repair, i) => (
																		<Fragment>
																		<option value={repair.ID}>{repair.ID}</option>
																		</Fragment>
																	))}
																</Input>
															</Col>
															<Col xs="4" md="4" lg="4">
																<Button className="" color="yellow" title="View and Download" onClick={() => this.toggle7()}>
																	Preview
																</Button>
															</Col>
														</Row>
													}
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="Flagged">Flag Repair:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input type="checkbox" name="Flagged" id="Flagged" checked={this.state.repairLog.Flagged==1 ? true : false} onChange={this.onChange}/>
														</Col>
													</Row>
													{
														// <Row className="">
														// 	<Col xs="4" md="4" lg="4">
														// 		<Label style={{fontSize:'18px'}} for="FootpedalFlag">Footpedal Replacement:</Label>
														// 	</Col>
														// 	<Col xs="7" md="7" lg="7">
														// 		<Input type="checkbox" name="FootpedalFlag" id="FootpedalFlag" checked={this.state.footpedalFlag} onChange={this.onChangeFootpedalFlag}/>
														// 	</Col>
														// </Row>
													}
												</Col>
											</Row>
											<Row className="pt-4">
												<Col xs="12" md="12" lg="12">
													<Label style={{fontSize:'18px'}} for="detailedRepair">Detailed Repair Info:</Label>
													<Input style={{width:'100%', height: '200px'}} type="textarea" name="detailedRepair" id="detailedRepair" defaultValue={this.state.detailedRepair} onChange={this.onChangeRepairNotes}/>
												</Col>
											</Row>
											<Row className="pt-3">
												<Col md="6">
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="Firmware">Firmware/Software:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{width:'100%', height: '30px'}} type="text" name="Firmware" id="Firmware" defaultValue={this.state.repairLog.Firmware}/>
														</Col>
													</Row>
												</Col>
												<Col md="6">
													<Row className="">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="NewCalibration">New Calibration:</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{height: '30px', padding: '3px'}} type="select" name="NewCalibration" id="NewCalibration" value={this.state.repairLog.NewCalibration} onChange={this.onChange}>
																<option value="0"></option>
																<option value="Yes">Yes</option>
																<option value="No">No</option>
															</Input>
														</Col>
													</Row>
												</Col>
											</Row>
											{this.state.selectedProductName==1 && this.props.repairID<3609 &&
												<Fragment>
												{old ? (
													<Fragment>
													<Row className="pt-4">
														<Col xs="3" md="3" lg="3">
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Input style={{marginLeft:'0px'}} type="checkbox" name="ReplacedSD" id="ReplacedSD" checked={this.state.repairLog.ReplacedSD} onChange={this.onChange}/>
																	<Label className="ml-4" style={{fontSize:'18px'}} for="ReplacedSD">Replaced SD Card</Label>
																</Col>
															</Row>
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Input style={{marginLeft:'0px'}} type="checkbox" name="ReplacedFiber" id="ReplacedFiber" checked={this.state.repairLog.ReplacedFiber} onChange={this.onChange}/>
																	<Label className="ml-4" style={{fontSize:'18px'}} for="ReplacedFiber">Replaced Fiber</Label>
																</Col>
															</Row>
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Input style={{marginLeft:'0px'}} type="checkbox" name="ReplacedModule" id="ReplacedModule" checked={this.state.repairLog.ReplacedModule} onChange={this.onChange}/>
																	<Label className="ml-4" style={{fontSize:'18px'}} for="ReplacedModule">Replaced Module</Label>
																</Col>
															</Row>
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Input style={{marginLeft:'0px'}} type="checkbox" name="ReplacedMain" id="ReplacedMain" checked={this.state.repairLog.ReplacedMain} onChange={this.onChange}/>
																	<Label className="ml-4" style={{fontSize:'18px'}} for="ReplacedMain">Replaced Main</Label>
																</Col>
															</Row>
														</Col>
														<Col xs="3" md="3" lg="3">
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Input style={{marginLeft:'0px'}} type="checkbox" name="ReplacedHans" id="ReplacedHans" checked={this.state.repairLog.ReplacedHans} onChange={this.onChange}/>
																	<Label className="ml-4" style={{fontSize:'18px'}} for="ReplacedHans">Replaced Hans</Label>
																</Col>
															</Row>
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Input style={{marginLeft:'0px'}} type="checkbox" name="ReplacedDisplay" id="ReplacedDisplay" checked={this.state.repairLog.ReplacedDisplay} onChange={this.onChange}/>
																	<Label className="ml-4" style={{fontSize:'18px'}} for="ReplacedDisplay">Replaced Display</Label>
																</Col>
															</Row>
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Input style={{marginLeft:'0px'}} type="checkbox" name="ReplacedSpeaker" id="ReplacedSpeaker" checked={this.state.repairLog.ReplacedSpeaker} onChange={this.onChange}/>
																	<Label className="ml-4" style={{fontSize:'18px'}} for="ReplacedSpeaker">Replaced Speaker</Label>
																</Col>
															</Row>
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Input style={{marginLeft:'0px'}} type="checkbox" name="ReplacedBattery" id="ReplacedBattery" checked={this.state.repairLog.ReplacedBattery} onChange={this.onChange}/>
																	<Label className="ml-4" style={{fontSize:'18px'}} for="ReplacedBattery">Replaced Battery</Label>
																</Col>
															</Row>
														</Col>
														<Col xs="3" md="3" lg="3">
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Input style={{marginLeft:'0px'}} type="checkbox" name="ReplacedPedal" id="ReplacedPedal" checked={this.state.repairLog.ReplacedPedal} onChange={this.onChange}/>
																	<Label className="ml-4" style={{fontSize:'18px'}} for="ReplacedPedal">Replaced Pedal</Label>
																</Col>
															</Row>
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Input style={{marginLeft:'0px'}} type="checkbox" name="ReplacedKeypad" id="ReplacedKeypad" checked={this.state.repairLog.ReplacedKeypad} onChange={this.onChange}/>
																	<Label className="ml-4" style={{fontSize:'18px'}} for="ReplacedKeypad">Replaced Keypad</Label>
																</Col>
															</Row>
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Input style={{marginLeft:'0px'}} type="checkbox" name="ReplacedDisplayDriver" id="ReplacedDisplayDriver" checked={this.state.repairLog.ReplacedDisplayDriver} onChange={this.onChange}/>
																	<Label className="ml-4" style={{fontSize:'18px'}} for="ReplacedDisplayDriver">Replaced Display Driver</Label>
																</Col>
															</Row>
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Input style={{marginLeft:'0px'}} type="checkbox" name="FixedBoardSolder" id="FixedBoardSolder" checked={this.state.repairLog.FixedBoardSolder} onChange={this.onChange}/>
																	<Label className="ml-4" style={{fontSize:'18px'}} for="FixedBoardSolder">Fixed Board Solder</Label>
																</Col>
															</Row>
														</Col>
														<Col xs="3" md="3" lg="3">
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Input style={{marginLeft:'0px'}} type="checkbox" name="ReplacedFlex16" id="ReplacedFlex16" checked={this.state.repairLog.ReplacedFlex16} onChange={this.onChange}/>
																	<Label className="ml-4" style={{fontSize:'18px'}} for="ReplacedFlex16">Replaced Flex 16</Label>
																</Col>
															</Row>
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Input style={{marginLeft:'0px'}} type="checkbox" name="ReplacedFlex21" id="ReplacedFlex21" checked={this.state.repairLog.ReplacedFlex21} onChange={this.onChange}/>
																	<Label className="ml-4" style={{fontSize:'18px'}} for="ReplacedFlex21">Replaced Flex 21</Label>
																</Col>
															</Row>
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Input style={{marginLeft:'0px'}} type="checkbox" name="ReplacedBox" id="ReplacedBox" checked={this.state.repairLog.ReplacedBox} onChange={this.onChange}/>
																	<Label className="ml-4" style={{fontSize:'18px'}} for="ReplacedBox">Replaced Box</Label>
																</Col>
															</Row>
															<Row className="">
																<Col xs="12" md="12" lg="12">
																	<Input style={{marginLeft:'0px'}} type="checkbox" name="ReplacedFoam" id="ReplacedFoam" checked={this.state.repairLog.ReplacedFoam} onChange={this.onChange}/>
																	<Label className="ml-4" style={{fontSize:'18px'}} for="ReplacedFoam">Replaced Foam</Label>
																</Col>
															</Row>
														</Col>
													</Row>
													</Fragment>
												) : (
													<Fragment>
													<Row className="pt-4">
														<Col xs="4" md="4" lg="4">
															<Row className="">
																<Col xs="4" md="4" lg="4">
																	<Label style={{fontSize:'18px'}} for="IssueOption1">Components:</Label>
																</Col>
																<Col xs="8" md="8" lg="8">
																	<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueOption1" id="IssueOption1" value={this.state.repairLog.IssueOption1} onChange={this.onChange}>
																		<option value="0">Select appropriate issue</option>
																		{this.state.repairOptions.map((option, i) => (
																			<option value={option.id}>{option.name}</option>
																		))}
																	</Input>
																</Col>
															</Row>
															<Row className="">
																<Col xs="4" md="4" lg="4">

																</Col>
																<Col xs="8" md="8" lg="8">
																	<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueOption2" id="IssueOption2" value={this.state.repairLog.IssueOption2} onChange={this.onChange}>
																		<option value="0">Select appropriate issue</option>
																		{this.state.repairOptions.map((option, i) => (
																			<option value={option.id}>{option.name}</option>
																		))}
																	</Input>
																</Col>
															</Row>
															<Row className="">
																<Col xs="4" md="4" lg="4">

																</Col>
																<Col xs="8" md="8" lg="8">
																	<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueOption3" id="IssueOption3" value={this.state.repairLog.IssueOption3} onChange={this.onChange}>
																		<option value="0">Select appropriate issue</option>
																		{this.state.repairOptions.map((option, i) => (
																			<option value={option.id}>{option.name}</option>
																		))}
																	</Input>
																</Col>
															</Row>
															<Row className="">
																<Col xs="4" md="4" lg="4">

																</Col>
																<Col xs="8" md="8" lg="8">
																	<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueOption4" id="IssueOption4" value={this.state.repairLog.IssueOption4} onChange={this.onChange}>
																		<option value="0">Select appropriate issue</option>
																		{this.state.repairOptions.map((option, i) => (
																			<option value={option.id}>{option.name}</option>
																		))}
																	</Input>
																</Col>
															</Row>
														</Col>
														<Col xs="4" md="4" lg="4">
															<Row className="">
																<Col xs="2" md="2" lg="2">

																</Col>
																<Col xs="8" md="8" lg="8">
																	<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueOption5" id="IssueOption5" value={this.state.repairLog.IssueOption5} onChange={this.onChange}>
																		<option value="0">Select appropriate issue</option>
																		{this.state.repairOptions.map((option, i) => (
																			<option value={option.id}>{option.name}</option>
																		))}
																	</Input>
																</Col>
															</Row>
															<Row className="">
																<Col xs="2" md="2" lg="2">

																</Col>
																<Col xs="8" md="8" lg="8">
																	<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueOption6" id="IssueOption6" value={this.state.repairLog.IssueOption6} onChange={this.onChange}>
																		<option value="0">Select appropriate issue</option>
																		{this.state.repairOptions.map((option, i) => (
																			<option value={option.id}>{option.name}</option>
																		))}
																	</Input>
																</Col>
															</Row>
															<Row className="">
																<Col xs="2" md="2" lg="2">

																</Col>
																<Col xs="8" md="8" lg="8">
																	<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueOption7" id="IssueOption7" value={this.state.repairLog.IssueOption7} onChange={this.onChange}>
																		<option value="0">Select appropriate issue</option>
																		{this.state.repairOptions.map((option, i) => (
																			<option value={option.id}>{option.name}</option>
																		))}
																	</Input>
																</Col>
															</Row>
															<Row className="">
																<Col xs="2" md="2" lg="2">

																</Col>
																<Col xs="8" md="8" lg="8">
																	<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueOption8" id="IssueOption8" value={this.state.repairLog.IssueOption8} onChange={this.onChange}>
																		<option value="0">Select appropriate issue</option>
																		{this.state.repairOptions.map((option, i) => (
																			<option value={option.id}>{option.name}</option>
																		))}
																	</Input>
																</Col>
															</Row>
														</Col>
														<Col xs="4" md="4" lg="4">
															<Row className="">
																<Col xs="8" md="8" lg="8">
																	<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueOption9" id="IssueOption9" value={this.state.repairLog.IssueOption9} onChange={this.onChange}>
																		<option value="0">Select appropriate issue</option>
																		{this.state.repairOptions.map((option, i) => (
																			<option value={option.id}>{option.name}</option>
																		))}
																	</Input>
																</Col>
															</Row>
															<Row className="">
																<Col xs="8" md="8" lg="8">
																	<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueOption10" id="IssueOption10" value={this.state.repairLog.IssueOption10} onChange={this.onChange}>
																		<option value="0">Select appropriate issue</option>
																		{this.state.repairOptions.map((option, i) => (
																			<option value={option.id}>{option.name}</option>
																		))}
																	</Input>
																</Col>
															</Row>
															<Row className="">
																<Col xs="8" md="8" lg="8">
																	<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueOption11" id="IssueOption11" value={this.state.repairLog.IssueOption11} onChange={this.onChange}>
																		<option value="0">Select appropriate issue</option>
																		{this.state.repairOptions.map((option, i) => (
																			<option value={option.id}>{option.name}</option>
																		))}
																	</Input>
																</Col>
															</Row>
															<Row className="">
																<Col xs="8" md="8" lg="8">
																	<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueOption12" id="IssueOption12" value={this.state.repairLog.IssueOption12} onChange={this.onChange}>
																		<option value="0">Select appropriate issue</option>
																		{this.state.repairOptions.map((option, i) => (
																			<option value={option.id}>{option.name}</option>
																		))}
																	</Input>
																</Col>
															</Row>
														</Col>
													</Row>
													</Fragment>
												)}
												</Fragment>
											}

											<Row className="">
												<div style={{ width: '100%', height: '1px', backgroundColor: "#ffc72c", margin: '25px' }} id="line"></div>
											</Row>
											<Row className="">
												<Col className="section-col mb-4 mb-xl-0 pb-4" xs="12" md="12" lg="12" xl="4">
													<Row className="">
														<Col xs="7" md="7" lg="7">
															<Label style={{fontSize:'18px'}} for="IssueCategory1">Reason for Repair:</Label>
														</Col>
														<Col xs="5" md="5" lg="5">
															<Label style={{fontSize:'18px'}}>User Caused</Label>
														</Col>
													</Row>
													{this.props.repairID>=3609 &&
														<Fragment>
														{this.state.categoryItemsForRepair.map((catItemForRepair, i) => (
															<Row className="">
																<Col xs="7" md="7" lg="7">
																	<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name={"CatItem"+i} id={"CatItem"+i} value={catItemForRepair.CategoryItemID} onChange={(e) => { this.onChangeCategoryItemForRepair(e, i); }} disabled={catItemForRepair.id!=null}>
																		<option value="0">Select appropriate issue</option>
																		{this.state.repairCategories.map((category, i) => (
																			<option value={category.id}>{category.name}</option>
																		))}
																	</Input>
																</Col>
																<Col xs="3" md="3" lg="3">
																	<Input style={{width: '95%', height: '30px', margin: '3px', padding: '3px'}} type="select" name={"CustomerCaused"+i} id={"CustomerCaused"+i} value={catItemForRepair.CustomerCaused} onChange={(e) => { this.onChangeCategoryItemForRepair(e, i); }} disabled={catItemForRepair.CategoryItemID==0 || catItemForRepair.id!=null}>
																		<option value="100">Select</option>
																		<option value="0">No</option>
																		<option value="1">Yes</option>
																	</Input>
																</Col>
																{catItemForRepair.id!=null ? (
																	<Col xs="2" md="2" lg="2">
																		<Button style={{ margin: '3px', padding: '3px'}} className="" size="sm" color="danger" title="Delete" onClick={() => this.deleteCategoryItemForRepair(i)}>
																			Delete
																		</Button>
																	</Col>
																) : (
																	<Col xs="2" md="2" lg="2">
																		<Button style={{ margin: '3px', padding: '3px'}} className="" size="sm" color="brightgreen" title="Save" onClick={() => this.createCategoryItemForRepair(i)}>
																			Save
																		</Button>
																	</Col>
																)}
															</Row>
														))}
														<Row className="pt-3 text-center">
															<Col xs="12" md="12" lg="12">
																<Button className="ml-3" size="md" color="brightgreen" title="Add +" onClick={() => this.addCategoryItemForRepair()}>
																	Add +
																</Button>
																{unsavedComponentItems.length>0 &&
																	<Button className="ml-3" size="md" color="brightgreen" title="Save All" onClick={() => this.saveAllCategoryItems()} disabled={this.state.isSavingReasons}>
																		Save All
																	</Button>
																}
															</Col>
														</Row>
														</Fragment>
													}
													{this.props.repairID<3609 &&
														<Fragment>
														<Row className="">
															<Col xs="12" md="12" lg="12">
																<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueCategory1" id="IssueCategory1" value={this.state.repairLog.IssueCategory1} onChange={this.onChange}>
																	<option value="0">Select appropriate issue</option>
																	{this.state.repairCategories.map((category, i) => (
																		<option value={category.id}>{category.name}</option>
																	))}
																</Input>
															</Col>
														</Row>
														<Row className="">
															<Col xs="12" md="12" lg="12">
																<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueCategory2" id="IssueCategory2" value={this.state.repairLog.IssueCategory2} onChange={this.onChange}>
																	<option value="0">Select appropriate issue</option>
																	{this.state.repairCategories.map((category, i) => (
																		<option value={category.id}>{category.name}</option>
																	))}
																</Input>
															</Col>
														</Row>
														<Row className="">
															<Col xs="12" md="12" lg="12">
																<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueCategory3" id="IssueCategory3" value={this.state.repairLog.IssueCategory3} onChange={this.onChange}>
																	<option value="0">Select appropriate issue</option>
																	{this.state.repairCategories.map((category, i) => (
																		<option value={category.id}>{category.name}</option>
																	))}
																</Input>
															</Col>
														</Row>
														<Row className="">
															<Col xs="12" md="12" lg="12">
																<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueCategory4" id="IssueCategory4" value={this.state.repairLog.IssueCategory4} onChange={this.onChange}>
																	<option value="0">Select appropriate issue</option>
																	{this.state.repairCategories.map((category, i) => (
																		<option value={category.id}>{category.name}</option>
																	))}
																</Input>
															</Col>
														</Row>
														</Fragment>
													}
													<Row className="pt-4">
														<Col xs="4" md="4" lg="4">
															<Label style={{fontSize:'18px'}} for="RecallRequired">Recall Required?</Label>
														</Col>
														<Col xs="7" md="7" lg="7">
															<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="RecallRequired" id="RecallRequired" value={this.state.repairLog.RecallRequired} onChange={this.onChange}>
																<option value="0">No</option>
																<option value="1">Yes</option>
															</Input>
														</Col>
													</Row>
												</Col>
												{this.props.repairID<3194 &&
													<Col className="section-col mb-4 mb-xl-0 pb-4" xs="12" md="12" lg="12" xl="4">
														<Row className="">
															<Col xs="12" md="12" lg="12">
																<Label style={{fontSize:'18px'}} for="IssueCategory4">Component Replacement:</Label>
															</Col>
														</Row>
														<Row className="">
															<Col xs="8" md="8" lg="8">
																<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueBOM1" id="IssueBOM1" value={this.state.repairLog.IssueBOM1} onChange={(e) => { this.onChangeBOM(e, this.state.repairLog.IssueBOM1); }}>
																	<option value="0">Select appropriate issue</option>
																	{this.state.bomData.map((bom, i) => (
																		<option value={bom.id}>{bom.PartNumber+" | "+bom.Description}</option>
																	))}
																</Input>
															</Col>
															<Col xs="4" md="4" lg="4">
																<Input style={{width: '95%', height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueBOM1Quantity" id="IssueBOM1Quantity" value={this.state.repairLog.IssueBOM1Quantity} onChange={(e) => { this.onChangeQuantity(e, this.state.repairLog.IssueBOM1); }} disabled={this.state.repairLog.IssueBOM1==0}>
																	<option value="0"></option>
																	<option value="100">Complimentary</option>
																	<option value="1">1</option>
																	<option value="2">2</option>
																	<option value="3">3</option>
																	<option value="4">4</option>
																	<option value="5">5</option>
																</Input>
															</Col>
														</Row>
														<Row className="">
															<Col xs="8" md="8" lg="8">
																<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueBOM2" id="IssueBOM2" value={this.state.repairLog.IssueBOM2} onChange={(e) => { this.onChangeBOM(e, this.state.repairLog.IssueBOM2); }}>
																	<option value="0">Select appropriate issue</option>
																	{this.state.bomData.map((bom, i) => (
																		<option value={bom.id}>{bom.Description}</option>
																	))}
																</Input>
															</Col>
															<Col xs="4" md="4" lg="4">
																<Input style={{width: '95%', height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueBOM2Quantity" id="IssueBOM2Quantity" value={this.state.repairLog.IssueBOM2Quantity} onChange={(e) => { this.onChangeQuantity(e, this.state.repairLog.IssueBOM2); }} disabled={this.state.repairLog.IssueBOM2==0}>
																	<option value="0"></option>
																	<option value="100">Complimentary</option>
																	<option value="1">1</option>
																	<option value="2">2</option>
																	<option value="3">3</option>
																	<option value="4">4</option>
																	<option value="5">5</option>
																</Input>
															</Col>
														</Row>
														<Row className="">
															<Col xs="8" md="8" lg="8">
																<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueBOM3" id="IssueBOM3" value={this.state.repairLog.IssueBOM3} onChange={(e) => { this.onChangeBOM(e, this.state.repairLog.IssueBOM3); }}>
																	<option value="0">Select appropriate issue</option>
																	{this.state.bomData.map((bom, i) => (
																		<option value={bom.id}>{bom.Description}</option>
																	))}
																</Input>
															</Col>
															<Col xs="4" md="4" lg="4">
																<Input style={{width: '95%', height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueBOM3Quantity" id="IssueBOM3Quantity" value={this.state.repairLog.IssueBOM3Quantity} onChange={(e) => { this.onChangeQuantity(e, this.state.repairLog.IssueBOM3); }} disabled={this.state.repairLog.IssueBOM3==0}>
																	<option value="0"></option>
																	<option value="100">Complimentary</option>
																	<option value="1">1</option>
																	<option value="2">2</option>
																	<option value="3">3</option>
																	<option value="4">4</option>
																	<option value="5">5</option>
																</Input>
															</Col>
														</Row>
														<Row className="">
															<Col xs="8" md="8" lg="8">
																<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueBOM4" id="IssueBOM4" value={this.state.repairLog.IssueBOM4} onChange={(e) => { this.onChangeBOM(e, this.state.repairLog.IssueBOM4); }}>
																	<option value="0">Select appropriate issue</option>
																	{this.state.bomData.map((bom, i) => (
																		<option value={bom.id}>{bom.Description}</option>
																	))}
																</Input>
															</Col>
															<Col xs="4" md="4" lg="4">
																<Input style={{width: '95%', height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueBOM4Quantity" id="IssueBOM4Quantity" value={this.state.repairLog.IssueBOM4Quantity} onChange={(e) => { this.onChangeQuantity(e, this.state.repairLog.IssueBOM4); }} disabled={this.state.repairLog.IssueBOM4==0}>
																	<option value="0"></option>
																	<option value="100">Complimentary</option>
																	<option value="1">1</option>
																	<option value="2">2</option>
																	<option value="3">3</option>
																	<option value="4">4</option>
																	<option value="5">5</option>
																</Input>
															</Col>
														</Row>
														<Row className="">
															<Col xs="8" md="8" lg="8">
																<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueBOM5" id="IssueBOM5" value={this.state.repairLog.IssueBOM5} onChange={(e) => { this.onChangeBOM(e, this.state.repairLog.IssueBOM5); }}>
																	<option value="0">Select appropriate issue</option>
																	{this.state.bomData.map((bom, i) => (
																		<option value={bom.id}>{bom.Description}</option>
																	))}
																</Input>
															</Col>
															<Col xs="4" md="4" lg="4">
																<Input style={{width: '95%', height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueBOM5Quantity" id="IssueBOM5Quantity" value={this.state.repairLog.IssueBOM5Quantity} onChange={(e) => { this.onChangeQuantity(e, this.state.repairLog.IssueBOM5); }} disabled={this.state.repairLog.IssueBOM5==0}>
																	<option value="0"></option>
																	<option value="100">Complimentary</option>
																	<option value="1">1</option>
																	<option value="2">2</option>
																	<option value="3">3</option>
																	<option value="4">4</option>
																	<option value="5">5</option>
																</Input>
															</Col>
														</Row>
														<Row className="">
															<Col xs="8" md="8" lg="8">
																<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueBOM6" id="IssueBOM6" value={this.state.repairLog.IssueBOM6} onChange={(e) => { this.onChangeBOM(e, this.state.repairLog.IssueBOM6); }}>
																	<option value="0">Select appropriate issue</option>
																	{this.state.bomData.map((bom, i) => (
																		<option value={bom.id}>{bom.Description}</option>
																	))}
																</Input>
															</Col>
															<Col xs="4" md="4" lg="4">
																<Input style={{width: '95%', height: '30px', margin: '3px', padding: '3px'}} type="select" name="IssueBOM6Quantity" id="IssueBOM6Quantity" value={this.state.repairLog.IssueBOM6Quantity} onChange={(e) => { this.onChangeQuantity(e, this.state.repairLog.IssueBOM6); }} disabled={this.state.repairLog.IssueBOM6==0}>
																	<option value="0"></option>
																	<option value="100">Complimentary</option>
																	<option value="1">1</option>
																	<option value="2">2</option>
																	<option value="3">3</option>
																	<option value="4">4</option>
																	<option value="5">5</option>
																</Input>
															</Col>
														</Row>
													</Col>
												}
												{this.props.repairID && showQuoting &&
													<Fragment>
													{this.props.repairID>3193 &&
														<Col className="section-col mb-4 mb-xl-0 pb-4" xs="12" md="12" lg="12" xl="4">
															<Row className="">
																<Col xs="8" md="8" lg="8">
																	<Label style={{fontSize:'18px'}}>Component Replacement:</Label>
																</Col>
																<Col className="text-center" xs="2" md="2" lg="2">
																	<Label style={{fontSize:'18px'}}>QTY</Label>
																</Col>
															</Row>
															{this.state.componentItemsForRepair.map((cItemForRepair, i) => (
																<Row className="">
																	<Col xs="8" md="8" lg="8">
																		<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name={"CItem"+i} id={"CItem"+i} value={cItemForRepair.ComponentItemID} onChange={(e) => { this.onChangeComponentItemForRepair(e, i); }} disabled={cItemForRepair.id!=null}>
																			<option value="0">Select appropriate issue</option>
																			{this.state.bomData.map((cItem, j) => (
																				<option value={cItem.id}>{cItem.PartNumber+" | "+cItem.Description}</option>
																			))}
																		</Input>
																	</Col>
																	<Col xs="2" md="2" lg="2">
																		<Input style={{width: '95%', height: '30px', margin: '3px', padding: '3px'}} type="select" name={"CQuantity"+i} id={"CQuantity"+i} value={cItemForRepair.Quantity} onChange={(e) => { this.onChangeComponentItemForRepair(e, i); }} disabled={cItemForRepair.ComponentItemID==0 || cItemForRepair.id!=null}>
																			<option value="0"></option>
																			<option value="1">1</option>
																			<option value="2">2</option>
																			<option value="3">3</option>
																			<option value="4">4</option>
																			<option value="5">5</option>
																			<option value="6">6</option>
																			<option value="7">7</option>
																			<option value="8">8</option>
																			<option value="9">9</option>
																			<option value="10">10</option>
																		</Input>
																	</Col>
																	{cItemForRepair.id!=null ? (
																		<Col xs="2" md="2" lg="2">
																			<Button style={{ margin: '3px', padding: '3px'}} className="" size="sm" color="danger" title="Delete" onClick={() => this.deleteComponentItemForRepair(i)}>
																				Delete
																			</Button>
																		</Col>
																	) : (
																		<Col xs="2" md="2" lg="2">
																			<Button style={{ margin: '3px', padding: '3px'}} className="" size="sm" color="brightgreen" title="Save" onClick={() => this.createComponentItemForRepair(i)}>
																				Save
																			</Button>
																		</Col>
																	)}
																</Row>
															))}
															<Row className="pt-3 text-center">
																<Col xs="12" md="12" lg="12">
																	<Button className="ml-3" size="md" color="brightgreen" title="Add +" onClick={() => this.addComponentItemForRepair()}>
																		Add +
																	</Button>
																	{unsavedComponentItems.length>0 &&
																		<Button className="ml-3" size="md" color="brightgreen" title="Save All" onClick={() => this.saveAllComponentItems()} disabled={this.state.isSavingComponents}>
																			Save All
																		</Button>
																	}
																</Col>
															</Row>
														</Col>
													}
													{this.state.market!="taiwan" &&
														<Col className="section-col mb-4 mb-xl-0 pb-4" xs="12" md="12" lg="12" xl="4">
															<Row className="">
																<Col xs="6" md="6" lg="6">
																	<Label style={{fontSize:'18px'}}>Quoting:</Label>
																</Col>
																<Col className="text-center" xs="2" md="2" lg="2">
																	<Label style={{fontSize:'18px'}}>QTY</Label>
																</Col>
																<Col xs="2" md="2" lg="2">
																	<Label style={{fontSize:'18px'}}>Optional</Label>
																</Col>
															</Row>
															{this.state.quoteItemsForRepair.map((qItemForRepair, i) => (
																<Row className="">
																	<Col xs="6" md="6" lg="6">
																		<Input style={{height: '30px', margin: '3px', padding: '3px'}} type="select" name={"QItem"+i} id={"QItem"+i} value={qItemForRepair.QuoteItemID} onChange={(e) => { this.onChangeQuoteItemForRepair(e, i); }} disabled={qItemForRepair.id!=null}>
																			<option value="0">Select appropriate issue</option>
																			{this.state.quoteData.map((qItem, j) => (
																				<option value={qItem.id}>{qItem.marketName+" - "+qItem.Description}</option>
																			))}
																		</Input>
																	</Col>
																	<Col xs="2" md="2" lg="2">
																		<Input style={{width: '95%', height: '30px', margin: '3px', padding: '3px'}} type="select" name={"QQuantity"+i} id={"QQuantity"+i} value={qItemForRepair.Quantity} onChange={(e) => { this.onChangeQuoteItemForRepair(e, i); }} disabled={qItemForRepair.QuoteItemID==0 || qItemForRepair.id!=null}>
																			<option value="0"></option>
																			<option value="1">1</option>
																			<option value="2">2</option>
																			<option value="3">3</option>
																			<option value="4">4</option>
																			<option value="5">5</option>
																			<option value="6">6</option>
																			<option value="7">7</option>
																			<option value="8">8</option>
																			<option value="9">9</option>
																			<option value="10">10</option>
																		</Input>
																	</Col>
																	<Col xs="2" md="2" lg="2">
																		<Input style={{width: '95%', height: '30px', margin: '3px', padding: '3px'}} type="select" name={"QOptional"+i} id={"QOptional"+i} value={qItemForRepair.Optional} onChange={(e) => { this.onChangeQuoteItemForRepair(e, i); }} disabled={qItemForRepair.QuoteItemID==0 || qItemForRepair.id!=null}>
																			<option value="0">No</option>
																			<option value="1">Yes</option>
																		</Input>
																	</Col>
																	{qItemForRepair.id!=null ? (
																		<Col xs="2" md="2" lg="2">
																			<Button style={{ margin: '3px', padding: '3px'}} className="" size="sm" color="danger" title="Delete" onClick={() => this.deleteQuoteItemForRepair(i)}>
																				Delete
																			</Button>
																		</Col>
																	) : (
																		<Col xs="2" md="2" lg="2">
																			<Button style={{ margin: '3px', padding: '3px'}} className="" size="sm" color="brightgreen" title="Save" onClick={() => this.createQuoteItemForRepair(i)}>
																				Save
																			</Button>
																		</Col>
																	)}
																</Row>
															))}
															<Row className="pt-3 text-center">
																<Col xs="12" md="12" lg="12">
																	{this.state.isInternationalRepair ? (
																		<Button className="" size="md" color="yellow" title="Generate Quote" onClick={() => this.generateIntlQuotingInvoice()}>
																			Generate Quote
																		</Button>
																	) : (
																		<Button className="" size="md" color="yellow" title="Generate UPI Repair List" onClick={() => this.generateQuotingInvoice()}>
																			Generate UPI Repair List
																		</Button>
																	)}
																	<Button className="ml-3" size="md" color="brightgreen" title="Add +" onClick={() => this.addQuoteItemForRepair()}>
																		Add +
																	</Button>
																	{unsavedQuoteItems.length>0 &&
																		<Button className="ml-3" size="md" color="brightgreen" title="Save All" onClick={() => this.saveAllQuoteItems()} disabled={this.state.isSavingQuotes}>
																			Save All
																		</Button>
																	}
																</Col>
															</Row>
														</Col>
													}
													</Fragment>
												}
											</Row>
											{!this.state.isUploadingFile ? (
												<Row className="pt-4 pb-4">
													<Col xs="2" md="2" lg="2">
														<Input className="" type="file" name="fileSectionTwo" id="fileSectionTwo" onChange={this.onChangeHandlerTwo} onClick={e => (e.target.value = null)}/>
													</Col>
													<Col xs="1" md="1" lg="1">
														{this.state.loadedTwo &&
															<Button className="" size="sm" color="yellow" title="Upload" onClick={this.onClickHandlerTwo}>
																Upload
															</Button>
														}
													</Col>
													<Col xs="2" md="2" lg="2">
														{this.state.loadedTwo &&
															<img className="mr-2" src={this.state.filePreviewTwo} width="100"/>
														}
													</Col>
												</Row>
											) : (
												<Row className="pt-4 pb-4 pl-4">
														<Fade in="true">
															<Row className="justify-content-center">
																<Loader type="ThreeDots" color="#ffc108" height={30} width={200}/>
															</Row>
														</Fade>
												</Row>
											)}
											<Row xs={3} className="text-center" style={{ display: 'flex', alignItems: 'center'}}>
											{this.state.sectionTwoFiles.map((file, key) => {
												return (

													<Col xs="2" md="2" lg="2">
														<Card style={{ backgroundColor: "#313642" }}>
																<div style={{ height: '5px', width: '100%', top: '0px', right: '0px'}}>
																<Button
																	onClick={() => {
																		this.setState({
																			modal2: !this.state.modal2,
																			file: file
																		});
																	}}
																	color="link"
																	size="sm"
																	round="true"
																	icon="true"
																	className="float-right"
																>
																	<i className="fa fa-trash-alt fa-lg" />
																</Button>
																</div>
																<CardBody>
																	<div style={{ height: '100px', width: '100%'}}>
																		{this.is_video_url_extension(file.url) ? (
																			<ReactPlayer style={{ cursor:"pointer" }} width="100%" height="100%" url={file.url} onClick={() => { this.lightBoxHandler(5, key); }}/>
																		) : (
																			<Fragment>
																			{this.is_pdf_url_extension(file.url) ? (
																				<Fragment>
																				<img key={file.id} style={{ height: 'inherit', maxWidth: '100%', cursor:"pointer" }} className="mr-2" src={pdfPlaceholder} onClick={() => { this.lightBoxHandler(8, key); }}/>
																				</Fragment>
																			) : (
																				<Fragment>
																				<img key={file.id} style={{ height: 'inherit', maxWidth: '100%', cursor:"pointer" }} className="mr-2" src={file.url} onClick={() => { this.lightBoxHandler(2, key); }}/>
																				</Fragment>
																			)}
																			</Fragment>
																		)}
																	</div>
																</CardBody>
														</Card>
													</Col>

													);
											 })}
											</Row>
											<Row className="pt-4 text-center">
												<Col xs="12" md="12" lg="12">
													{this.state.isNewRepairLog ? (
														<Button className="ml-3" size="lg" color="yellow" title="Save" onClick={() => this.updateRepairLog()} disabled={this.state.isBeingSaved}>
															Save
														</Button>
													) : (
														<Fragment>
														<Button className="ml-3" size="lg" color="yellow" title="Update" onClick={() => this.updateRepairLog()} disabled={this.state.isBeingSaved}>
															Update
														</Button>
														</Fragment>
													)}
												</Col>
											</Row>
										</CardBody>
									</Card>
								</Col>
							</Row>
						</Collapse>
						{!this.state.isUPI2 &&
						<Fragment>
						<Row>
							<Col md="6">
								<h1 style={{color:'#737782'}}>Customer Information</h1>
							</Col>
							<Col md="6">
								{this.state.isThreeOpen ? (
									<Fragment>
										<i style={{color:'#ffc108'}} className="mdi mdi-arrow-up-drop-circle-outline mdi-36px float-right" onClick={this.toggleThree}/>
									</Fragment>
								) : (
									<Fragment>
										<i style={{color:'#ffc108'}} className="mdi mdi-arrow-down-drop-circle-outline mdi-36px float-right" onClick={this.toggleThree}/>
									</Fragment>
								)}
							</Col>
						</Row>
						<Collapse isOpen={this.state.isThreeOpen}>
							<Row>
								<Col md="12">
									<Card className="card-hover">
										<CardBody>
										<Row className="mb-3">
											<Col md="6">
												<Row className="">
													<Col xs="4" md="4" lg="4">
														<Label style={{fontSize:'18px'}} for="ReturnedDate">Date Back to Customer:</Label>
													</Col>
													<Col xs="7" md="7" lg="7">
														<Input style={{width:'100%', height: '30px'}} type="date" name="ReturnedDate" id="ReturnedDate" defaultValue={Moment(this.state.repairLog.ReturnedDate).utc(false).format('YYYY-MM-DD')} onChange={this.onChange}/>
													</Col>
												</Row>
												<Row className="">
													<Col xs="4" md="4" lg="4">
														<Label style={{fontSize:'18px'}} for="TrackingCustomer">Tracking # to Customer:</Label>
													</Col>
													<Col xs="7" md="7" lg="7">
														<Input style={{width:'100%', height: '30px'}} type="text" name="TrackingCustomer" id="TrackingCustomer" defaultValue={this.state.repairLog.TrackingCustomer}/>
													</Col>
												</Row>
											</Col>
											<Col md="6">
												<Row className="">
													<Col xs="4" md="4" lg="4">
														<Label style={{fontSize:'18px'}} for="ReturnedStatus">Returned Unit Status:</Label>
													</Col>
													<Col xs="7" md="7" lg="7">
														<Input style={{height: '30px', padding: '3px'}} type="select" name="ReturnedStatus" id="ReturnedStatus" value={this.state.repairLog.ReturnedStatus} onChange={this.onChange}>
															<option value="As Is">As Is</option>
															<option value="Back to Inventory">Back to Inventory</option>
														</Input>
													</Col>
												</Row>
												<Row className="">
													<Col xs="4" md="4" lg="4">
														<Label style={{fontSize:'18px'}} for="ShippingDestination">Shipping Destination:</Label>
													</Col>
													<Col xs="7" md="7" lg="7">
														<Input style={{height: '30px', padding: '3px'}} type="select" name="ShippingDestination" id="ShippingDestination" value={this.state.repairLog.ShippingDestination} onChange={this.onChange}>
															<option value="Customer">Customer</option>
															<option value="UPI">UPI</option>
															{this.state.isInternationalRepair &&
																<Fragment>
																<option value="Dealer">Dealer</option>
																</Fragment>
															}
														</Input>
													</Col>
												</Row>
											</Col>
										</Row>
										<Row className="pt-3">
											<Col xs="4" md="4" lg="4">
												<Label style={{fontSize:'18px'}} for="CustomerNoteSelect">Select Customer Note Template:</Label>
											</Col>
											<Col xs="7" md="7" lg="7">
												<Input style={{height: '30px', padding: '3px'}} type="select" name="CustomerNoteSelect" id="CustomerNoteSelect" onChange={this.onChangeCustomerNotesSelect}>
													<option value="0">Select Note Template</option>
													{this.state.repairCustomerNotes.map((note, i) => (
														<option value={note.id}>{note.Description}</option>
													))}
												</Input>
											</Col>
											<Col xs="1" md="1" lg="1">
												{this.state.selectedCustomerNoteID!=0 &&
													<Button style={{ margin: '3px', padding: '3px'}} className="" size="sm" color="brightgreen" title="Add" onClick={() => this.addCustomerNote()}>
														ADD
													</Button>
												}
											</Col>
										</Row>
										<Row className="pt-4 pb-4">
											<Col xs="12" md="12" lg="12">
												<Label style={{fontSize:'18px'}} for="customerNotes">Customer Notes:</Label>
												<Input style={{width:'100%', height: '200px'}} type="textarea" name="customerNotes" id="customerNotes" defaultValue={this.state.customerNotes} onChange={this.onChangeCustomerNotes}/>
											</Col>
										</Row>
										{
										// {!this.state.isUploadingFile ? (
										// 	<Row className="pt-4 pb-4">
										// 		<Col xs="2" md="2" lg="2">
										// 			<Input className="" type="file" name="fileSectionThree" id="fileSectionThree" onChange={this.onChangeHandlerThree} onClick={e => (e.target.value = null)}/>
										// 		</Col>
										// 		<Col xs="1" md="1" lg="1">
										// 			{this.state.loadedThree &&
										// 				<Button className="" size="sm" color="yellow" title="Upload" onClick={this.onClickHandlerThree}>
										// 					Upload
										// 				</Button>
										// 			}
										// 		</Col>
										// 		<Col xs="2" md="2" lg="2">
										// 			{this.state.loadedThree &&
										// 				<img className="mr-2" src={this.state.filePreviewThree} width="100"/>
										// 			}
										// 		</Col>
										// 	</Row>
										// ) : (
										// 	<Row className="pt-4 pb-4 pl-4">
										// 			<Fade in="true">
										// 				<Row className="justify-content-center">
										// 					<Loader type="ThreeDots" color="#ffc108" height={30} width={200}/>
										// 				</Row>
										// 			</Fade>
										// 	</Row>
										// )}
										}
										<Row xs={3} className="text-center" style={{ display: 'flex', alignItems: 'center'}}>
										{this.state.sectionThreeFiles.map((file, key) => {
											return (

												<Col xs="2" md="2" lg="2">
													<Card style={{ backgroundColor: "#313642" }}>
															<div style={{ height: '5px', width: '100%', top: '0px', right: '0px'}}>
																<Button
																	onClick={() => {
																		this.setState({
																			modal2: !this.state.modal2,
																			file: file
																		});
																	}}
																	color="link"
																	size="sm"
																	round="true"
																	icon="true"
																	className="float-right"
																>
																	<i className="fa fa-trash-alt fa-lg" />
																</Button>
															</div>
															<CardBody>
																<div style={{ height: '100px', width: '100%'}}>
																	{this.is_video_url_extension(file.url) ? (
																		<ReactPlayer style={{ cursor:"pointer" }} width="100%" height="100%" url={file.url} onClick={() => { this.lightBoxHandler(6, key); }}/>
																	) : (
																		<Fragment>
																		{this.is_pdf_url_extension(file.url) ? (
																			<Fragment>
																			<img key={file.id} style={{ height: 'inherit', maxWidth: '100%', cursor:"pointer" }} className="mr-2" src={pdfPlaceholder} onClick={() => { this.lightBoxHandler(9, key); }}/>
																			</Fragment>
																		) : (
																			<Fragment>
																			<img key={file.id} style={{ height: 'inherit', maxWidth: '100%', cursor:"pointer" }} className="mr-2" src={file.url} onClick={() => { this.lightBoxHandler(3, key); }}/>
																			</Fragment>
																		)}
																		</Fragment>
																	)}
																</div>
															</CardBody>
													</Card>
												</Col>

												);
										 })}
										</Row>
										<Row className="pt-4 text-center">
											<Col xs="12" md="12" lg="12">
												{this.state.isNewRepairLog ? (
													<Button className="ml-3" size="lg" color="yellow" title="Save" onClick={() => this.updateRepairLog()} disabled={this.state.isBeingSaved}>
														Save
													</Button>
												) : (
													<Fragment>
													<Button className="ml-3" size="lg" color="yellow" title="Update" onClick={() => this.updateRepairLog()} disabled={this.state.isBeingSaved}>
														Update
													</Button>
													<Button className="ml-3" size="lg" color="yellow" title="Generate Customer Report" onClick={() => this.generateCustomerReport()}>
														Generate Customer Report
													</Button>
													{!this.state.isInternationalRepair &&
														<Fragment>
														<Button className="ml-3" size="lg" color="yellow" title="Create Shipping Label" onClick={() => this.toggle9()}>
															Create Shipping Label
														</Button>
														<Button className="ml-3" size="lg" color="yellow" title="Create Return Shipping Label" onClick={() => this.toggle9Return()}>
															Create Return Shipping Label
														</Button>
														</Fragment>
													}
													<Button className="ml-3" size="lg" color="yellow" title="Create Repair Order" onClick={() => this.toggle10()}>
						                Create Repair Order
						              </Button>
													</Fragment>
												)}
											</Col>
										</Row>
										</CardBody>
									</Card>
								</Col>
							</Row>
						</Collapse>
						</Fragment>
						}
					</Fragment>
				}
				<div>
					<Modal isOpen={this.state.modal} toggle={this.toggle} centered={true} contentClassName="custom-modal-style">
    				<ModalHeader toggle={this.toggle}>Preview Media</ModalHeader>
    				<ModalBody>

						{sectionOneUrl && this.state.lightBoxDataIndex==1 &&
							<div style={{ height: '100%', width: '100%'}}>
								<img style={{ maxWidth: '100%', cursor:"pointer" }} className="mr-2" src={sectionOneUrl.url}/>
							</div>
						}

						{sectionTwoUrl && this.state.lightBoxDataIndex==2 &&
							<div style={{ height: '100%', width: '100%'}}>
								<img style={{ maxWidth: '100%', cursor:"pointer" }} className="mr-2" src={sectionTwoUrl.url}/>
							</div>
						}

						{sectionThreeUrl && this.state.lightBoxDataIndex==3 &&
							<div style={{ height: '100%', width: '100%'}}>
								<img style={{ maxWidth: '100%', cursor:"pointer" }} className="mr-2" src={sectionThreeUrl.url}/>
							</div>
						}

						{sectionOneUrl && this.state.lightBoxDataIndex==4 &&
							<div style={{ height: '100%', width: '100%'}}>
								<ReactPlayer url={sectionOneUrl.url} controls={true} />
							</div>
						}

						{sectionTwoUrl && this.state.lightBoxDataIndex==5 &&
							<div style={{ height: '100%', width: '100%'}}>
								<ReactPlayer url={sectionTwoUrl.url} controls={true} />
							</div>
						}

						{sectionThreeUrl && this.state.lightBoxDataIndex==6 &&
							<div style={{ height: '100%', width: '100%'}}>
								<ReactPlayer url={sectionThreeUrl.url} controls={true} />
							</div>
						}

						{sectionOneUrl && this.state.lightBoxDataIndex==7 &&
							<div style={{ height: '100%', width: '100%'}}>
								<iframe key={sectionOneUrl.url} ref={this.previewPdfModalFrameRef} src={sectionOneUrl.url} width="100%" height="700px">
								</iframe>
							</div>
						}

						{sectionTwoUrl && this.state.lightBoxDataIndex==8 &&
							<div style={{ height: '100%', width: '100%'}}>
								<iframe key={sectionTwoUrl.url} ref={this.previewPdfModalFrameRef} src={sectionTwoUrl.url} width="100%" height="700px">
								</iframe>
							</div>
						}

						{sectionThreeUrl && this.state.lightBoxDataIndex==9 &&
							<div style={{ height: '100%', width: '100%'}}>
								<iframe key={sectionThreeUrl.url} ref={this.previewPdfModalFrameRef} src={sectionThreeUrl.url} width="100%" height="700px">
								</iframe>
							</div>
						}

    				</ModalBody>
  					<ModalFooter>
  						<Button color="primary" className="ml-1" onClick={this.toggle}>DONE</Button>
							{[7, 8, 9].includes(this.state.lightBoxDataIndex) &&
								<Fragment>
									<span style={{ color: "#737782", marginLeft: "12px", marginRight: "auto" }}>
										If the toolbar is missing on mobile, open the full PDF.
									</span>
									{this.state.isMobileOrTabletPdfAction &&
										<Button color="primary" className="ml-1" onClick={() => this.printIframeInPlace(this.previewPdfModalFrameRef, "Unable to print this preview in place.")}>Print</Button>
									}
									<Button color="primary" className="ml-1" onClick={() => this.openPdfInBrowser(this.getCurrentPreviewPdfUrl(), "Allow pop-ups to open this PDF.")}>Open Full PDF</Button>
								</Fragment>
							}
  					</ModalFooter>
  			  </Modal>
					<Modal isOpen={this.state.modal2} toggle={this.toggle2}>
	  				<ModalHeader toggle={this.toggle2}>Delete Media File</ModalHeader>
	  				<ModalBody>
							<span>Are you sure you want to delete this media file?</span>
	  				</ModalBody>
						<ModalFooter>
							<Button color="primary" onClick={this.deleteFileForRepair}>Delete</Button>
							<Button color="secondary" className="ml-1" onClick={this.toggle2}>Cancel</Button>
						</ModalFooter>
				  </Modal>
					<Modal isOpen={this.state.modal3} toggle={this.toggle3}>
    				<ModalHeader toggle={this.toggle3}>Repair List</ModalHeader>
						<Form onSubmit={this.submitQuoteInvoice}>
    				<ModalBody>
							<PDFViewer style={{ height: "650px", width: "100%"}}>
								{
									//<GenFactoryWarranty serialNumber={this.state.currentDevice} warrantyLength={this.state.device.WarrantyLength} />
								}
								{
									<GenInvoice data={this.state.invoiceArray} invoiceNumber={this.state.invoiceNumber} invoiceTotal={this.state.invoiceTotal} invoiceDate={this.state.invoiceDate} detailedRepair={this.state.detailedRepair} repairLogID={this.props.repairID} serialNumber={this.state.invoiceSerialNumber} />
								}
							</PDFViewer>
    				</ModalBody>
  					<ModalFooter>
  						<Button color="primary" className="ml-1" onClick={this.toggle3}>DONE</Button>
							<Button color="primary" className="ml-1" onClick={this.printRepairList}>Print</Button>
							<Button color="primary" type="submit">Submit Repair List</Button>
  					</ModalFooter>
						</Form>
  			  </Modal>
					<Modal isOpen={this.state.modal12} toggle={this.toggle12}>
    				<ModalHeader toggle={this.toggle12}>Quote</ModalHeader>
						<Form onSubmit={this.submitIntlQuoteInvoice}>
    				<ModalBody>
							<PDFViewer style={{ height: "650px", width: "100%"}}>
								{
									//<GenFactoryWarranty serialNumber={this.state.currentDevice} warrantyLength={this.state.device.WarrantyLength} />
								}
								{
									//<GenIntlQuote dealers={this.state.dealerData} data={this.state.invoiceArray} invoiceNumber={this.state.invoiceNumber} invoiceTotal={this.state.invoiceTotal} invoiceDate={this.state.invoiceDate} detailedIssue={this.state.detailedIssue} repairLog={this.state.repairLog} repairLogID={this.props.repairID} serialNumber={this.state.invoiceSerialNumber} />
								}
								{this.state.market=="aus" ? (
									<GenIntlQuote market={this.state.market} dealers={this.state.dealerData} data={this.state.invoiceArray} invoiceNumber={this.state.invoiceNumber} invoiceTotal={this.state.invoiceTotal} invoiceFormattedUSDTotal={this.state.invoiceFormattedUSDTotal}  invoiceFormattedEuroTotal={this.state.invoiceFormattedEuroTotal} invoiceDate={this.state.invoiceDate} detailedIssue={this.state.detailedIssue} repairLog={this.state.repairLog} repairLogID={this.props.repairID} serialNumber={this.state.invoiceSerialNumber} />
								) : (
									<GenEuropeIntlQuote market={this.state.market} dealers={this.state.dealerData} data={this.state.invoiceArray} invoiceNumber={this.state.invoiceNumber} invoiceTotal={this.state.invoiceTotal} invoiceFormattedUSDTotal={this.state.invoiceFormattedUSDTotal}  invoiceFormattedEuroTotal={this.state.invoiceFormattedEuroTotal} invoiceDate={this.state.invoiceDate} detailedIssue={this.state.detailedIssue} repairLog={this.state.repairLog} repairLogID={this.props.repairID} serialNumber={this.state.invoiceSerialNumber} />
								)}
							</PDFViewer>
    				</ModalBody>
  					<ModalFooter>
  						<Button color="primary" className="ml-1" onClick={this.toggle12}>DONE</Button>
							<Button color="primary" className="ml-1" onClick={this.printQuote}>Print</Button>
							<Button color="primary" type="submit">Submit Quote</Button>
  					</ModalFooter>
						</Form>
  			  </Modal>
					{
						// <Modal isOpen={this.state.modal3} toggle={this.toggle3}>
	    			// 	<ModalHeader toggle={this.toggle3}>Repair List</ModalHeader>
						// 	<Form onSubmit={this.sendInvoice}>
	    			// 	<ModalBody>
						// 		<FormGroup>
						// 			<Label for="subject">Email Repair List to:</Label>
						// 			<Input type="text" name="email" id="email" defaultValue={this.state.currentUser.payload.email}/>
						// 		</FormGroup>
						// 		<PDFViewer style={{ height: "650px", width: "100%"}}>
						// 			{
						// 				//<GenFactoryWarranty serialNumber={this.state.currentDevice} warrantyLength={this.state.device.WarrantyLength} />
						// 			}
						// 			{
						// 				<GenInvoice data={this.state.invoiceArray} invoiceNumber={this.state.invoiceNumber} invoiceTotal={this.state.invoiceTotal} invoiceDate={this.state.invoiceDate} detailedRepair={this.state.detailedRepair} repairLogID={this.props.repairID} serialNumber={this.state.invoiceSerialNumber} />
						// 			}
						// 		</PDFViewer>
	    			// 	</ModalBody>
	  				// 	<ModalFooter>
	  				// 		<Button color="primary" className="ml-1" onClick={this.toggle3}>DONE</Button>
						// 		<Button color="primary" type="submit">Email Repair List</Button>
	  				// 	</ModalFooter>
						// 	</Form>
	  			  // </Modal>
					}
					<Modal isOpen={this.state.modal6} toggle={this.toggle6}>
    				<ModalHeader toggle={this.toggle6}>Customer Repair Report</ModalHeader>
						<Form onSubmit={this.sendReport}>
    				<ModalBody>
							<FormGroup>
								<Label for="subject">Email Customer Repair Report to:</Label>
								<Input type="text" name="email" id="email" defaultValue={this.state.customerEmail}/>
							</FormGroup>
							<div style={{ height: "70vh", minHeight: "420px", width: "100%" }}>
								{this.state.customerReportPreviewLoading ? (
									<Fade in="true">
										<Row className="justify-content-center align-items-center h-100">
											<Loader type="ThreeDots" color="#ffc108" height={120} width={120}/>
										</Row>
									</Fade>
								) : (
									this.state.customerReportPreviewUrl &&
										<iframe
											ref={this.customerReportFrameRef}
											src={this.state.customerReportPreviewUrl}
											title="Customer Repair Report Preview"
											width="100%"
											height="100%"
											style={{ border: 0 }}
										/>
								)}
							</div>
    				</ModalBody>
  					<ModalFooter>
  						<Button color="primary" className="ml-1" onClick={this.toggle6}>Close</Button>
							<span style={{ color: "#737782", marginLeft: "12px", marginRight: "auto" }}>
								If the toolbar is missing on mobile, open the full PDF.
							</span>
							{this.state.isMobileOrTabletPdfAction &&
								<Button color="primary" className="ml-1" onClick={() => this.printIframeInPlace(this.customerReportFrameRef, "Unable to print the customer repair report in place.")}>Print</Button>
							}
							<Button color="primary" className="ml-1" onClick={() => this.openPdfInBrowser(this.state.customerReportPreviewUrl, "Allow pop-ups to open the customer repair report.")}>Open Full PDF</Button>
							<Button color="primary" className="ml-1" onClick={this.saveReport}>Save</Button>
							<Button color="primary" type="submit">Email and Save</Button>
  					</ModalFooter>
						</Form>
  			  </Modal>
					<Modal isOpen={this.state.modal4} toggle={this.toggle4} centered={true} contentClassName="custom-modal-style">
    				<ModalHeader toggle={this.toggle4}>Purchase Order</ModalHeader>
    				<ModalBody>
							<div style={{ height: '100%', width: '100%'}}>
								<iframe src={purchaseOrderURL.url} width="100%" height="700px">
								</iframe>
							</div>
    				</ModalBody>
  					<ModalFooter>
  						<Button color="primary" className="ml-1" onClick={this.toggle4}>OK</Button>
							<Button color="primary" className="ml-1" onClick={this.printPurchaseOrder}>Print</Button>
  					</ModalFooter>
  			  </Modal>
					<Modal isOpen={this.state.modal5} toggle={this.toggle5}>
						<ModalHeader toggle={this.toggle5}>{this.state.statusSubject}</ModalHeader>
						<ModalBody>
							<span>{this.state.statusMessage}</span>
						</ModalBody>
						<ModalFooter>
							<Button color="primary" className="ml-1" onClick={this.toggle5}>OK</Button>
						</ModalFooter>
					</Modal>
					<Modal className="modal-background-color" style={{ maxWidth: "1200px", width: "100%", backgroundColor: "#000"}} isOpen={this.state.modal7} toggle={this.toggle7} centered={true}>
						<ModalBody>
							<RepairLogModalView repairID={this.state.selectedModalRepair} />
						</ModalBody>
						<ModalFooter>
							<Button color="primary" className="ml-1" onClick={this.toggle7}>OK</Button>
						</ModalFooter>
					</Modal>
					<Modal isOpen={this.state.modal8} toggle={this.toggle8}>
	  				<ModalHeader toggle={this.toggle8}>Delete Repair {this.props.repairID}</ModalHeader>
	  				<ModalBody>
							<span>Are you sure you want to delete Repair Log {this.props.repairID}?</span>
	  				</ModalBody>
						<ModalFooter>
							<Button color="primary" onClick={this.deleteRepairLog}>Delete</Button>
							<Button color="secondary" className="ml-1" onClick={this.toggle8}>Cancel</Button>
						</ModalFooter>
				  </Modal>
					<Modal isOpen={this.state.modal9} toggle={this.toggle9} centered={true} contentClassName="custom-modal-style">
    				<ModalHeader toggle={this.toggle9}>Create Shipping Label</ModalHeader>
						<Form onSubmit={this.reteiveShippingLabel}>
						{!this.state.shippingLabelGenerating && !this.state.shippingLabelGenerated && !this.state.shippingRetreivingRates && !this.state.shippingReceivedRates &&
    				<ModalBody>
							<FormGroup>
								<Label for="subject">Shipping Destination:</Label>
								<Input style={{height: '30px', padding: '3px'}} type="select" name="ShippingDestination" id="ShippingDestination" value={this.state.repairLog.ShippingDestination} onChange={this.onChange}>
									{!this.state.isReturnLabel ? (
										<Fragment>
										<option value="Customer">Customer</option>
										<option value="UPI">UPI</option>
										</Fragment>
									) : (
										<Fragment>
										<option value="Azena">Azena</option>
										</Fragment>
									)}
								</Input>
							</FormGroup>
							<FormGroup>
								<Label for="subject">Box Size:</Label>
								<Input style={{height: '30px', padding: '3px'}} type="select" name="BoxSize" id="BoxSize">
									{
										//<option value="0">Select One</option>
									}
									<option value="1">12x12x9</option>
									<option value="2">13x13x10</option>
									<option value="3">14x14x10</option>
									<option value="4">8x6x6</option>
								</Input>
							</FormGroup>
							<FormGroup>
								<Label for="subject">Box Weight:</Label>
								<Input style={{height: '30px', padding: '3px'}} type="select" name="BoxWeight" id="BoxWeight">
									{
										//<option value="0">Select One</option>
									}
									<option value="1">7 lbs</option>
									<option value="2">13 lbs</option>
									<option value="3">1 lbs</option>
								</Input>
							</FormGroup>
							{this.state.shippingLabelErrorStatus!="" &&
								<div className={'alert alert-danger'}>{this.state.shippingLabelErrorStatus}</div>
							}
    				</ModalBody>
						}
						{this.state.shippingReceivedRates &&
    				<ModalBody>
							{this.state.shippoAvailableRates.map((rate, i) => (
								<Row>
									<Col lg="12">
										<Card className="card-hover" style={{ backgroundColor: "#313642", color: "#fff", cursor:"pointer" }} onClick={() => { this.selectShippingRate(rate.object_id); }}>
												<CardBody>
													<Row className="pb-2">
														<Col className="text-left" lg="6">
															<h4>{rate.servicelevel.name}</h4>
														</Col>
														<Col className="text-right" lg="6">
															{
																<h4><b>US$ {rate.amount}</b></h4>
															}
														</Col>
													</Row>
													<Row className="pb-2">
														<Col className="text-left" lg="6">
															{
																//<span>ETA: {Moment().utc(false).add(rate.estimated_days, 'days').format('ddd, MMM Do YYYY')}</span>
															}
															<span>ETA: {business.addWeekDays(Moment().utc(false), rate.estimated_days).format('ddd, MMM Do YYYY')}</span>
														</Col>
														<Col className="text-right" lg="6">

														</Col>
													</Row>
													<Row>
														<Col className="text-left" lg="12">
															<span>{rate.duration_terms} Additonal information about your <i><u>estimated</u></i> delivery time can vary based on your region.</span>
														</Col>
													</Row>
												</CardBody>
										</Card>
									</Col>
								</Row>
							))}
    				</ModalBody>
						}
						{this.state.shippingRetreivingRates &&
							<ModalBody>
								<Fade in="true">
									<Row className="justify-content-center">
										<Loader type="ThreeDots" color="#ffc108" height={200} width={200}/>
									</Row>
								</Fade>
	    				</ModalBody>
						}
						{this.state.shippingLabelGenerating &&
							<ModalBody>
								<Fade in="true">
									<Row className="justify-content-center">
										<Loader type="ThreeDots" color="#ffc108" height={200} width={200}/>
									</Row>
								</Fade>
	    				</ModalBody>
						}
						{this.state.shippingLabelGenerated &&
							<ModalBody>
								<Fade in="true">
									<div style={{ height: '100%', width: '100%'}}>
										<iframe ref={this.shippingLabelFrameRef} src={this.state.shippingLabelURL} width="100%" height="700px">
										</iframe>
									</div>
								</Fade>
	    				</ModalBody>
						}
  					<ModalFooter>
							{!this.state.shippingLabelGenerated &&
  							<Button color="primary" className="ml-1" onClick={this.toggle9}>Cancel</Button>
							}
							{!this.state.shippingLabelGenerating && !this.state.shippingLabelGenerated && !this.state.shippingRetreivingRates && !this.state.shippingReceivedRates &&
								<Button color="primary" type="submit" disabled={this.state.shippingRetreivingRates}>Next</Button>
							}
						{this.state.shippingLabelGenerated &&
							<Button color="primary" className="ml-1" onClick={this.toggle9}>DONE</Button>
						}
						{this.state.shippingLabelGenerated &&
							<Fragment>
								<span style={{ color: "#737782", marginLeft: "12px", marginRight: "auto" }}>
									If the toolbar is missing on mobile, open the full PDF.
								</span>
								{this.state.isMobileOrTabletPdfAction &&
									<Button color="primary" className="ml-1" onClick={() => this.printIframeInPlace(this.shippingLabelFrameRef, "Unable to print the shipping label in place.")}>Print</Button>
								}
								<Button color="primary" className="ml-1" onClick={() => this.openPdfInBrowser(this.state.shippingLabelURL, "Allow pop-ups to open the shipping label.")}>Open Full PDF</Button>
							</Fragment>
						}
  					</ModalFooter>
						</Form>
  			  </Modal>
					<Modal isOpen={this.state.modal10} toggle={this.toggle10}>
		        <ModalHeader toggle={this.toggle10}>Repair Traveler Order</ModalHeader>
		        <ModalBody>
		          <div style={{ height: "70vh", minHeight: "420px", width: "100%" }}>
								{this.state.repairTravelerPreviewLoading ? (
									<Fade in="true">
										<Row className="justify-content-center align-items-center h-100">
											<Loader type="ThreeDots" color="#ffc108" height={120} width={120}/>
										</Row>
									</Fade>
								) : (
									this.state.repairTravelerPreviewUrl &&
										<iframe
											ref={this.repairTravelerFrameRef}
											src={this.state.repairTravelerPreviewUrl}
											title="Repair Traveler Preview"
											width="100%"
											height="100%"
											style={{ border: 0 }}
										/>
								)}
							</div>
		      </ModalBody>
		      <ModalFooter>
		          <Button color="primary" className="ml-1" onClick={this.toggle10}>DONE</Button>
		          <span style={{ color: "#737782", marginLeft: "12px", marginRight: "auto" }}>
								If the toolbar is missing on mobile, open the full PDF.
							</span>
		          {this.state.isMobileOrTabletPdfAction &&
								<Button color="primary" className="ml-1" onClick={() => this.printIframeInPlace(this.repairTravelerFrameRef, "Unable to print the repair traveler in place.")}>Print</Button>
							}
		          <Button color="primary" className="ml-1" onClick={() => this.openPdfInBrowser(this.state.repairTravelerPreviewUrl, "Allow pop-ups to open the repair traveler.")}>Open Full PDF</Button>
		          {
		            //<Button color="primary" type="submit">Email Customer Repair Report</Button>
		          }
		        </ModalFooter>
		      </Modal>
					<Modal isOpen={this.state.modal11} toggle={this.toggle11} centered={true} contentClassName="custom-modal-style">
    				<ModalHeader toggle={this.toggle11}>Loaner Return Label</ModalHeader>
    				<ModalBody>
							<div style={{ height: '100%', width: '100%'}}>
								<iframe src={loanerReturnLabelURL.url} width="100%" height="700px">
								</iframe>
							</div>
    				</ModalBody>
  					<ModalFooter>
  						<Button color="primary" className="ml-1" onClick={this.toggle11}>OK</Button>
							<Button color="primary" className="ml-1" onClick={this.printLoanerReturnLabel}>Print</Button>
  					</ModalFooter>
  			  </Modal>
					<Modal size="lg" isOpen={this.state.modal13} toggle={this.toggle13} centered={true} contentClassName="custom-modal-style-13">
    				<ModalHeader toggle={this.toggle13}>Repair History</ModalHeader>
    				<ModalBody>
							<ReactTable
	              style={{backgroundColor:'#000', padding:'10px', autocomplete: 'none'}}
	              columns={[
									{
										Header: "Tech Name",
										accessor: "TechFullName",
										style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
										Cell: row => (
												<div style={{ textAlign: "center" }}>{row.value}</div>
											)
									},
	                {
	                  Header: "Type",
	                  accessor: "LogType",
										minWidth: 170,
	                  style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
	                  Cell: row => (
											<Fragment>
											{row.value == 1 &&
												<div style={{ textAlign: "center" }}>CREATED REPAIR</div>
											}
											{row.value == 2 &&
												<div style={{ textAlign: "center" }}>UPDATE REPAIR</div>
											}
											{row.value == 3 &&
												<div style={{ textAlign: "center" }}>REPAIR STATUS CHANGE</div>
											}
											</Fragment>
	                    )
	                },
									{
										Header: "Status",
										accessor: "RepairStatus",
										minWidth: 170,
										style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
										Cell: row => (
												<div style={{ textAlign: "center" }}>{row.value}</div>
											)
									},
	                {
	                  Header: "Tech Role",
	                  accessor: "TechRole",
	                  style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
	                  Cell: row => (
												<Fragment>
												{row.value == 0 &&
													<div style={{ textAlign: "center" }}>General</div>
												}
												{row.value == 1 &&
													<div style={{ textAlign: "center" }}>Tech</div>
												}
												{row.value == 2 &&
													<div style={{ textAlign: "center" }}>Admin</div>
												}
												</Fragment>
	                    )
	                },
	                {
	                  Header: "Tech Market",
	                  accessor: "TechMarket",
	                  style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
	                  Cell: row => (
	                      <div style={{ textAlign: "center" }}>{row.value}</div>
	                    )
	                },
									{
	                  Header: "Timestamp",
	                  accessor: "Timestamp",
										minWidth: 150,
	                  style: {'display': 'flex', 'flexDirection': 'column', 'justifyContent': 'center'},
	                  Cell: row => (
	                      <div style={{ textAlign: "center" }}>{Moment(row.value).format('MM-DD-YYYY h:mmA')}</div>
	                    )
	                },
	              ]}
	              defaultPageSize={15}
	              sortable={false}
	              showPaginationBottom={true}
	              className="-striped -highlight"
	              data={this.state.repairHistoryLogs}
	              getTrGroupProps={(state, rowInfo, column, instance) => {
	                      if (rowInfo !== undefined) {
	                          return {
	                              onClick: (e, handleOriginal) => {
	                                console.log('It was in this row:', rowInfo)
	                                console.log('with ID:', rowInfo.original.categoryID);

	                                //this.goToRepairLog(rowInfo.original.repairId);
	                              },
	                              style: {
	                                  cursor: 'pointer'
	                              }
	                          }
	                      }}
	                  }
	            />
    				</ModalBody>
  					<ModalFooter>
  						<Button color="primary" className="ml-1" onClick={this.toggle13}>Close</Button>
  					</ModalFooter>
  			  </Modal>
						<Modal
							isOpen={this.state.imageEditorOpen}
							toggle={this.resetImageEditor}
						  size="xl"
						  centered
						  style={{ maxWidth: "1200px" }}
						>
					  <ModalHeader toggle={this.resetImageEditor}>
					    Edit Image
					  </ModalHeader>

						<ModalBody
							style={{
								height: "640px",
								overflow: "hidden"
							}}
						>
							{!this.state.croppedImageSrc ? (
						    <div
									style={{
										height: "100%",
										display: "flex",
										flexDirection: "column"
									}}
								>
						      <div
						        style={{
						          position: "relative",
						          width: "100%",
						          height: "520px",
						          background: "#222",
						          overflow: "hidden",
						          border: "1px solid #ccc",
											borderRadius: "4px",
											flex: "0 0 auto"
						        }}
						      >
										<div
											style={{
												width: "100%",
												height: "100%",
												display: "flex",
												alignItems: "center",
												justifyContent: "center",
												padding: "12px"
											}}
										>
											<div
												style={{
													position: "relative",
													display: "inline-block",
													maxWidth: "100%",
													maxHeight: "100%",
													cursor: "crosshair",
													lineHeight: 0,
													touchAction: "none"
												}}
												onMouseDown={this.startFreeformCrop}
												onTouchStart={this.startFreeformCropTouch}
											>
												<img
													ref={this.cropSourceImageRef}
													src={this.state.originalImageSrc}
													alt="Repair upload crop source"
													draggable={false}
													style={{
														display: "block",
														maxWidth: "100%",
														maxHeight: "496px",
														width: "auto",
														height: "auto",
														objectFit: "contain",
														userSelect: "none",
														touchAction: "none"
													}}
												/>
												{this.state.cropSelection && (
													<div
														style={{
															position: "absolute",
															left: `${this.state.cropSelection.x}px`,
															top: `${this.state.cropSelection.y}px`,
															width: `${this.state.cropSelection.width}px`,
															height: `${this.state.cropSelection.height}px`,
															border: "2px solid #ffc72c",
															background: "rgba(255, 199, 44, 0.18)",
															boxShadow: "0 0 0 9999px rgba(0, 0, 0, 0.35)",
															pointerEvents: "none"
														}}
													/>
												)}
											</div>
										</div>
						      </div>
						      <div style={{ marginTop: "15px", paddingLeft: "10px", paddingRight: "10px", color: "#555", fontSize: "14px" }}>
						        Click and drag on the image to draw a free-form crop area.
						      </div>
						    </div>
						  ) : (
								<div
									style={{
								    width: "100%",
											height: "100%",
											display: "flex",
											alignItems: "center",
											justifyContent: "center"
								  }}
								>
									<div
										style={{
											width: "100%",
											height: "520px",
											border: "1px solid #ccc",
											background: "#fff",
											borderRadius: "4px",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											overflow: "hidden",
											padding: "12px"
										}}
									>
										<div
											style={{
												position: "relative",
												display: "inline-block",
												lineHeight: 0,
												maxWidth: "100%",
												maxHeight: "100%"
											}}
										>
											<img
												ref={this.editorImageRef}
												src={this.state.croppedImageSrc}
												alt="Cropped repair upload"
												onLoad={this.initFabric}
												style={{
													display: "block",
													maxWidth: "100%",
													maxHeight: "496px",
													width: "auto",
													height: "auto",
													objectFit: "contain"
												}}
											/>
											<canvas
												id="editorCanvas"
												ref={this.editorCanvasRef}
												style={{
													position: "absolute",
													left: 0,
													top: 0,
													background: "transparent"
												}}
											/>
										</div>
									</div>
								</div>
						  )}
						</ModalBody>

					  <ModalFooter>
					    {!this.state.croppedImageSrc ? (
					      <>
					        <Button color="primary" onClick={this.handleCropNext}>
					          Next
					        </Button>
					        <Button onClick={this.resetImageEditor}>
					          Cancel
					        </Button>
					      </>
						    ) : (
						      <>
						        <div style={{ display: "inline-flex", alignItems: "center", marginRight: "8px" }}>
						          <span style={{ fontSize: "14px", marginRight: "8px" }}>Color</span>
						          <Input
						            type="color"
						            value={this.state.annotationColor}
							            onChange={(e) => this.updateActiveAnnotationColor(e.target.value)}
							            style={{
							              width: "42px",
						              height: "34px",
						              padding: "2px",
						              border: "1px solid #ced4da",
						              cursor: "pointer"
						            }}
						          />
						        </div>
						        {this.state.selectedAnnotationIsText && (
						          <div style={{ display: "inline-flex", alignItems: "center", marginRight: "8px", gap: "6px" }}>
						            <Input
						              type="select"
						              value={this.state.annotationFontSize}
						              onChange={(e) => this.updateActiveTextStyle({ fontSize: Number(e.target.value) })}
						              style={{ width: "78px", height: "34px", padding: "2px" }}
						            >
						              <option value="16">16</option>
						              <option value="20">20</option>
						              <option value="24">24</option>
						              <option value="28">28</option>
						              <option value="32">32</option>
						              <option value="40">40</option>
						            </Input>
						            <Button
						              onClick={() => this.updateActiveTextStyle({ fontWeight: this.state.annotationFontWeight === "bold" ? "normal" : "bold" })}
						              color={this.state.annotationFontWeight === "bold" ? "primary" : "secondary"}
						              style={{ minWidth: "40px", fontWeight: "bold" }}
						            >
						              B
						            </Button>
						            <Button
						              onClick={() => this.updateActiveTextStyle({ fontStyle: this.state.annotationFontStyle === "italic" ? "normal" : "italic" })}
						              color={this.state.annotationFontStyle === "italic" ? "primary" : "secondary"}
						              style={{ minWidth: "40px", fontStyle: "italic" }}
						            >
						              I
						            </Button>
						            <Button
						              onClick={() => this.updateActiveTextStyle({ underline: !this.state.annotationUnderline })}
						              color={this.state.annotationUnderline ? "primary" : "secondary"}
						              style={{ minWidth: "40px", textDecoration: "underline" }}
						            >
						              U
						            </Button>
						            <Button
						              onClick={() => this.updateActiveTextStyle({ textAlign: "left" })}
						              color={this.state.annotationTextAlign === "left" ? "primary" : "secondary"}
						              style={{ minWidth: "40px" }}
						              title="Left align"
						            >
						              <i className="fa fa-align-left" />
						            </Button>
						            <Button
						              onClick={() => this.updateActiveTextStyle({ textAlign: "center" })}
						              color={this.state.annotationTextAlign === "center" ? "primary" : "secondary"}
						              style={{ minWidth: "40px" }}
						              title="Center align"
						            >
						              <i className="fa fa-align-center" />
						            </Button>
						            <Button
						              onClick={() => this.updateActiveTextStyle({ textAlign: "right" })}
						              color={this.state.annotationTextAlign === "right" ? "primary" : "secondary"}
						              style={{ minWidth: "40px" }}
						              title="Right align"
						            >
						              <i className="fa fa-align-right" />
						            </Button>
						          </div>
						        )}
						        <Button onClick={this.addRectangle}>Rectangle</Button>
						        <Button onClick={this.addCircle}>Circle</Button>
						        <Button onClick={this.addArrow}>Arrow</Button>
						        <Button onClick={this.addText}>Text</Button>
						        <Button color="primary" onClick={this.saveEditedImage}>
					          Save
					        </Button>
					      </>
					    )}
					  </ModalFooter>
					</Modal>
					<ToastContainer/>
					</div>
					</Fragment>
				)}
			</Fragment>
		);
	}
}

export default RepairLogView;
